/*

Envy by WeTheme (http://www.wetheme.com)
Plugins

1. Wrapper for ConsoleLog
2. Zoom 1.7.13
3. Bootstrap 3.3.1
4. HoverIntent
5. FlexSlider 2.6.3
6. jQuery MouseWheel 3.0.6
7. FancyBox 2.1.5
9. jQuery Cookie 1.4.1
10. Instafeed 1.4.1
11. Sidr 2.2.1
12. Select or Die 0.1.8
13. Social Icon Buttons 1.0
14. MatchHeight 0.7.0
15. Menu
16. Currencies
17. Wow 1.1.2
18. Bootstrap Hover Dropdown

*/

// usage: log('inside coolFunc', this, arguments);
// paulirish.com/2009/log-a-lightweight-wrapper-for-consolelog/
window.log = function f() {
    log.history = log.history || [];
    log.history.push(arguments);
    if (this.console) {
        var args = arguments,
            newarr;
        args.callee = args.callee.caller;
        newarr = [].slice.call(args);
        if (typeof console.log === "object") log.apply.call(console.log, console, newarr);
        else console.log.apply(console, newarr);
    }
};

// make it safe to use console.log always
(function (a) {
    function b() {}
    for (var c = "assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profileEnd,time,timeEnd,trace,warn".split(","), d; !!(d = c.pop()); ) {
        a[d] = a[d] || b;
    }
})(
    (function () {
        try {
            console.log();
            return window.console;
        } catch (a) {
            return (window.console = {});
        }
    })()
);

// place any jQuery/helper plugins in here, instead of separate, slower script files.

/*!
	Zoom v1.7.13 - 2014-04-29
	Enlarge images on click or mouseover.
	(c) 2014 Jack Moore - http://www.jacklmoore.com/zoom
	license: http://www.opensource.org/licenses/mit-license.php
*/
(function (o) {
    var t = { url: !1, callback: !1, target: !1, duration: 120, on: "mouseover", touch: !0, onZoomIn: !1, onZoomOut: !1, magnify: 1 };
    (o.zoom = function (t, n, e, i) {
        var u,
            c,
            a,
            m,
            l,
            r,
            s,
            f = o(t).css("position"),
            h = o(n);
        return (
            (t.style.position = /(absolute|fixed)/.test(f) ? f : "relative"),
            (t.style.overflow = "hidden"),
            (e.style.width = e.style.height = ""),
            o(e)
                .addClass("zoomImg")
                .css({ position: "absolute", top: 0, left: 0, opacity: 0, width: e.width * i, height: e.height * i, border: "none", maxWidth: "none", maxHeight: "none" })
                .appendTo(t),
            {
                init: function () {
                    (c = o(t).outerWidth()), (u = o(t).outerHeight()), n === t ? ((m = c), (a = u)) : ((m = h.outerWidth()), (a = h.outerHeight())), (l = (e.width - c) / m), (r = (e.height - u) / a), (s = h.offset());
                },
                move: function (o) {
                    var t = o.pageX - s.left,
                        n = o.pageY - s.top;
                    (n = Math.max(Math.min(n, a), 0)), (t = Math.max(Math.min(t, m), 0)), (e.style.left = t * -l + "px"), (e.style.top = n * -r + "px");
                },
            }
        );
    }),
        (o.fn.zoom = function (n) {
            return this.each(function () {
                var e,
                    i = o.extend({}, t, n || {}),
                    u = i.target || this,
                    c = this,
                    a = o(c),
                    m = document.createElement("img"),
                    l = o(m),
                    r = "mousemove.zoom",
                    s = !1,
                    f = !1;
                (i.url || ((e = a.find("img")), e[0] && (i.url = e.data("src") || e.attr("src")), i.url)) &&
                    ((function () {
                        var o = u.style.position,
                            t = u.style.overflow;
                        a.one("zoom.destroy", function () {
                            a.off(".zoom"), (u.style.position = o), (u.style.overflow = t), l.remove();
                        });
                    })(),
                    (m.onload = function () {
                        function t(t) {
                            e.init(), e.move(t), l.stop().fadeTo(o.support.opacity ? i.duration : 0, 1, o.isFunction(i.onZoomIn) ? i.onZoomIn.call(m) : !1);
                        }
                        function n() {
                            l.stop().fadeTo(i.duration, 0, o.isFunction(i.onZoomOut) ? i.onZoomOut.call(m) : !1);
                        }
                        var e = o.zoom(u, c, m, i.magnify);
                        "grab" === i.on
                            ? a.on("mousedown.zoom", function (i) {
                                  1 === i.which &&
                                      (o(document).one("mouseup.zoom", function () {
                                          n(), o(document).off(r, e.move);
                                      }),
                                      t(i),
                                      o(document).on(r, e.move),
                                      i.preventDefault());
                              })
                            : "click" === i.on
                            ? a.on("click.zoom", function (i) {
                                  return s
                                      ? void 0
                                      : ((s = !0),
                                        t(i),
                                        o(document).on(r, e.move),
                                        o(document).one("click.zoom", function () {
                                            n(), (s = !1), o(document).off(r, e.move);
                                        }),
                                        !1);
                              })
                            : "toggle" === i.on
                            ? a.on("click.zoom", function (o) {
                                  s ? n() : t(o), (s = !s);
                              })
                            : "mouseover" === i.on && (e.init(), a.on("mouseenter.zoom", t).on("mouseleave.zoom", n).on(r, e.move)),
                            i.touch &&
                                a
                                    .on("touchstart.zoom", function (o) {
                                        o.preventDefault(), f ? ((f = !1), n()) : ((f = !0), t(o.originalEvent.touches[0] || o.originalEvent.changedTouches[0]));
                                    })
                                    .on("touchmove.zoom", function (o) {
                                        o.preventDefault(), e.move(o.originalEvent.touches[0] || o.originalEvent.changedTouches[0]);
                                    }),
                            o.isFunction(i.callback) && i.callback.call(m);
                    }),
                    (m.src = i.url));
            });
        }),
        (o.fn.zoom.defaults = t);
})(window.jQuery);

/*!
 * Bootstrap v3.3.1 (http://getbootstrap.com)
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */
if ("undefined" == typeof jQuery) throw new Error("Bootstrap's JavaScript requires jQuery");
+(function (a) {
    var b = a.fn.jquery.split(" ")[0].split(".");
    if ((b[0] < 2 && b[1] < 9) || (1 == b[0] && 9 == b[1] && b[2] < 1)) throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher");
})(jQuery),
    +(function (a) {
        "use strict";
        function b() {
            var a = document.createElement("bootstrap"),
                b = { WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "oTransitionEnd otransitionend", transition: "transitionend" };
            for (var c in b) if (void 0 !== a.style[c]) return { end: b[c] };
            return !1;
        }
        (a.fn.emulateTransitionEnd = function (b) {
            var c = !1,
                d = this;
            a(this).one("bsTransitionEnd", function () {
                c = !0;
            });
            var e = function () {
                c || a(d).trigger(a.support.transition.end);
            };
            return setTimeout(e, b), this;
        }),
            a(function () {
                (a.support.transition = b()),
                    a.support.transition &&
                        (a.event.special.bsTransitionEnd = {
                            bindType: a.support.transition.end,
                            delegateType: a.support.transition.end,
                            handle: function (b) {
                                return a(b.target).is(this) ? b.handleObj.handler.apply(this, arguments) : void 0;
                            },
                        });
            });
    })(jQuery),
    +(function (a) {
        "use strict";
        function b(b) {
            return this.each(function () {
                var c = a(this),
                    e = c.data("bs.alert");
                e || c.data("bs.alert", (e = new d(this))), "string" == typeof b && e[b].call(c);
            });
        }
        var c = '[data-dismiss="alert"]',
            d = function (b) {
                a(b).on("click", c, this.close);
            };
        (d.VERSION = "3.3.1"),
            (d.TRANSITION_DURATION = 150),
            (d.prototype.close = function (b) {
                function c() {
                    g.detach().trigger("closed.bs.alert").remove();
                }
                var e = a(this),
                    f = e.attr("data-target");
                f || ((f = e.attr("href")), (f = f && f.replace(/.*(?=#[^\s]*$)/, "")));
                var g = a(f);
                b && b.preventDefault(),
                    g.length || (g = e.closest(".alert")),
                    g.trigger((b = a.Event("close.bs.alert"))),
                    b.isDefaultPrevented() || (g.removeClass("in"), a.support.transition && g.hasClass("fade") ? g.one("bsTransitionEnd", c).emulateTransitionEnd(d.TRANSITION_DURATION) : c());
            });
        var e = a.fn.alert;
        (a.fn.alert = b),
            (a.fn.alert.Constructor = d),
            (a.fn.alert.noConflict = function () {
                return (a.fn.alert = e), this;
            }),
            a(document).on("click.bs.alert.data-api", c, d.prototype.close);
    })(jQuery),
    +(function (a) {
        "use strict";
        function b(b) {
            return this.each(function () {
                var d = a(this),
                    e = d.data("bs.button"),
                    f = "object" == typeof b && b;
                e || d.data("bs.button", (e = new c(this, f))), "toggle" == b ? e.toggle() : b && e.setState(b);
            });
        }
        var c = function (b, d) {
            (this.$element = a(b)), (this.options = a.extend({}, c.DEFAULTS, d)), (this.isLoading = !1);
        };
        (c.VERSION = "3.3.1"),
            (c.DEFAULTS = { loadingText: "loading..." }),
            (c.prototype.setState = function (b) {
                var c = "disabled",
                    d = this.$element,
                    e = d.is("input") ? "val" : "html",
                    f = d.data();
                (b += "Text"),
                    null == f.resetText && d.data("resetText", d[e]()),
                    setTimeout(
                        a.proxy(function () {
                            d[e](null == f[b] ? this.options[b] : f[b]), "loadingText" == b ? ((this.isLoading = !0), d.addClass(c).attr(c, c)) : this.isLoading && ((this.isLoading = !1), d.removeClass(c).removeAttr(c));
                        }, this),
                        0
                    );
            }),
            (c.prototype.toggle = function () {
                var a = !0,
                    b = this.$element.closest('[data-toggle="buttons"]');
                if (b.length) {
                    var c = this.$element.find("input");
                    "radio" == c.prop("type") && (c.prop("checked") && this.$element.hasClass("active") ? (a = !1) : b.find(".active").removeClass("active")), a && c.prop("checked", !this.$element.hasClass("active")).trigger("change");
                } else this.$element.attr("aria-pressed", !this.$element.hasClass("active"));
                a && this.$element.toggleClass("active");
            });
        var d = a.fn.button;
        (a.fn.button = b),
            (a.fn.button.Constructor = c),
            (a.fn.button.noConflict = function () {
                return (a.fn.button = d), this;
            }),
            a(document)
                .on("click.bs.button.data-api", '[data-toggle^="button"]', function (c) {
                    var d = a(c.target);
                    d.hasClass("btn") || (d = d.closest(".btn")), b.call(d, "toggle"), c.preventDefault();
                })
                .on("focus.bs.button.data-api blur.bs.button.data-api", '[data-toggle^="button"]', function (b) {
                    a(b.target)
                        .closest(".btn")
                        .toggleClass("focus", /^focus(in)?$/.test(b.type));
                });
    })(jQuery),
    +(function (a) {
        "use strict";
        function b(b) {
            return this.each(function () {
                var d = a(this),
                    e = d.data("bs.carousel"),
                    f = a.extend({}, c.DEFAULTS, d.data(), "object" == typeof b && b),
                    g = "string" == typeof b ? b : f.slide;
                e || d.data("bs.carousel", (e = new c(this, f))), "number" == typeof b ? e.to(b) : g ? e[g]() : f.interval && e.pause().cycle();
            });
        }
        var c = function (b, c) {
            (this.$element = a(b)),
                (this.$indicators = this.$element.find(".carousel-indicators")),
                (this.options = c),
                (this.paused = this.sliding = this.interval = this.$active = this.$items = null),
                this.options.keyboard && this.$element.on("keydown.bs.carousel", a.proxy(this.keydown, this)),
                "hover" == this.options.pause && !("ontouchstart" in document.documentElement) && this.$element.on("mouseenter.bs.carousel", a.proxy(this.pause, this)).on("mouseleave.bs.carousel", a.proxy(this.cycle, this));
        };
        (c.VERSION = "3.3.1"),
            (c.TRANSITION_DURATION = 600),
            (c.DEFAULTS = { interval: 5e3, pause: "hover", wrap: !0, keyboard: !0 }),
            (c.prototype.keydown = function (a) {
                if (!/input|textarea/i.test(a.target.tagName)) {
                    switch (a.which) {
                        case 37:
                            this.prev();
                            break;
                        case 39:
                            this.next();
                            break;
                        default:
                            return;
                    }
                    a.preventDefault();
                }
            }),
            (c.prototype.cycle = function (b) {
                return b || (this.paused = !1), this.interval && clearInterval(this.interval), this.options.interval && !this.paused && (this.interval = setInterval(a.proxy(this.next, this), this.options.interval)), this;
            }),
            (c.prototype.getItemIndex = function (a) {
                return (this.$items = a.parent().children(".item")), this.$items.index(a || this.$active);
            }),
            (c.prototype.getItemForDirection = function (a, b) {
                var c = "prev" == a ? -1 : 1,
                    d = this.getItemIndex(b),
                    e = (d + c) % this.$items.length;
                return this.$items.eq(e);
            }),
            (c.prototype.to = function (a) {
                var b = this,
                    c = this.getItemIndex((this.$active = this.$element.find(".item.active")));
                return a > this.$items.length - 1 || 0 > a
                    ? void 0
                    : this.sliding
                    ? this.$element.one("slid.bs.carousel", function () {
                          b.to(a);
                      })
                    : c == a
                    ? this.pause().cycle()
                    : this.slide(a > c ? "next" : "prev", this.$items.eq(a));
            }),
            (c.prototype.pause = function (b) {
                return b || (this.paused = !0), this.$element.find(".next, .prev").length && a.support.transition && (this.$element.trigger(a.support.transition.end), this.cycle(!0)), (this.interval = clearInterval(this.interval)), this;
            }),
            (c.prototype.next = function () {
                return this.sliding ? void 0 : this.slide("next");
            }),
            (c.prototype.prev = function () {
                return this.sliding ? void 0 : this.slide("prev");
            }),
            (c.prototype.slide = function (b, d) {
                var e = this.$element.find(".item.active"),
                    f = d || this.getItemForDirection(b, e),
                    g = this.interval,
                    h = "next" == b ? "left" : "right",
                    i = "next" == b ? "first" : "last",
                    j = this;
                if (!f.length) {
                    if (!this.options.wrap) return;
                    f = this.$element.find(".item")[i]();
                }
                if (f.hasClass("active")) return (this.sliding = !1);
                var k = f[0],
                    l = a.Event("slide.bs.carousel", { relatedTarget: k, direction: h });
                if ((this.$element.trigger(l), !l.isDefaultPrevented())) {
                    if (((this.sliding = !0), g && this.pause(), this.$indicators.length)) {
                        this.$indicators.find(".active").removeClass("active");
                        var m = a(this.$indicators.children()[this.getItemIndex(f)]);
                        m && m.addClass("active");
                    }
                    var n = a.Event("slid.bs.carousel", { relatedTarget: k, direction: h });
                    return (
                        a.support.transition && this.$element.hasClass("slide")
                            ? (f.addClass(b),
                              f[0].offsetWidth,
                              e.addClass(h),
                              f.addClass(h),
                              e
                                  .one("bsTransitionEnd", function () {
                                      f.removeClass([b, h].join(" ")).addClass("active"),
                                          e.removeClass(["active", h].join(" ")),
                                          (j.sliding = !1),
                                          setTimeout(function () {
                                              j.$element.trigger(n);
                                          }, 0);
                                  })
                                  .emulateTransitionEnd(c.TRANSITION_DURATION))
                            : (e.removeClass("active"), f.addClass("active"), (this.sliding = !1), this.$element.trigger(n)),
                        g && this.cycle(),
                        this
                    );
                }
            });
        var d = a.fn.carousel;
        (a.fn.carousel = b),
            (a.fn.carousel.Constructor = c),
            (a.fn.carousel.noConflict = function () {
                return (a.fn.carousel = d), this;
            });
        var e = function (c) {
            var d,
                e = a(this),
                f = a(e.attr("data-target") || ((d = e.attr("href")) && d.replace(/.*(?=#[^\s]+$)/, "")));
            if (f.hasClass("carousel")) {
                var g = a.extend({}, f.data(), e.data()),
                    h = e.attr("data-slide-to");
                h && (g.interval = !1), b.call(f, g), h && f.data("bs.carousel").to(h), c.preventDefault();
            }
        };
        a(document).on("click.bs.carousel.data-api", "[data-slide]", e).on("click.bs.carousel.data-api", "[data-slide-to]", e),
            a(window).on("load", function () {
                a('[data-ride="carousel"]').each(function () {
                    var c = a(this);
                    b.call(c, c.data());
                });
            });
    })(jQuery),
    +(function (a) {
        "use strict";
        function b(b) {
            var c,
                d = b.attr("data-target") || ((c = b.attr("href")) && c.replace(/.*(?=#[^\s]+$)/, ""));
            return a(d);
        }
        function c(b) {
            return this.each(function () {
                var c = a(this),
                    e = c.data("bs.collapse"),
                    f = a.extend({}, d.DEFAULTS, c.data(), "object" == typeof b && b);
                !e && f.toggle && "show" == b && (f.toggle = !1), e || c.data("bs.collapse", (e = new d(this, f))), "string" == typeof b && e[b]();
            });
        }
        var d = function (b, c) {
            (this.$element = a(b)),
                (this.options = a.extend({}, d.DEFAULTS, c)),
                (this.$trigger = a(this.options.trigger).filter('[href="#' + b.id + '"], [data-target="#' + b.id + '"]')),
                (this.transitioning = null),
                this.options.parent ? (this.$parent = this.getParent()) : this.addAriaAndCollapsedClass(this.$element, this.$trigger),
                this.options.toggle && this.toggle();
        };
        (d.VERSION = "3.3.1"),
            (d.TRANSITION_DURATION = 350),
            (d.DEFAULTS = { toggle: !0, trigger: '[data-toggle="collapse"]' }),
            (d.prototype.dimension = function () {
                var a = this.$element.hasClass("width");
                return a ? "width" : "height";
            }),
            (d.prototype.show = function () {
                if (!this.transitioning && !this.$element.hasClass("in")) {
                    var b,
                        e = this.$parent && this.$parent.find("> .panel").children(".in, .collapsing");
                    if (!(e && e.length && ((b = e.data("bs.collapse")), b && b.transitioning))) {
                        var f = a.Event("show.bs.collapse");
                        if ((this.$element.trigger(f), !f.isDefaultPrevented())) {
                            e && e.length && (c.call(e, "hide"), b || e.data("bs.collapse", null));
                            var g = this.dimension();
                            this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded", !0), this.$trigger.removeClass("collapsed").attr("aria-expanded", !0), (this.transitioning = 1);
                            var h = function () {
                                this.$element.removeClass("collapsing").addClass("collapse in")[g](""), (this.transitioning = 0), this.$element.trigger("shown.bs.collapse");
                            };
                            if (!a.support.transition) return h.call(this);
                            var i = a.camelCase(["scroll", g].join("-"));
                            this.$element.one("bsTransitionEnd", a.proxy(h, this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i]);
                        }
                    }
                }
            }),
            (d.prototype.hide = function () {
                if (!this.transitioning && this.$element.hasClass("in")) {
                    var b = a.Event("hide.bs.collapse");
                    if ((this.$element.trigger(b), !b.isDefaultPrevented())) {
                        var c = this.dimension();
                        this.$element[c](this.$element[c]())[0].offsetHeight,
                            this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded", !1),
                            this.$trigger.addClass("collapsed").attr("aria-expanded", !1),
                            (this.transitioning = 1);
                        var e = function () {
                            (this.transitioning = 0), this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse");
                        };
                        return a.support.transition ? void this.$element[c](0).one("bsTransitionEnd", a.proxy(e, this)).emulateTransitionEnd(d.TRANSITION_DURATION) : e.call(this);
                    }
                }
            }),
            (d.prototype.toggle = function () {
                this[this.$element.hasClass("in") ? "hide" : "show"]();
            }),
            (d.prototype.getParent = function () {
                return a(this.options.parent)
                    .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
                    .each(
                        a.proxy(function (c, d) {
                            var e = a(d);
                            this.addAriaAndCollapsedClass(b(e), e);
                        }, this)
                    )
                    .end();
            }),
            (d.prototype.addAriaAndCollapsedClass = function (a, b) {
                var c = a.hasClass("in");
                a.attr("aria-expanded", c), b.toggleClass("collapsed", !c).attr("aria-expanded", c);
            });
        var e = a.fn.collapse;
        (a.fn.collapse = c),
            (a.fn.collapse.Constructor = d),
            (a.fn.collapse.noConflict = function () {
                return (a.fn.collapse = e), this;
            }),
            a(document).on("click.bs.collapse.data-api", '[data-toggle="collapse"]', function (d) {
                var e = a(this);
                e.attr("data-target") || d.preventDefault();
                var f = b(e),
                    g = f.data("bs.collapse"),
                    h = g ? "toggle" : a.extend({}, e.data(), { trigger: this });
                c.call(f, h);
            });
    })(jQuery),
    +(function (a) {
        "use strict";
        function b(b) {
            (b && 3 === b.which) ||
                (a(e).remove(),
                a(f).each(function () {
                    var d = a(this),
                        e = c(d),
                        f = { relatedTarget: this };
                    e.hasClass("open") && (e.trigger((b = a.Event("hide.bs.dropdown", f))), b.isDefaultPrevented() || (d.attr("aria-expanded", "false"), e.removeClass("open").trigger("hidden.bs.dropdown", f)));
                }));
        }
        function c(b) {
            var c = b.attr("data-target");
            c || ((c = b.attr("href")), (c = c && /#[A-Za-z]/.test(c) && c.replace(/.*(?=#[^\s]*$)/, "")));
            var d = c && a(c);
            return d && d.length ? d : b.parent();
        }
        function d(b) {
            return this.each(function () {
                var c = a(this),
                    d = c.data("bs.dropdown");
                d || c.data("bs.dropdown", (d = new g(this))), "string" == typeof b && d[b].call(c);
            });
        }
        var e = ".dropdown-backdrop",
            f = '[data-toggle="dropdown"]',
            g = function (b) {
                a(b).on("click.bs.dropdown", this.toggle);
            };
        (g.VERSION = "3.3.1"),
            (g.prototype.toggle = function (d) {
                var e = a(this);
                if (!e.is(".disabled, :disabled")) {
                    var f = c(e),
                        g = f.hasClass("open");
                    if ((b(), !g)) {
                        "ontouchstart" in document.documentElement && !f.closest(".navbar-nav").length && a('<div class="dropdown-backdrop"/>').insertAfter(a(this)).on("click", b);
                        var h = { relatedTarget: this };
                        if ((f.trigger((d = a.Event("show.bs.dropdown", h))), d.isDefaultPrevented())) return;
                        e.trigger("focus").attr("aria-expanded", "true"), f.toggleClass("open").trigger("shown.bs.dropdown", h);
                    }
                    return !1;
                }
            }),
            (g.prototype.keydown = function (b) {
                if (/(38|40|27|32)/.test(b.which) && !/input|textarea/i.test(b.target.tagName)) {
                    var d = a(this);
                    if ((b.preventDefault(), b.stopPropagation(), !d.is(".disabled, :disabled"))) {
                        var e = c(d),
                            g = e.hasClass("open");
                        if ((!g && 27 != b.which) || (g && 27 == b.which)) return 27 == b.which && e.find(f).trigger("focus"), d.trigger("click");
                        var h = " li:not(.divider):visible a",
                            i = e.find('[role="menu"]' + h + ', [role="listbox"]' + h);
                        if (i.length) {
                            var j = i.index(b.target);
                            38 == b.which && j > 0 && j--, 40 == b.which && j < i.length - 1 && j++, ~j || (j = 0), i.eq(j).trigger("focus");
                        }
                    }
                }
            });
        var h = a.fn.dropdown;
        (a.fn.dropdown = d),
            (a.fn.dropdown.Constructor = g),
            (a.fn.dropdown.noConflict = function () {
                return (a.fn.dropdown = h), this;
            }),
            a(document)
                .on("click.bs.dropdown.data-api", b)
                .on("click.bs.dropdown.data-api", ".dropdown form", function (a) {
                    a.stopPropagation();
                })
                .on("click.bs.dropdown.data-api", f, g.prototype.toggle)
                .on("keydown.bs.dropdown.data-api", f, g.prototype.keydown)
                .on("keydown.bs.dropdown.data-api", '[role="menu"]', g.prototype.keydown)
                .on("keydown.bs.dropdown.data-api", '[role="listbox"]', g.prototype.keydown);
    })(jQuery),
    +(function (a) {
        "use strict";
        function b(b, d) {
            return this.each(function () {
                var e = a(this),
                    f = e.data("bs.modal"),
                    g = a.extend({}, c.DEFAULTS, e.data(), "object" == typeof b && b);
                f || e.data("bs.modal", (f = new c(this, g))), "string" == typeof b ? f[b](d) : g.show && f.show(d);
            });
        }
        var c = function (b, c) {
            (this.options = c),
                (this.$body = a(document.body)),
                (this.$element = a(b)),
                (this.$backdrop = this.isShown = null),
                (this.scrollbarWidth = 0),
                this.options.remote &&
                    this.$element.find(".modal-content").load(
                        this.options.remote,
                        a.proxy(function () {
                            this.$element.trigger("loaded.bs.modal");
                        }, this)
                    );
        };
        (c.VERSION = "3.3.1"),
            (c.TRANSITION_DURATION = 300),
            (c.BACKDROP_TRANSITION_DURATION = 150),
            (c.DEFAULTS = { backdrop: !0, keyboard: !0, show: !0 }),
            (c.prototype.toggle = function (a) {
                return this.isShown ? this.hide() : this.show(a);
            }),
            (c.prototype.show = function (b) {
                var d = this,
                    e = a.Event("show.bs.modal", { relatedTarget: b });
                this.$element.trigger(e),
                    this.isShown ||
                        e.isDefaultPrevented() ||
                        ((this.isShown = !0),
                        this.checkScrollbar(),
                        this.setScrollbar(),
                        this.$body.addClass("modal-open"),
                        this.escape(),
                        this.resize(),
                        this.$element.on("click.dismiss.bs.modal", '[data-dismiss="modal"]', a.proxy(this.hide, this)),
                        this.backdrop(function () {
                            var e = a.support.transition && d.$element.hasClass("fade");
                            d.$element.parent().length || d.$element.appendTo(d.$body),
                                d.$element.show().scrollTop(0),
                                d.options.backdrop && d.adjustBackdrop(),
                                d.adjustDialog(),
                                e && d.$element[0].offsetWidth,
                                d.$element.addClass("in").attr("aria-hidden", !1),
                                d.enforceFocus();
                            var f = a.Event("shown.bs.modal", { relatedTarget: b });
                            e
                                ? d.$element
                                      .find(".modal-dialog")
                                      .one("bsTransitionEnd", function () {
                                          d.$element.trigger("focus").trigger(f);
                                      })
                                      .emulateTransitionEnd(c.TRANSITION_DURATION)
                                : d.$element.trigger("focus").trigger(f);
                        }));
            }),
            (c.prototype.hide = function (b) {
                b && b.preventDefault(),
                    (b = a.Event("hide.bs.modal")),
                    this.$element.trigger(b),
                    this.isShown &&
                        !b.isDefaultPrevented() &&
                        ((this.isShown = !1),
                        this.escape(),
                        this.resize(),
                        a(document).off("focusin.bs.modal"),
                        this.$element.removeClass("in").attr("aria-hidden", !0).off("click.dismiss.bs.modal"),
                        a.support.transition && this.$element.hasClass("fade") ? this.$element.one("bsTransitionEnd", a.proxy(this.hideModal, this)).emulateTransitionEnd(c.TRANSITION_DURATION) : this.hideModal());
            }),
            (c.prototype.enforceFocus = function () {
                a(document)
                    .off("focusin.bs.modal")
                    .on(
                        "focusin.bs.modal",
                        a.proxy(function (a) {
                            this.$element[0] === a.target || this.$element.has(a.target).length || this.$element.trigger("focus");
                        }, this)
                    );
            }),
            (c.prototype.escape = function () {
                this.isShown && this.options.keyboard
                    ? this.$element.on(
                          "keydown.dismiss.bs.modal",
                          a.proxy(function (a) {
                              27 == a.which && this.hide();
                          }, this)
                      )
                    : this.isShown || this.$element.off("keydown.dismiss.bs.modal");
            }),
            (c.prototype.resize = function () {
                this.isShown ? a(window).on("resize.bs.modal", a.proxy(this.handleUpdate, this)) : a(window).off("resize.bs.modal");
            }),
            (c.prototype.hideModal = function () {
                var a = this;
                this.$element.hide(),
                    this.backdrop(function () {
                        a.$body.removeClass("modal-open"), a.resetAdjustments(), a.resetScrollbar(), a.$element.trigger("hidden.bs.modal");
                    });
            }),
            (c.prototype.removeBackdrop = function () {
                this.$backdrop && this.$backdrop.remove(), (this.$backdrop = null);
            }),
            (c.prototype.backdrop = function (b) {
                var d = this,
                    e = this.$element.hasClass("fade") ? "fade" : "";
                if (this.isShown && this.options.backdrop) {
                    var f = a.support.transition && e;
                    if (
                        ((this.$backdrop = a('<div class="modal-backdrop ' + e + '" />')
                            .prependTo(this.$element)
                            .on(
                                "click.dismiss.bs.modal",
                                a.proxy(function (a) {
                                    a.target === a.currentTarget && ("static" == this.options.backdrop ? this.$element[0].focus.call(this.$element[0]) : this.hide.call(this));
                                }, this)
                            )),
                        f && this.$backdrop[0].offsetWidth,
                        this.$backdrop.addClass("in"),
                        !b)
                    )
                        return;
                    f ? this.$backdrop.one("bsTransitionEnd", b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION) : b();
                } else if (!this.isShown && this.$backdrop) {
                    this.$backdrop.removeClass("in");
                    var g = function () {
                        d.removeBackdrop(), b && b();
                    };
                    a.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one("bsTransitionEnd", g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION) : g();
                } else b && b();
            }),
            (c.prototype.handleUpdate = function () {
                this.options.backdrop && this.adjustBackdrop(), this.adjustDialog();
            }),
            (c.prototype.adjustBackdrop = function () {
                this.$backdrop.css("height", 0).css("height", this.$element[0].scrollHeight);
            }),
            (c.prototype.adjustDialog = function () {
                var a = this.$element[0].scrollHeight > document.documentElement.clientHeight;
                this.$element.css({ paddingLeft: !this.bodyIsOverflowing && a ? this.scrollbarWidth : "", paddingRight: this.bodyIsOverflowing && !a ? this.scrollbarWidth : "" });
            }),
            (c.prototype.resetAdjustments = function () {
                this.$element.css({ paddingLeft: "", paddingRight: "" });
            }),
            (c.prototype.checkScrollbar = function () {
                (this.bodyIsOverflowing = document.body.scrollHeight > document.documentElement.clientHeight), (this.scrollbarWidth = this.measureScrollbar());
            }),
            (c.prototype.setScrollbar = function () {
                var a = parseInt(this.$body.css("padding-right") || 0, 10);
                this.bodyIsOverflowing && this.$body.css("padding-right", a + this.scrollbarWidth);
            }),
            (c.prototype.resetScrollbar = function () {
                this.$body.css("padding-right", "");
            }),
            (c.prototype.measureScrollbar = function () {
                var a = document.createElement("div");
                (a.className = "modal-scrollbar-measure"), this.$body.append(a);
                var b = a.offsetWidth - a.clientWidth;
                return this.$body[0].removeChild(a), b;
            });
        var d = a.fn.modal;
        (a.fn.modal = b),
            (a.fn.modal.Constructor = c),
            (a.fn.modal.noConflict = function () {
                return (a.fn.modal = d), this;
            }),
            a(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function (c) {
                var d = a(this),
                    e = d.attr("href"),
                    f = a(d.attr("data-target") || (e && e.replace(/.*(?=#[^\s]+$)/, ""))),
                    g = f.data("bs.modal") ? "toggle" : a.extend({ remote: !/#/.test(e) && e }, f.data(), d.data());
                d.is("a") && c.preventDefault(),
                    f.one("show.bs.modal", function (a) {
                        a.isDefaultPrevented() ||
                            f.one("hidden.bs.modal", function () {
                                d.is(":visible") && d.trigger("focus");
                            });
                    }),
                    b.call(f, g, this);
            });
    })(jQuery),
    +(function (a) {
        "use strict";
        function b(b) {
            return this.each(function () {
                var d = a(this),
                    e = d.data("bs.tooltip"),
                    f = "object" == typeof b && b,
                    g = f && f.selector;
                (e || "destroy" != b) && (g ? (e || d.data("bs.tooltip", (e = {})), e[g] || (e[g] = new c(this, f))) : e || d.data("bs.tooltip", (e = new c(this, f))), "string" == typeof b && e[b]());
            });
        }
        var c = function (a, b) {
            (this.type = this.options = this.enabled = this.timeout = this.hoverState = this.$element = null), this.init("tooltip", a, b);
        };
        (c.VERSION = "3.3.1"),
            (c.TRANSITION_DURATION = 150),
            (c.DEFAULTS = {
                animation: !0,
                placement: "top",
                selector: !1,
                template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
                trigger: "hover focus",
                title: "",
                delay: 0,
                html: !1,
                container: !1,
                viewport: { selector: "body", padding: 0 },
            }),
            (c.prototype.init = function (b, c, d) {
                (this.enabled = !0), (this.type = b), (this.$element = a(c)), (this.options = this.getOptions(d)), (this.$viewport = this.options.viewport && a(this.options.viewport.selector || this.options.viewport));
                for (var e = this.options.trigger.split(" "), f = e.length; f--; ) {
                    var g = e[f];
                    if ("click" == g) this.$element.on("click." + this.type, this.options.selector, a.proxy(this.toggle, this));
                    else if ("manual" != g) {
                        var h = "hover" == g ? "mouseenter" : "focusin",
                            i = "hover" == g ? "mouseleave" : "focusout";
                        this.$element.on(h + "." + this.type, this.options.selector, a.proxy(this.enter, this)), this.$element.on(i + "." + this.type, this.options.selector, a.proxy(this.leave, this));
                    }
                }
                this.options.selector ? (this._options = a.extend({}, this.options, { trigger: "manual", selector: "" })) : this.fixTitle();
            }),
            (c.prototype.getDefaults = function () {
                return c.DEFAULTS;
            }),
            (c.prototype.getOptions = function (b) {
                return (b = a.extend({}, this.getDefaults(), this.$element.data(), b)), b.delay && "number" == typeof b.delay && (b.delay = { show: b.delay, hide: b.delay }), b;
            }),
            (c.prototype.getDelegateOptions = function () {
                var b = {},
                    c = this.getDefaults();
                return (
                    this._options &&
                        a.each(this._options, function (a, d) {
                            c[a] != d && (b[a] = d);
                        }),
                    b
                );
            }),
            (c.prototype.enter = function (b) {
                var c = b instanceof this.constructor ? b : a(b.currentTarget).data("bs." + this.type);
                return c && c.$tip && c.$tip.is(":visible")
                    ? void (c.hoverState = "in")
                    : (c || ((c = new this.constructor(b.currentTarget, this.getDelegateOptions())), a(b.currentTarget).data("bs." + this.type, c)),
                      clearTimeout(c.timeout),
                      (c.hoverState = "in"),
                      c.options.delay && c.options.delay.show
                          ? void (c.timeout = setTimeout(function () {
                                "in" == c.hoverState && c.show();
                            }, c.options.delay.show))
                          : c.show());
            }),
            (c.prototype.leave = function (b) {
                var c = b instanceof this.constructor ? b : a(b.currentTarget).data("bs." + this.type);
                return (
                    c || ((c = new this.constructor(b.currentTarget, this.getDelegateOptions())), a(b.currentTarget).data("bs." + this.type, c)),
                    clearTimeout(c.timeout),
                    (c.hoverState = "out"),
                    c.options.delay && c.options.delay.hide
                        ? void (c.timeout = setTimeout(function () {
                              "out" == c.hoverState && c.hide();
                          }, c.options.delay.hide))
                        : c.hide()
                );
            }),
            (c.prototype.show = function () {
                var b = a.Event("show.bs." + this.type);
                if (this.hasContent() && this.enabled) {
                    this.$element.trigger(b);
                    var d = a.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
                    if (b.isDefaultPrevented() || !d) return;
                    var e = this,
                        f = this.tip(),
                        g = this.getUID(this.type);
                    this.setContent(), f.attr("id", g), this.$element.attr("aria-describedby", g), this.options.animation && f.addClass("fade");
                    var h = "function" == typeof this.options.placement ? this.options.placement.call(this, f[0], this.$element[0]) : this.options.placement,
                        i = /\s?auto?\s?/i,
                        j = i.test(h);
                    j && (h = h.replace(i, "") || "top"),
                        f
                            .detach()
                            .css({ top: 0, left: 0, display: "block" })
                            .addClass(h)
                            .data("bs." + this.type, this),
                        this.options.container ? f.appendTo(this.options.container) : f.insertAfter(this.$element);
                    var k = this.getPosition(),
                        l = f[0].offsetWidth,
                        m = f[0].offsetHeight;
                    if (j) {
                        var n = h,
                            o = this.options.container ? a(this.options.container) : this.$element.parent(),
                            p = this.getPosition(o);
                        (h = "bottom" == h && k.bottom + m > p.bottom ? "top" : "top" == h && k.top - m < p.top ? "bottom" : "right" == h && k.right + l > p.width ? "left" : "left" == h && k.left - l < p.left ? "right" : h),
                            f.removeClass(n).addClass(h);
                    }
                    var q = this.getCalculatedOffset(h, k, l, m);
                    this.applyPlacement(q, h);
                    var r = function () {
                        var a = e.hoverState;
                        e.$element.trigger("shown.bs." + e.type), (e.hoverState = null), "out" == a && e.leave(e);
                    };
                    a.support.transition && this.$tip.hasClass("fade") ? f.one("bsTransitionEnd", r).emulateTransitionEnd(c.TRANSITION_DURATION) : r();
                }
            }),
            (c.prototype.applyPlacement = function (b, c) {
                var d = this.tip(),
                    e = d[0].offsetWidth,
                    f = d[0].offsetHeight,
                    g = parseInt(d.css("margin-top"), 10),
                    h = parseInt(d.css("margin-left"), 10);
                isNaN(g) && (g = 0),
                    isNaN(h) && (h = 0),
                    (b.top = b.top + g),
                    (b.left = b.left + h),
                    a.offset.setOffset(
                        d[0],
                        a.extend(
                            {
                                using: function (a) {
                                    d.css({ top: Math.round(a.top), left: Math.round(a.left) });
                                },
                            },
                            b
                        ),
                        0
                    ),
                    d.addClass("in");
                var i = d[0].offsetWidth,
                    j = d[0].offsetHeight;
                "top" == c && j != f && (b.top = b.top + f - j);
                var k = this.getViewportAdjustedDelta(c, b, i, j);
                k.left ? (b.left += k.left) : (b.top += k.top);
                var l = /top|bottom/.test(c),
                    m = l ? 2 * k.left - e + i : 2 * k.top - f + j,
                    n = l ? "offsetWidth" : "offsetHeight";
                d.offset(b), this.replaceArrow(m, d[0][n], l);
            }),
            (c.prototype.replaceArrow = function (a, b, c) {
                this.arrow()
                    .css(c ? "left" : "top", 50 * (1 - a / b) + "%")
                    .css(c ? "top" : "left", "");
            }),
            (c.prototype.setContent = function () {
                var a = this.tip(),
                    b = this.getTitle();
                a.find(".tooltip-inner")[this.options.html ? "html" : "text"](b), a.removeClass("fade in top bottom left right");
            }),
            (c.prototype.hide = function (b) {
                function d() {
                    "in" != e.hoverState && f.detach(), e.$element.removeAttr("aria-describedby").trigger("hidden.bs." + e.type), b && b();
                }
                var e = this,
                    f = this.tip(),
                    g = a.Event("hide.bs." + this.type);
                return (
                    this.$element.trigger(g),
                    g.isDefaultPrevented() ? void 0 : (f.removeClass("in"), a.support.transition && this.$tip.hasClass("fade") ? f.one("bsTransitionEnd", d).emulateTransitionEnd(c.TRANSITION_DURATION) : d(), (this.hoverState = null), this)
                );
            }),
            (c.prototype.fixTitle = function () {
                var a = this.$element;
                (a.attr("title") || "string" != typeof a.attr("data-original-title")) && a.attr("data-original-title", a.attr("title") || "").attr("title", "");
            }),
            (c.prototype.hasContent = function () {
                return this.getTitle();
            }),
            (c.prototype.getPosition = function (b) {
                b = b || this.$element;
                var c = b[0],
                    d = "BODY" == c.tagName,
                    e = c.getBoundingClientRect();
                null == e.width && (e = a.extend({}, e, { width: e.right - e.left, height: e.bottom - e.top }));
                var f = d ? { top: 0, left: 0 } : b.offset(),
                    g = { scroll: d ? document.documentElement.scrollTop || document.body.scrollTop : b.scrollTop() },
                    h = d ? { width: a(window).width(), height: a(window).height() } : null;
                return a.extend({}, e, g, h, f);
            }),
            (c.prototype.getCalculatedOffset = function (a, b, c, d) {
                return "bottom" == a
                    ? { top: b.top + b.height, left: b.left + b.width / 2 - c / 2 }
                    : "top" == a
                    ? { top: b.top - d, left: b.left + b.width / 2 - c / 2 }
                    : "left" == a
                    ? { top: b.top + b.height / 2 - d / 2, left: b.left - c }
                    : { top: b.top + b.height / 2 - d / 2, left: b.left + b.width };
            }),
            (c.prototype.getViewportAdjustedDelta = function (a, b, c, d) {
                var e = { top: 0, left: 0 };
                if (!this.$viewport) return e;
                var f = (this.options.viewport && this.options.viewport.padding) || 0,
                    g = this.getPosition(this.$viewport);
                if (/right|left/.test(a)) {
                    var h = b.top - f - g.scroll,
                        i = b.top + f - g.scroll + d;
                    h < g.top ? (e.top = g.top - h) : i > g.top + g.height && (e.top = g.top + g.height - i);
                } else {
                    var j = b.left - f,
                        k = b.left + f + c;
                    j < g.left ? (e.left = g.left - j) : k > g.width && (e.left = g.left + g.width - k);
                }
                return e;
            }),
            (c.prototype.getTitle = function () {
                var a,
                    b = this.$element,
                    c = this.options;
                return (a = b.attr("data-original-title") || ("function" == typeof c.title ? c.title.call(b[0]) : c.title));
            }),
            (c.prototype.getUID = function (a) {
                do a += ~~(1e6 * Math.random());
                while (document.getElementById(a));
                return a;
            }),
            (c.prototype.tip = function () {
                return (this.$tip = this.$tip || a(this.options.template));
            }),
            (c.prototype.arrow = function () {
                return (this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow"));
            }),
            (c.prototype.enable = function () {
                this.enabled = !0;
            }),
            (c.prototype.disable = function () {
                this.enabled = !1;
            }),
            (c.prototype.toggleEnabled = function () {
                this.enabled = !this.enabled;
            }),
            (c.prototype.toggle = function (b) {
                var c = this;
                b && ((c = a(b.currentTarget).data("bs." + this.type)), c || ((c = new this.constructor(b.currentTarget, this.getDelegateOptions())), a(b.currentTarget).data("bs." + this.type, c))),
                    c.tip().hasClass("in") ? c.leave(c) : c.enter(c);
            }),
            (c.prototype.destroy = function () {
                var a = this;
                clearTimeout(this.timeout),
                    this.hide(function () {
                        a.$element.off("." + a.type).removeData("bs." + a.type);
                    });
            });
        var d = a.fn.tooltip;
        (a.fn.tooltip = b),
            (a.fn.tooltip.Constructor = c),
            (a.fn.tooltip.noConflict = function () {
                return (a.fn.tooltip = d), this;
            });
    })(jQuery),
    +(function (a) {
        "use strict";
        function b(b) {
            return this.each(function () {
                var d = a(this),
                    e = d.data("bs.popover"),
                    f = "object" == typeof b && b,
                    g = f && f.selector;
                (e || "destroy" != b) && (g ? (e || d.data("bs.popover", (e = {})), e[g] || (e[g] = new c(this, f))) : e || d.data("bs.popover", (e = new c(this, f))), "string" == typeof b && e[b]());
            });
        }
        var c = function (a, b) {
            this.init("popover", a, b);
        };
        if (!a.fn.tooltip) throw new Error("Popover requires tooltip.js");
        (c.VERSION = "3.3.1"),
            (c.DEFAULTS = a.extend({}, a.fn.tooltip.Constructor.DEFAULTS, {
                placement: "right",
                trigger: "click",
                content: "",
                template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
            })),
            (c.prototype = a.extend({}, a.fn.tooltip.Constructor.prototype)),
            (c.prototype.constructor = c),
            (c.prototype.getDefaults = function () {
                return c.DEFAULTS;
            }),
            (c.prototype.setContent = function () {
                var a = this.tip(),
                    b = this.getTitle(),
                    c = this.getContent();
                a.find(".popover-title")[this.options.html ? "html" : "text"](b),
                    a.find(".popover-content").children().detach().end()[this.options.html ? ("string" == typeof c ? "html" : "append") : "text"](c),
                    a.removeClass("fade top bottom left right in"),
                    a.find(".popover-title").html() || a.find(".popover-title").hide();
            }),
            (c.prototype.hasContent = function () {
                return this.getTitle() || this.getContent();
            }),
            (c.prototype.getContent = function () {
                var a = this.$element,
                    b = this.options;
                return a.attr("data-content") || ("function" == typeof b.content ? b.content.call(a[0]) : b.content);
            }),
            (c.prototype.arrow = function () {
                return (this.$arrow = this.$arrow || this.tip().find(".arrow"));
            }),
            (c.prototype.tip = function () {
                return this.$tip || (this.$tip = a(this.options.template)), this.$tip;
            });
        var d = a.fn.popover;
        (a.fn.popover = b),
            (a.fn.popover.Constructor = c),
            (a.fn.popover.noConflict = function () {
                return (a.fn.popover = d), this;
            });
    })(jQuery),
    +(function (a) {
        "use strict";
        function b(c, d) {
            var e = a.proxy(this.process, this);
            (this.$body = a("body")),
                (this.$scrollElement = a(a(c).is("body") ? window : c)),
                (this.options = a.extend({}, b.DEFAULTS, d)),
                (this.selector = (this.options.target || "") + " .nav li > a"),
                (this.offsets = []),
                (this.targets = []),
                (this.activeTarget = null),
                (this.scrollHeight = 0),
                this.$scrollElement.on("scroll.bs.scrollspy", e),
                this.refresh(),
                this.process();
        }
        function c(c) {
            return this.each(function () {
                var d = a(this),
                    e = d.data("bs.scrollspy"),
                    f = "object" == typeof c && c;
                e || d.data("bs.scrollspy", (e = new b(this, f))), "string" == typeof c && e[c]();
            });
        }
        (b.VERSION = "3.3.1"),
            (b.DEFAULTS = { offset: 10 }),
            (b.prototype.getScrollHeight = function () {
                return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight);
            }),
            (b.prototype.refresh = function () {
                var b = "offset",
                    c = 0;
                a.isWindow(this.$scrollElement[0]) || ((b = "position"), (c = this.$scrollElement.scrollTop())), (this.offsets = []), (this.targets = []), (this.scrollHeight = this.getScrollHeight());
                var d = this;
                this.$body
                    .find(this.selector)
                    .map(function () {
                        var d = a(this),
                            e = d.data("target") || d.attr("href"),
                            f = /^#./.test(e) && a(e);
                        return (f && f.length && f.is(":visible") && [[f[b]().top + c, e]]) || null;
                    })
                    .sort(function (a, b) {
                        return a[0] - b[0];
                    })
                    .each(function () {
                        d.offsets.push(this[0]), d.targets.push(this[1]);
                    });
            }),
            (b.prototype.process = function () {
                var a,
                    b = this.$scrollElement.scrollTop() + this.options.offset,
                    c = this.getScrollHeight(),
                    d = this.options.offset + c - this.$scrollElement.height(),
                    e = this.offsets,
                    f = this.targets,
                    g = this.activeTarget;
                if ((this.scrollHeight != c && this.refresh(), b >= d)) return g != (a = f[f.length - 1]) && this.activate(a);
                if (g && b < e[0]) return (this.activeTarget = null), this.clear();
                for (a = e.length; a--; ) g != f[a] && b >= e[a] && (!e[a + 1] || b <= e[a + 1]) && this.activate(f[a]);
            }),
            (b.prototype.activate = function (b) {
                (this.activeTarget = b), this.clear();
                var c = this.selector + '[data-target="' + b + '"],' + this.selector + '[href="' + b + '"]',
                    d = a(c).parents("li").addClass("active");
                d.parent(".dropdown-menu").length && (d = d.closest("li.dropdown").addClass("active")), d.trigger("activate.bs.scrollspy");
            }),
            (b.prototype.clear = function () {
                a(this.selector).parentsUntil(this.options.target, ".active").removeClass("active");
            });
        var d = a.fn.scrollspy;
        (a.fn.scrollspy = c),
            (a.fn.scrollspy.Constructor = b),
            (a.fn.scrollspy.noConflict = function () {
                return (a.fn.scrollspy = d), this;
            }),
            a(window).on("load.bs.scrollspy.data-api", function () {
                a('[data-spy="scroll"]').each(function () {
                    var b = a(this);
                    c.call(b, b.data());
                });
            });
    })(jQuery),
    +(function (a) {
        "use strict";
        function b(b) {
            return this.each(function () {
                var d = a(this),
                    e = d.data("bs.tab");
                e || d.data("bs.tab", (e = new c(this))), "string" == typeof b && e[b]();
            });
        }
        var c = function (b) {
            this.element = a(b);
        };
        (c.VERSION = "3.3.1"),
            (c.TRANSITION_DURATION = 150),
            (c.prototype.show = function () {
                var b = this.element,
                    c = b.closest("ul:not(.dropdown-menu)"),
                    d = b.data("target");
                if ((d || ((d = b.attr("href")), (d = d && d.replace(/.*(?=#[^\s]*$)/, ""))), !b.parent("li").hasClass("active"))) {
                    var e = c.find(".active:last a"),
                        f = a.Event("hide.bs.tab", { relatedTarget: b[0] }),
                        g = a.Event("show.bs.tab", { relatedTarget: e[0] });
                    if ((e.trigger(f), b.trigger(g), !g.isDefaultPrevented() && !f.isDefaultPrevented())) {
                        var h = a(d);
                        this.activate(b.closest("li"), c),
                            this.activate(h, h.parent(), function () {
                                e.trigger({ type: "hidden.bs.tab", relatedTarget: b[0] }), b.trigger({ type: "shown.bs.tab", relatedTarget: e[0] });
                            });
                    }
                }
            }),
            (c.prototype.activate = function (b, d, e) {
                function f() {
                    g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !1),
                        b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded", !0),
                        h ? (b[0].offsetWidth, b.addClass("in")) : b.removeClass("fade"),
                        b.parent(".dropdown-menu") && b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !0),
                        e && e();
                }
                var g = d.find("> .active"),
                    h = e && a.support.transition && ((g.length && g.hasClass("fade")) || !!d.find("> .fade").length);
                g.length && h ? g.one("bsTransitionEnd", f).emulateTransitionEnd(c.TRANSITION_DURATION) : f(), g.removeClass("in");
            });
        var d = a.fn.tab;
        (a.fn.tab = b),
            (a.fn.tab.Constructor = c),
            (a.fn.tab.noConflict = function () {
                return (a.fn.tab = d), this;
            });
        var e = function (c) {
            c.preventDefault(), b.call(a(this), "show");
        };
        a(document).on("click.bs.tab.data-api", '[data-toggle="tab"]', e).on("click.bs.tab.data-api", '[data-toggle="pill"]', e);
    })(jQuery),
    +(function (a) {
        "use strict";
        function b(b) {
            return this.each(function () {
                var d = a(this),
                    e = d.data("bs.affix"),
                    f = "object" == typeof b && b;
                e || d.data("bs.affix", (e = new c(this, f))), "string" == typeof b && e[b]();
            });
        }
        var c = function (b, d) {
            (this.options = a.extend({}, c.DEFAULTS, d)),
                (this.$target = a(this.options.target).on("scroll.bs.affix.data-api", a.proxy(this.checkPosition, this)).on("click.bs.affix.data-api", a.proxy(this.checkPositionWithEventLoop, this))),
                (this.$element = a(b)),
                (this.affixed = this.unpin = this.pinnedOffset = null),
                this.checkPosition();
        };
        (c.VERSION = "3.3.1"),
            (c.RESET = "affix affix-top affix-bottom"),
            (c.DEFAULTS = { offset: 0, target: window }),
            (c.prototype.getState = function (a, b, c, d) {
                var e = this.$target.scrollTop(),
                    f = this.$element.offset(),
                    g = this.$target.height();
                if (null != c && "top" == this.affixed) return c > e ? "top" : !1;
                if ("bottom" == this.affixed) return null != c ? (e + this.unpin <= f.top ? !1 : "bottom") : a - d >= e + g ? !1 : "bottom";
                var h = null == this.affixed,
                    i = h ? e : f.top,
                    j = h ? g : b;
                return null != c && c >= i ? "top" : null != d && i + j >= a - d ? "bottom" : !1;
            }),
            (c.prototype.getPinnedOffset = function () {
                if (this.pinnedOffset) return this.pinnedOffset;
                this.$element.removeClass(c.RESET).addClass("affix");
                var a = this.$target.scrollTop(),
                    b = this.$element.offset();
                return (this.pinnedOffset = b.top - a);
            }),
            (c.prototype.checkPositionWithEventLoop = function () {
                setTimeout(a.proxy(this.checkPosition, this), 1);
            }),
            (c.prototype.checkPosition = function () {
                if (this.$element.is(":visible")) {
                    var b = this.$element.height(),
                        d = this.options.offset,
                        e = d.top,
                        f = d.bottom,
                        g = a("body").height();
                    "object" != typeof d && (f = e = d), "function" == typeof e && (e = d.top(this.$element)), "function" == typeof f && (f = d.bottom(this.$element));
                    var h = this.getState(g, b, e, f);
                    if (this.affixed != h) {
                        null != this.unpin && this.$element.css("top", "");
                        var i = "affix" + (h ? "-" + h : ""),
                            j = a.Event(i + ".bs.affix");
                        if ((this.$element.trigger(j), j.isDefaultPrevented())) return;
                        (this.affixed = h),
                            (this.unpin = "bottom" == h ? this.getPinnedOffset() : null),
                            this.$element
                                .removeClass(c.RESET)
                                .addClass(i)
                                .trigger(i.replace("affix", "affixed") + ".bs.affix");
                    }
                    "bottom" == h && this.$element.offset({ top: g - b - f });
                }
            });
        var d = a.fn.affix;
        (a.fn.affix = b),
            (a.fn.affix.Constructor = c),
            (a.fn.affix.noConflict = function () {
                return (a.fn.affix = d), this;
            }),
            a(window).on("load", function () {
                a('[data-spy="affix"]').each(function () {
                    var c = a(this),
                        d = c.data();
                    (d.offset = d.offset || {}), null != d.offsetBottom && (d.offset.bottom = d.offsetBottom), null != d.offsetTop && (d.offset.top = d.offsetTop), b.call(c, d);
                });
            });
    })(jQuery);

/*!
 * hoverIntent v1.8.1 // 2014.08.11 // jQuery v1.9.1+
 * http://cherne.net/brian/resources/jquery.hoverIntent.html
 *
 * You may use hoverIntent under the terms of the MIT license. Basically that
 * means you are free to use hoverIntent as long as this header is left intact.
 * Copyright 2007, 2014 Brian Cherne
 */
(function ($) {
    $.fn.hoverIntent = function (handlerIn, handlerOut, selector) {
        var cfg = { interval: 100, sensitivity: 6, timeout: 0 };
        if (typeof handlerIn === "object") {
            cfg = $.extend(cfg, handlerIn);
        } else if ($.isFunction(handlerOut)) {
            cfg = $.extend(cfg, { over: handlerIn, out: handlerOut, selector: selector });
        } else {
            cfg = $.extend(cfg, { over: handlerIn, out: handlerIn, selector: handlerOut });
        }
        var cX, cY, pX, pY;
        var track = function (ev) {
            cX = ev.pageX;
            cY = ev.pageY;
        };
        var compare = function (ev, ob) {
            ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
            if (Math.sqrt((pX - cX) * (pX - cX) + (pY - cY) * (pY - cY)) < cfg.sensitivity) {
                $(ob).off("mousemove.hoverIntent", track);
                ob.hoverIntent_s = true;
                return cfg.over.apply(ob, [ev]);
            } else {
                pX = cX;
                pY = cY;
                ob.hoverIntent_t = setTimeout(function () {
                    compare(ev, ob);
                }, cfg.interval);
            }
        };
        var delay = function (ev, ob) {
            ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
            ob.hoverIntent_s = false;
            return cfg.out.apply(ob, [ev]);
        };
        var handleHover = function (e) {
            var ev = $.extend({}, e);
            var ob = this;
            if (ob.hoverIntent_t) {
                ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
            }
            if (e.type === "mouseenter") {
                pX = ev.pageX;
                pY = ev.pageY;
                $(ob).on("mousemove.hoverIntent", track);
                if (!ob.hoverIntent_s) {
                    ob.hoverIntent_t = setTimeout(function () {
                        compare(ev, ob);
                    }, cfg.interval);
                }
            } else {
                $(ob).off("mousemove.hoverIntent", track);
                if (ob.hoverIntent_s) {
                    ob.hoverIntent_t = setTimeout(function () {
                        delay(ev, ob);
                    }, cfg.timeout);
                }
            }
        };
        return this.on({ "mouseenter.hoverIntent": handleHover, "mouseleave.hoverIntent": handleHover }, cfg.selector);
    };
})(jQuery);

/*
 * jQuery FlexSlider v2.6.3
 * Copyright 2012 WooThemes
 * Contributing Author: Tyler Smith
 */ !(function ($) {
    var e = !0;
    ($.flexslider = function (t, a) {
        var n = $(t);
        n.vars = $.extend({}, $.flexslider.defaults, a);
        var i = n.vars.namespace,
            s = window.navigator && window.navigator.msPointerEnabled && window.MSGesture,
            r = ("ontouchstart" in window || s || (window.DocumentTouch && document instanceof DocumentTouch)) && n.vars.touch,
            o = "click touchend MSPointerUp keyup",
            l = "",
            c,
            d = "vertical" === n.vars.direction,
            u = n.vars.reverse,
            v = n.vars.itemWidth > 0,
            p = "fade" === n.vars.animation,
            m = "" !== n.vars.asNavFor,
            f = {};
        $.data(t, "flexslider", n),
            (f = {
                init: function () {
                    (n.animating = !1),
                        (n.currentSlide = parseInt(n.vars.startAt ? n.vars.startAt : 0, 10)),
                        isNaN(n.currentSlide) && (n.currentSlide = 0),
                        (n.animatingTo = n.currentSlide),
                        (n.atEnd = 0 === n.currentSlide || n.currentSlide === n.last),
                        (n.containerSelector = n.vars.selector.substr(0, n.vars.selector.search(" "))),
                        (n.slides = $(n.vars.selector, n)),
                        (n.container = $(n.containerSelector, n)),
                        (n.count = n.slides.length),
                        (n.syncExists = $(n.vars.sync).length > 0),
                        "slide" === n.vars.animation && (n.vars.animation = "swing"),
                        (n.prop = d ? "top" : "marginLeft"),
                        (n.args = {}),
                        (n.manualPause = !1),
                        (n.stopped = !1),
                        (n.started = !1),
                        (n.startTimeout = null),
                        (n.transitions =
                            !n.vars.video &&
                            !p &&
                            n.vars.useCSS &&
                            (function () {
                                var e = document.createElement("div"),
                                    t = ["perspectiveProperty", "WebkitPerspective", "MozPerspective", "OPerspective", "msPerspective"];
                                for (var a in t) if (void 0 !== e.style[t[a]]) return (n.pfx = t[a].replace("Perspective", "").toLowerCase()), (n.prop = "-" + n.pfx + "-transform"), !0;
                                return !1;
                            })()),
                        (n.ensureAnimationEnd = ""),
                        "" !== n.vars.controlsContainer && (n.controlsContainer = $(n.vars.controlsContainer).length > 0 && $(n.vars.controlsContainer)),
                        "" !== n.vars.manualControls && (n.manualControls = $(n.vars.manualControls).length > 0 && $(n.vars.manualControls)),
                        "" !== n.vars.customDirectionNav && (n.customDirectionNav = 2 === $(n.vars.customDirectionNav).length && $(n.vars.customDirectionNav)),
                        n.vars.randomize &&
                            (n.slides.sort(function () {
                                return Math.round(Math.random()) - 0.5;
                            }),
                            n.container.empty().append(n.slides)),
                        n.doMath(),
                        n.setup("init"),
                        n.vars.controlNav && f.controlNav.setup(),
                        n.vars.directionNav && f.directionNav.setup(),
                        n.vars.keyboard &&
                            (1 === $(n.containerSelector).length || n.vars.multipleKeyboard) &&
                            $(document).bind("keyup", function (e) {
                                var t = e.keyCode;
                                if (!n.animating && (39 === t || 37 === t)) {
                                    var a = 39 === t ? n.getTarget("next") : 37 === t ? n.getTarget("prev") : !1;
                                    n.flexAnimate(a, n.vars.pauseOnAction);
                                }
                            }),
                        n.vars.mousewheel &&
                            n.bind("mousewheel", function (e, t, a, i) {
                                e.preventDefault();
                                var s = 0 > t ? n.getTarget("next") : n.getTarget("prev");
                                n.flexAnimate(s, n.vars.pauseOnAction);
                            }),
                        n.vars.pausePlay && f.pausePlay.setup(),
                        n.vars.slideshow && n.vars.pauseInvisible && f.pauseInvisible.init(),
                        n.vars.slideshow &&
                            (n.vars.pauseOnHover &&
                                n.hover(
                                    function () {
                                        n.manualPlay || n.manualPause || n.pause();
                                    },
                                    function () {
                                        n.manualPause || n.manualPlay || n.stopped || n.play();
                                    }
                                ),
                            (n.vars.pauseInvisible && f.pauseInvisible.isHidden()) || (n.vars.initDelay > 0 ? (n.startTimeout = setTimeout(n.play, n.vars.initDelay)) : n.play())),
                        m && f.asNav.setup(),
                        r && n.vars.touch && f.touch(),
                        (!p || (p && n.vars.smoothHeight)) && $(window).bind("resize orientationchange focus", f.resize),
                        n.find("img").attr("draggable", "false"),
                        setTimeout(function () {
                            n.vars.start(n);
                        }, 200);
                },
                asNav: {
                    setup: function () {
                        (n.asNav = !0),
                            (n.animatingTo = Math.floor(n.currentSlide / n.move)),
                            (n.currentItem = n.currentSlide),
                            n.slides
                                .removeClass(i + "active-slide")
                                .eq(n.currentItem)
                                .addClass(i + "active-slide"),
                            s
                                ? ((t._slider = n),
                                  n.slides.each(function () {
                                      var e = this;
                                      (e._gesture = new MSGesture()),
                                          (e._gesture.target = e),
                                          e.addEventListener(
                                              "MSPointerDown",
                                              function (e) {
                                                  e.preventDefault(), e.currentTarget._gesture && e.currentTarget._gesture.addPointer(e.pointerId);
                                              },
                                              !1
                                          ),
                                          e.addEventListener("MSGestureTap", function (e) {
                                              e.preventDefault();
                                              var t = $(this),
                                                  a = t.index();
                                              $(n.vars.asNavFor).data("flexslider").animating || t.hasClass("active") || ((n.direction = n.currentItem < a ? "next" : "prev"), n.flexAnimate(a, n.vars.pauseOnAction, !1, !0, !0));
                                          });
                                  }))
                                : n.slides.on(o, function (e) {
                                      e.preventDefault();
                                      var t = $(this),
                                          a = t.index(),
                                          s = t.offset().left - $(n).scrollLeft();
                                      0 >= s && t.hasClass(i + "active-slide")
                                          ? n.flexAnimate(n.getTarget("prev"), !0)
                                          : $(n.vars.asNavFor).data("flexslider").animating || t.hasClass(i + "active-slide") || ((n.direction = n.currentItem < a ? "next" : "prev"), n.flexAnimate(a, n.vars.pauseOnAction, !1, !0, !0));
                                  });
                    },
                },
                controlNav: {
                    setup: function () {
                        n.manualControls ? f.controlNav.setupManual() : f.controlNav.setupPaging();
                    },
                    setupPaging: function () {
                        var e = "thumbnails" === n.vars.controlNav ? "control-thumbs" : "control-paging",
                            t = 1,
                            a,
                            s;
                        if (((n.controlNavScaffold = $('<ol class="' + i + "control-nav " + i + e + '"></ol>')), n.pagingCount > 1))
                            for (var r = 0; r < n.pagingCount; r++) {
                                (s = n.slides.eq(r)), void 0 === s.attr("data-thumb-alt") && s.attr("data-thumb-alt", "");
                                var c = "" !== s.attr("data-thumb-alt") ? (c = ' alt="' + s.attr("data-thumb-alt") + '"') : "";
                                if (((a = "thumbnails" === n.vars.controlNav ? '<img src="' + s.attr("data-thumb") + '"' + c + "/>" : '<a href="#">' + t + "</a>"), "thumbnails" === n.vars.controlNav && !0 === n.vars.thumbCaptions)) {
                                    var d = s.attr("data-thumbcaption");
                                    "" !== d && void 0 !== d && (a += '<span class="' + i + 'caption">' + d + "</span>");
                                }
                                n.controlNavScaffold.append("<li>" + a + "</li>"), t++;
                            }
                        n.controlsContainer ? $(n.controlsContainer).append(n.controlNavScaffold) : n.append(n.controlNavScaffold),
                            f.controlNav.set(),
                            f.controlNav.active(),
                            n.controlNavScaffold.delegate("a, img", o, function (e) {
                                if ((e.preventDefault(), "" === l || l === e.type)) {
                                    var t = $(this),
                                        a = n.controlNav.index(t);
                                    t.hasClass(i + "active") || ((n.direction = a > n.currentSlide ? "next" : "prev"), n.flexAnimate(a, n.vars.pauseOnAction));
                                }
                                "" === l && (l = e.type), f.setToClearWatchedEvent();
                            });
                    },
                    setupManual: function () {
                        (n.controlNav = n.manualControls),
                            f.controlNav.active(),
                            n.controlNav.bind(o, function (e) {
                                if ((e.preventDefault(), "" === l || l === e.type)) {
                                    var t = $(this),
                                        a = n.controlNav.index(t);
                                    t.hasClass(i + "active") || (a > n.currentSlide ? (n.direction = "next") : (n.direction = "prev"), n.flexAnimate(a, n.vars.pauseOnAction));
                                }
                                "" === l && (l = e.type), f.setToClearWatchedEvent();
                            });
                    },
                    set: function () {
                        var e = "thumbnails" === n.vars.controlNav ? "img" : "a";
                        n.controlNav = $("." + i + "control-nav li " + e, n.controlsContainer ? n.controlsContainer : n);
                    },
                    active: function () {
                        n.controlNav
                            .removeClass(i + "active")
                            .eq(n.animatingTo)
                            .addClass(i + "active");
                    },
                    update: function (e, t) {
                        n.pagingCount > 1 && "add" === e
                            ? n.controlNavScaffold.append($('<li><a href="#">' + n.count + "</a></li>"))
                            : 1 === n.pagingCount
                            ? n.controlNavScaffold.find("li").remove()
                            : n.controlNav.eq(t).closest("li").remove(),
                            f.controlNav.set(),
                            n.pagingCount > 1 && n.pagingCount !== n.controlNav.length ? n.update(t, e) : f.controlNav.active();
                    },
                },
                directionNav: {
                    setup: function () {
                        var e = $(
                            '<ul class="' +
                                i +
                                'direction-nav"><li class="' +
                                i +
                                'nav-prev"><a class="' +
                                i +
                                'prev" href="#">' +
                                n.vars.prevText +
                                '</a></li><li class="' +
                                i +
                                'nav-next"><a class="' +
                                i +
                                'next" href="#">' +
                                n.vars.nextText +
                                "</a></li></ul>"
                        );
                        n.customDirectionNav
                            ? (n.directionNav = n.customDirectionNav)
                            : n.controlsContainer
                            ? ($(n.controlsContainer).append(e), (n.directionNav = $("." + i + "direction-nav li a", n.controlsContainer)))
                            : (n.append(e), (n.directionNav = $("." + i + "direction-nav li a", n))),
                            f.directionNav.update(),
                            n.directionNav.bind(o, function (e) {
                                e.preventDefault();
                                var t;
                                ("" !== l && l !== e.type) || ((t = $(this).hasClass(i + "next") ? n.getTarget("next") : n.getTarget("prev")), n.flexAnimate(t, n.vars.pauseOnAction)), "" === l && (l = e.type), f.setToClearWatchedEvent();
                            });
                    },
                    update: function () {
                        var e = i + "disabled";
                        1 === n.pagingCount
                            ? n.directionNav.addClass(e).attr("tabindex", "-1")
                            : n.vars.animationLoop
                            ? n.directionNav.removeClass(e).removeAttr("tabindex")
                            : 0 === n.animatingTo
                            ? n.directionNav
                                  .removeClass(e)
                                  .filter("." + i + "prev")
                                  .addClass(e)
                                  .attr("tabindex", "-1")
                            : n.animatingTo === n.last
                            ? n.directionNav
                                  .removeClass(e)
                                  .filter("." + i + "next")
                                  .addClass(e)
                                  .attr("tabindex", "-1")
                            : n.directionNav.removeClass(e).removeAttr("tabindex");
                    },
                },
                pausePlay: {
                    setup: function () {
                        var e = $('<div class="' + i + 'pauseplay"><a href="#"></a></div>');
                        n.controlsContainer ? (n.controlsContainer.append(e), (n.pausePlay = $("." + i + "pauseplay a", n.controlsContainer))) : (n.append(e), (n.pausePlay = $("." + i + "pauseplay a", n))),
                            f.pausePlay.update(n.vars.slideshow ? i + "pause" : i + "play"),
                            n.pausePlay.bind(o, function (e) {
                                e.preventDefault(),
                                    ("" !== l && l !== e.type) || ($(this).hasClass(i + "pause") ? ((n.manualPause = !0), (n.manualPlay = !1), n.pause()) : ((n.manualPause = !1), (n.manualPlay = !0), n.play())),
                                    "" === l && (l = e.type),
                                    f.setToClearWatchedEvent();
                            });
                    },
                    update: function (e) {
                        "play" === e
                            ? n.pausePlay
                                  .removeClass(i + "pause")
                                  .addClass(i + "play")
                                  .html(n.vars.playText)
                            : n.pausePlay
                                  .removeClass(i + "play")
                                  .addClass(i + "pause")
                                  .html(n.vars.pauseText);
                    },
                },
                touch: function () {
                    function e(e) {
                        e.stopPropagation(),
                            n.animating
                                ? e.preventDefault()
                                : (n.pause(),
                                  t._gesture.addPointer(e.pointerId),
                                  (T = 0),
                                  (c = d ? n.h : n.w),
                                  (f = Number(new Date())),
                                  (l =
                                      v && u && n.animatingTo === n.last
                                          ? 0
                                          : v && u
                                          ? n.limit - (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo
                                          : v && n.currentSlide === n.last
                                          ? n.limit
                                          : v
                                          ? (n.itemW + n.vars.itemMargin) * n.move * n.currentSlide
                                          : u
                                          ? (n.last - n.currentSlide + n.cloneOffset) * c
                                          : (n.currentSlide + n.cloneOffset) * c));
                    }
                    function a(e) {
                        e.stopPropagation();
                        var a = e.target._slider;
                        if (a) {
                            var n = -e.translationX,
                                i = -e.translationY;
                            return (
                                (T += d ? i : n),
                                (m = T),
                                (y = d ? Math.abs(T) < Math.abs(-n) : Math.abs(T) < Math.abs(-i)),
                                e.detail === e.MSGESTURE_FLAG_INERTIA
                                    ? void setImmediate(function () {
                                          t._gesture.stop();
                                      })
                                    : void (
                                          (!y || Number(new Date()) - f > 500) &&
                                          (e.preventDefault(),
                                          !p && a.transitions && (a.vars.animationLoop || (m = T / ((0 === a.currentSlide && 0 > T) || (a.currentSlide === a.last && T > 0) ? Math.abs(T) / c + 2 : 1)), a.setProps(l + m, "setTouch")))
                                      )
                            );
                        }
                    }
                    function i(e) {
                        e.stopPropagation();
                        var t = e.target._slider;
                        if (t) {
                            if (t.animatingTo === t.currentSlide && !y && null !== m) {
                                var a = u ? -m : m,
                                    n = a > 0 ? t.getTarget("next") : t.getTarget("prev");
                                t.canAdvance(n) && ((Number(new Date()) - f < 550 && Math.abs(a) > 50) || Math.abs(a) > c / 2) ? t.flexAnimate(n, t.vars.pauseOnAction) : p || t.flexAnimate(t.currentSlide, t.vars.pauseOnAction, !0);
                            }
                            (r = null), (o = null), (m = null), (l = null), (T = 0);
                        }
                    }
                    var r,
                        o,
                        l,
                        c,
                        m,
                        f,
                        g,
                        h,
                        S,
                        y = !1,
                        x = 0,
                        b = 0,
                        T = 0;
                    s
                        ? ((t.style.msTouchAction = "none"),
                          (t._gesture = new MSGesture()),
                          (t._gesture.target = t),
                          t.addEventListener("MSPointerDown", e, !1),
                          (t._slider = n),
                          t.addEventListener("MSGestureChange", a, !1),
                          t.addEventListener("MSGestureEnd", i, !1))
                        : ((g = function (e) {
                              n.animating
                                  ? e.preventDefault()
                                  : (window.navigator.msPointerEnabled || 1 === e.touches.length) &&
                                    (n.pause(),
                                    (c = d ? n.h : n.w),
                                    (f = Number(new Date())),
                                    (x = e.touches[0].pageX),
                                    (b = e.touches[0].pageY),
                                    (l =
                                        v && u && n.animatingTo === n.last
                                            ? 0
                                            : v && u
                                            ? n.limit - (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo
                                            : v && n.currentSlide === n.last
                                            ? n.limit
                                            : v
                                            ? (n.itemW + n.vars.itemMargin) * n.move * n.currentSlide
                                            : u
                                            ? (n.last - n.currentSlide + n.cloneOffset) * c
                                            : (n.currentSlide + n.cloneOffset) * c),
                                    (r = d ? b : x),
                                    (o = d ? x : b),
                                    t.addEventListener("touchmove", h, !1),
                                    t.addEventListener("touchend", S, !1));
                          }),
                          (h = function (e) {
                              (x = e.touches[0].pageX), (b = e.touches[0].pageY), (m = d ? r - b : r - x), (y = d ? Math.abs(m) < Math.abs(x - o) : Math.abs(m) < Math.abs(b - o));
                              var t = 500;
                              (!y || Number(new Date()) - f > t) &&
                                  (e.preventDefault(),
                                  !p && n.transitions && (n.vars.animationLoop || (m /= (0 === n.currentSlide && 0 > m) || (n.currentSlide === n.last && m > 0) ? Math.abs(m) / c + 2 : 1), n.setProps(l + m, "setTouch")));
                          }),
                          (S = function (e) {
                              if ((t.removeEventListener("touchmove", h, !1), n.animatingTo === n.currentSlide && !y && null !== m)) {
                                  var a = u ? -m : m,
                                      i = a > 0 ? n.getTarget("next") : n.getTarget("prev");
                                  n.canAdvance(i) && ((Number(new Date()) - f < 550 && Math.abs(a) > 50) || Math.abs(a) > c / 2) ? n.flexAnimate(i, n.vars.pauseOnAction) : p || n.flexAnimate(n.currentSlide, n.vars.pauseOnAction, !0);
                              }
                              t.removeEventListener("touchend", S, !1), (r = null), (o = null), (m = null), (l = null);
                          }),
                          t.addEventListener("touchstart", g, !1));
                },
                resize: function () {
                    !n.animating &&
                        n.is(":visible") &&
                        (v || n.doMath(),
                        p
                            ? f.smoothHeight()
                            : v
                            ? (n.slides.width(n.computedW), n.update(n.pagingCount), n.setProps())
                            : d
                            ? (n.viewport.height(n.h), n.setProps(n.h, "setTotal"))
                            : (n.vars.smoothHeight && f.smoothHeight(), n.newSlides.width(n.computedW), n.setProps(n.computedW, "setTotal")));
                },
                smoothHeight: function (e) {
                    if (!d || p) {
                        var t = p ? n : n.viewport;
                        e ? t.animate({ height: n.slides.eq(n.animatingTo).innerHeight() }, e) : t.innerHeight(n.slides.eq(n.animatingTo).innerHeight());
                    }
                },
                sync: function (e) {
                    var t = $(n.vars.sync).data("flexslider"),
                        a = n.animatingTo;
                    switch (e) {
                        case "animate":
                            t.flexAnimate(a, n.vars.pauseOnAction, !1, !0);
                            break;
                        case "play":
                            t.playing || t.asNav || t.play();
                            break;
                        case "pause":
                            t.pause();
                    }
                },
                uniqueID: function (e) {
                    return (
                        e
                            .filter("[id]")
                            .add(e.find("[id]"))
                            .each(function () {
                                var e = $(this);
                                e.attr("id", e.attr("id") + "_clone");
                            }),
                        e
                    );
                },
                pauseInvisible: {
                    visProp: null,
                    init: function () {
                        var e = f.pauseInvisible.getHiddenProp();
                        if (e) {
                            var t = e.replace(/[H|h]idden/, "") + "visibilitychange";
                            document.addEventListener(t, function () {
                                f.pauseInvisible.isHidden() ? (n.startTimeout ? clearTimeout(n.startTimeout) : n.pause()) : n.started ? n.play() : n.vars.initDelay > 0 ? setTimeout(n.play, n.vars.initDelay) : n.play();
                            });
                        }
                    },
                    isHidden: function () {
                        var e = f.pauseInvisible.getHiddenProp();
                        return e ? document[e] : !1;
                    },
                    getHiddenProp: function () {
                        var e = ["webkit", "moz", "ms", "o"];
                        if ("hidden" in document) return "hidden";
                        for (var t = 0; t < e.length; t++) if (e[t] + "Hidden" in document) return e[t] + "Hidden";
                        return null;
                    },
                },
                setToClearWatchedEvent: function () {
                    clearTimeout(c),
                        (c = setTimeout(function () {
                            l = "";
                        }, 3e3));
                },
            }),
            (n.flexAnimate = function (e, t, a, s, o) {
                if (
                    (n.vars.animationLoop || e === n.currentSlide || (n.direction = e > n.currentSlide ? "next" : "prev"),
                    m && 1 === n.pagingCount && (n.direction = n.currentItem < e ? "next" : "prev"),
                    !n.animating && (n.canAdvance(e, o) || a) && n.is(":visible"))
                ) {
                    if (m && s) {
                        var l = $(n.vars.asNavFor).data("flexslider");
                        if (
                            ((n.atEnd = 0 === e || e === n.count - 1),
                            l.flexAnimate(e, !0, !1, !0, o),
                            (n.direction = n.currentItem < e ? "next" : "prev"),
                            (l.direction = n.direction),
                            Math.ceil((e + 1) / n.visible) - 1 === n.currentSlide || 0 === e)
                        )
                            return (
                                (n.currentItem = e),
                                n.slides
                                    .removeClass(i + "active-slide")
                                    .eq(e)
                                    .addClass(i + "active-slide"),
                                !1
                            );
                        (n.currentItem = e),
                            n.slides
                                .removeClass(i + "active-slide")
                                .eq(e)
                                .addClass(i + "active-slide"),
                            (e = Math.floor(e / n.visible));
                    }
                    if (
                        ((n.animating = !0),
                        (n.animatingTo = e),
                        t && n.pause(),
                        n.vars.before(n),
                        n.syncExists && !o && f.sync("animate"),
                        n.vars.controlNav && f.controlNav.active(),
                        v ||
                            n.slides
                                .removeClass(i + "active-slide")
                                .eq(e)
                                .addClass(i + "active-slide"),
                        (n.atEnd = 0 === e || e === n.last),
                        n.vars.directionNav && f.directionNav.update(),
                        e === n.last && (n.vars.end(n), n.vars.animationLoop || n.pause()),
                        p)
                    )
                        r
                            ? (n.slides.eq(n.currentSlide).css({ opacity: 0, zIndex: 1 }), n.slides.eq(e).css({ opacity: 1, zIndex: 2 }), n.wrapup(c))
                            : (n.slides.eq(n.currentSlide).css({ zIndex: 1 }).animate({ opacity: 0 }, n.vars.animationSpeed, n.vars.easing),
                              n.slides.eq(e).css({ zIndex: 2 }).animate({ opacity: 1 }, n.vars.animationSpeed, n.vars.easing, n.wrapup));
                    else {
                        var c = d ? n.slides.filter(":first").height() : n.computedW,
                            g,
                            h,
                            S;
                        v
                            ? ((g = n.vars.itemMargin), (S = (n.itemW + g) * n.move * n.animatingTo), (h = S > n.limit && 1 !== n.visible ? n.limit : S))
                            : (h =
                                  0 === n.currentSlide && e === n.count - 1 && n.vars.animationLoop && "next" !== n.direction
                                      ? u
                                          ? (n.count + n.cloneOffset) * c
                                          : 0
                                      : n.currentSlide === n.last && 0 === e && n.vars.animationLoop && "prev" !== n.direction
                                      ? u
                                          ? 0
                                          : (n.count + 1) * c
                                      : u
                                      ? (n.count - 1 - e + n.cloneOffset) * c
                                      : (e + n.cloneOffset) * c),
                            n.setProps(h, "", n.vars.animationSpeed),
                            n.transitions
                                ? ((n.vars.animationLoop && n.atEnd) || ((n.animating = !1), (n.currentSlide = n.animatingTo)),
                                  n.container.unbind("webkitTransitionEnd transitionend"),
                                  n.container.bind("webkitTransitionEnd transitionend", function () {
                                      clearTimeout(n.ensureAnimationEnd), n.wrapup(c);
                                  }),
                                  clearTimeout(n.ensureAnimationEnd),
                                  (n.ensureAnimationEnd = setTimeout(function () {
                                      n.wrapup(c);
                                  }, n.vars.animationSpeed + 100)))
                                : n.container.animate(n.args, n.vars.animationSpeed, n.vars.easing, function () {
                                      n.wrapup(c);
                                  });
                    }
                    n.vars.smoothHeight && f.smoothHeight(n.vars.animationSpeed);
                }
            }),
            (n.wrapup = function (e) {
                p || v || (0 === n.currentSlide && n.animatingTo === n.last && n.vars.animationLoop ? n.setProps(e, "jumpEnd") : n.currentSlide === n.last && 0 === n.animatingTo && n.vars.animationLoop && n.setProps(e, "jumpStart")),
                    (n.animating = !1),
                    (n.currentSlide = n.animatingTo),
                    n.vars.after(n);
            }),
            (n.animateSlides = function () {
                !n.animating && e && n.flexAnimate(n.getTarget("next"));
            }),
            (n.pause = function () {
                clearInterval(n.animatedSlides), (n.animatedSlides = null), (n.playing = !1), n.vars.pausePlay && f.pausePlay.update("play"), n.syncExists && f.sync("pause");
            }),
            (n.play = function () {
                n.playing && clearInterval(n.animatedSlides),
                    (n.animatedSlides = n.animatedSlides || setInterval(n.animateSlides, n.vars.slideshowSpeed)),
                    (n.started = n.playing = !0),
                    n.vars.pausePlay && f.pausePlay.update("pause"),
                    n.syncExists && f.sync("play");
            }),
            (n.stop = function () {
                n.pause(), (n.stopped = !0);
            }),
            (n.canAdvance = function (e, t) {
                var a = m ? n.pagingCount - 1 : n.last;
                return t
                    ? !0
                    : m && n.currentItem === n.count - 1 && 0 === e && "prev" === n.direction
                    ? !0
                    : m && 0 === n.currentItem && e === n.pagingCount - 1 && "next" !== n.direction
                    ? !1
                    : e !== n.currentSlide || m
                    ? n.vars.animationLoop
                        ? !0
                        : n.atEnd && 0 === n.currentSlide && e === a && "next" !== n.direction
                        ? !1
                        : !n.atEnd || n.currentSlide !== a || 0 !== e || "next" !== n.direction
                    : !1;
            }),
            (n.getTarget = function (e) {
                return (n.direction = e), "next" === e ? (n.currentSlide === n.last ? 0 : n.currentSlide + 1) : 0 === n.currentSlide ? n.last : n.currentSlide - 1;
            }),
            (n.setProps = function (e, t, a) {
                var i = (function () {
                    var a = e ? e : (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo,
                        i = (function () {
                            if (v) return "setTouch" === t ? e : u && n.animatingTo === n.last ? 0 : u ? n.limit - (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo : n.animatingTo === n.last ? n.limit : a;
                            switch (t) {
                                case "setTotal":
                                    return u ? (n.count - 1 - n.currentSlide + n.cloneOffset) * e : (n.currentSlide + n.cloneOffset) * e;
                                case "setTouch":
                                    return u ? e : e;
                                case "jumpEnd":
                                    return u ? e : n.count * e;
                                case "jumpStart":
                                    return u ? n.count * e : e;
                                default:
                                    return e;
                            }
                        })();
                    return -1 * i + "px";
                })();
                n.transitions &&
                    ((i = d ? "translate3d(0," + i + ",0)" : "translate3d(" + i + ",0,0)"), (a = void 0 !== a ? a / 1e3 + "s" : "0s"), n.container.css("-" + n.pfx + "-transition-duration", a), n.container.css("transition-duration", a)),
                    (n.args[n.prop] = i),
                    (n.transitions || void 0 === a) && n.container.css(n.args),
                    n.container.css("transform", i);
            }),
            (n.setup = function (e) {
                if (p)
                    n.slides.css({ width: "100%", float: "left", marginRight: "-100%", position: "relative" }),
                        "init" === e &&
                            (r
                                ? n.slides
                                      .css({ opacity: 0, display: "block", webkitTransition: "opacity " + n.vars.animationSpeed / 1e3 + "s ease", zIndex: 1 })
                                      .eq(n.currentSlide)
                                      .css({ opacity: 1, zIndex: 2 })
                                : 0 == n.vars.fadeFirstSlide
                                ? n.slides.css({ opacity: 0, display: "block", zIndex: 1 }).eq(n.currentSlide).css({ zIndex: 2 }).css({ opacity: 1 })
                                : n.slides.css({ opacity: 0, display: "block", zIndex: 1 }).eq(n.currentSlide).css({ zIndex: 2 }).animate({ opacity: 1 }, n.vars.animationSpeed, n.vars.easing)),
                        n.vars.smoothHeight && f.smoothHeight();
                else {
                    var t, a;
                    "init" === e &&
                        ((n.viewport = $('<div class="' + i + 'viewport"></div>')
                            .css({ overflow: "hidden", position: "relative" })
                            .appendTo(n)
                            .append(n.container)),
                        (n.cloneCount = 0),
                        (n.cloneOffset = 0),
                        u && ((a = $.makeArray(n.slides).reverse()), (n.slides = $(a)), n.container.empty().append(n.slides))),
                        n.vars.animationLoop &&
                            !v &&
                            ((n.cloneCount = 2),
                            (n.cloneOffset = 1),
                            "init" !== e && n.container.find(".clone").remove(),
                            n.container.append(f.uniqueID(n.slides.first().clone().addClass("clone")).attr("aria-hidden", "true")).prepend(f.uniqueID(n.slides.last().clone().addClass("clone")).attr("aria-hidden", "true"))),
                        (n.newSlides = $(n.vars.selector, n)),
                        (t = u ? n.count - 1 - n.currentSlide + n.cloneOffset : n.currentSlide + n.cloneOffset),
                        d && !v
                            ? (n.container
                                  .height(200 * (n.count + n.cloneCount) + "%")
                                  .css("position", "absolute")
                                  .width("100%"),
                              setTimeout(
                                  function () {
                                      n.newSlides.css({ display: "block" }), n.doMath(), n.viewport.height(n.h), n.setProps(t * n.h, "init");
                                  },
                                  "init" === e ? 100 : 0
                              ))
                            : (n.container.width(200 * (n.count + n.cloneCount) + "%"),
                              n.setProps(t * n.computedW, "init"),
                              setTimeout(
                                  function () {
                                      n.doMath(), n.newSlides.css({ width: n.computedW, marginRight: n.computedM, float: "left", display: "block" }), n.vars.smoothHeight && f.smoothHeight();
                                  },
                                  "init" === e ? 100 : 0
                              ));
                }
                v ||
                    n.slides
                        .removeClass(i + "active-slide")
                        .eq(n.currentSlide)
                        .addClass(i + "active-slide"),
                    n.vars.init(n);
            }),
            (n.doMath = function () {
                var e = n.slides.first(),
                    t = n.vars.itemMargin,
                    a = n.vars.minItems,
                    i = n.vars.maxItems;
                (n.w = void 0 === n.viewport ? n.width() : n.viewport.width()),
                    (n.h = e.height()),
                    (n.boxPadding = e.outerWidth() - e.width()),
                    v
                        ? ((n.itemT = n.vars.itemWidth + t),
                          (n.itemM = t),
                          (n.minW = a ? a * n.itemT : n.w),
                          (n.maxW = i ? i * n.itemT - t : n.w),
                          (n.itemW = n.minW > n.w ? (n.w - t * (a - 1)) / a : n.maxW < n.w ? (n.w - t * (i - 1)) / i : n.vars.itemWidth > n.w ? n.w : n.vars.itemWidth),
                          (n.visible = Math.floor(n.w / n.itemW)),
                          (n.move = n.vars.move > 0 && n.vars.move < n.visible ? n.vars.move : n.visible),
                          (n.pagingCount = Math.ceil((n.count - n.visible) / n.move + 1)),
                          (n.last = n.pagingCount - 1),
                          (n.limit = 1 === n.pagingCount ? 0 : n.vars.itemWidth > n.w ? n.itemW * (n.count - 1) + t * (n.count - 1) : (n.itemW + t) * n.count - n.w - t))
                        : ((n.itemW = n.w), (n.itemM = t), (n.pagingCount = n.count), (n.last = n.count - 1)),
                    (n.computedW = n.itemW - n.boxPadding),
                    (n.computedM = n.itemM);
            }),
            (n.update = function (e, t) {
                n.doMath(),
                    v || (e < n.currentSlide ? (n.currentSlide += 1) : e <= n.currentSlide && 0 !== e && (n.currentSlide -= 1), (n.animatingTo = n.currentSlide)),
                    n.vars.controlNav &&
                        !n.manualControls &&
                        (("add" === t && !v) || n.pagingCount > n.controlNav.length
                            ? f.controlNav.update("add")
                            : (("remove" === t && !v) || n.pagingCount < n.controlNav.length) && (v && n.currentSlide > n.last && ((n.currentSlide -= 1), (n.animatingTo -= 1)), f.controlNav.update("remove", n.last))),
                    n.vars.directionNav && f.directionNav.update();
            }),
            (n.addSlide = function (e, t) {
                var a = $(e);
                (n.count += 1),
                    (n.last = n.count - 1),
                    d && u ? (void 0 !== t ? n.slides.eq(n.count - t).after(a) : n.container.prepend(a)) : void 0 !== t ? n.slides.eq(t).before(a) : n.container.append(a),
                    n.update(t, "add"),
                    (n.slides = $(n.vars.selector + ":not(.clone)", n)),
                    n.setup(),
                    n.vars.added(n);
            }),
            (n.removeSlide = function (e) {
                var t = isNaN(e) ? n.slides.index($(e)) : e;
                (n.count -= 1),
                    (n.last = n.count - 1),
                    isNaN(e) ? $(e, n.slides).remove() : d && u ? n.slides.eq(n.last).remove() : n.slides.eq(e).remove(),
                    n.doMath(),
                    n.update(t, "remove"),
                    (n.slides = $(n.vars.selector + ":not(.clone)", n)),
                    n.setup(),
                    n.vars.removed(n);
            }),
            f.init();
    }),
        $(window)
            .blur(function (t) {
                e = !1;
            })
            .focus(function (t) {
                e = !0;
            }),
        ($.flexslider.defaults = {
            namespace: "flex-",
            selector: ".slides > li",
            animation: "fade",
            easing: "swing",
            direction: "horizontal",
            reverse: !1,
            animationLoop: !0,
            smoothHeight: !1,
            startAt: 0,
            slideshow: !0,
            slideshowSpeed: 7e3,
            animationSpeed: 600,
            initDelay: 0,
            randomize: !1,
            fadeFirstSlide: !0,
            thumbCaptions: !1,
            pauseOnAction: !0,
            pauseOnHover: !1,
            pauseInvisible: !0,
            useCSS: !0,
            touch: !0,
            video: !1,
            controlNav: !0,
            directionNav: !0,
            prevText: "Previous",
            nextText: "Next",
            keyboard: !0,
            multipleKeyboard: !1,
            mousewheel: !1,
            pausePlay: !1,
            pauseText: "Pause",
            playText: "Play",
            controlsContainer: "",
            manualControls: "",
            customDirectionNav: "",
            sync: "",
            asNavFor: "",
            itemWidth: 0,
            itemMargin: 0,
            minItems: 1,
            maxItems: 0,
            move: 0,
            allowOneSlide: !0,
            start: function () {},
            before: function () {},
            after: function () {},
            end: function () {},
            added: function () {},
            removed: function () {},
            init: function () {},
        }),
        ($.fn.flexslider = function (e) {
            if ((void 0 === e && (e = {}), "object" == typeof e))
                return this.each(function () {
                    var t = $(this),
                        a = e.selector ? e.selector : ".slides > li",
                        n = t.find(a);
                    (1 === n.length && e.allowOneSlide === !1) || 0 === n.length ? (n.fadeIn(400), e.start && e.start(t)) : void 0 === t.data("flexslider") && new $.flexslider(this, e);
                });
            var t = $(this).data("flexslider");
            switch (e) {
                case "play":
                    t.play();
                    break;
                case "pause":
                    t.pause();
                    break;
                case "stop":
                    t.stop();
                    break;
                case "next":
                    t.flexAnimate(t.getTarget("next"), !0);
                    break;
                case "prev":
                case "previous":
                    t.flexAnimate(t.getTarget("prev"), !0);
                    break;
                default:
                    "number" == typeof e && t.flexAnimate(e, !0);
            }
        });
})(jQuery);

/*! Copyright (c) 2011 Brandon Aaron (http://brandonaaron.net)
 * Licensed under the MIT License (LICENSE.txt).
 *
 * Thanks to: http://adomas.org/javascript-mouse-wheel/ for some pointers.
 * Thanks to: Mathias Bank(http://www.mathias-bank.de) for a scope bug fix.
 * Thanks to: Seamus Leahy for adding deltaX and deltaY
 *
 * Version: 3.0.6
 *
 * Requires: 1.2.2+
 */
(function (d) {
    function e(a) {
        var b = a || window.event,
            c = [].slice.call(arguments, 1),
            f = 0,
            e = 0,
            g = 0,
            a = d.event.fix(b);
        a.type = "mousewheel";
        b.wheelDelta && (f = b.wheelDelta / 120);
        b.detail && (f = -b.detail / 3);
        g = f;
        b.axis !== void 0 && b.axis === b.HORIZONTAL_AXIS && ((g = 0), (e = -1 * f));
        b.wheelDeltaY !== void 0 && (g = b.wheelDeltaY / 120);
        b.wheelDeltaX !== void 0 && (e = (-1 * b.wheelDeltaX) / 120);
        c.unshift(a, f, e, g);
        return (d.event.dispatch || d.event.handle).apply(this, c);
    }
    var c = ["DOMMouseScroll", "mousewheel"];
    if (d.event.fixHooks) for (var h = c.length; h; ) d.event.fixHooks[c[--h]] = d.event.mouseHooks;
    d.event.special.mousewheel = {
        setup: function () {
            if (this.addEventListener) for (var a = c.length; a; ) this.addEventListener(c[--a], e, false);
            else this.onmousewheel = e;
        },
        teardown: function () {
            if (this.removeEventListener) for (var a = c.length; a; ) this.removeEventListener(c[--a], e, false);
            else this.onmousewheel = null;
        },
    };
    d.fn.extend({
        mousewheel: function (a) {
            return a ? this.bind("mousewheel", a) : this.trigger("mousewheel");
        },
        unmousewheel: function (a) {
            return this.unbind("mousewheel", a);
        },
    });
})(jQuery);

/*! fancyBox v2.1.5 fancyapps.com | fancyapps.com/fancybox/#license */
(function (r, G, f, v) {
    var J = f("html"),
        n = f(r),
        p = f(G),
        b = (f.fancybox = function () {
            b.open.apply(this, arguments);
        }),
        I = navigator.userAgent.match(/msie/i),
        B = null,
        s = G.createTouch !== v,
        t = function (a) {
            return a && a.hasOwnProperty && a instanceof f;
        },
        q = function (a) {
            return a && "string" === f.type(a);
        },
        E = function (a) {
            return q(a) && 0 < a.indexOf("%");
        },
        l = function (a, d) {
            var e = parseInt(a, 10) || 0;
            d && E(a) && (e *= b.getViewport()[d] / 100);
            return Math.ceil(e);
        },
        w = function (a, b) {
            return l(a, b) + "px";
        };
    f.extend(b, {
        version: "2.1.5",
        defaults: {
            padding: 15,
            margin: 20,
            width: 800,
            height: 600,
            minWidth: 100,
            minHeight: 100,
            maxWidth: 9999,
            maxHeight: 9999,
            pixelRatio: 1,
            autoSize: !0,
            autoHeight: !1,
            autoWidth: !1,
            autoResize: !0,
            autoCenter: !s,
            fitToView: !0,
            aspectRatio: !1,
            topRatio: 0.5,
            leftRatio: 0.5,
            scrolling: "auto",
            wrapCSS: "",
            arrows: !0,
            closeBtn: !0,
            closeClick: !1,
            nextClick: !1,
            mouseWheel: !0,
            autoPlay: !1,
            playSpeed: 3e3,
            preload: 3,
            modal: !1,
            loop: !0,
            ajax: { dataType: "html", headers: { "X-fancyBox": !0 } },
            iframe: { scrolling: "auto", preload: !0 },
            swf: { wmode: "transparent", allowfullscreen: "true", allowscriptaccess: "always" },
            keys: { next: { 13: "left", 34: "up", 39: "left", 40: "up" }, prev: { 8: "right", 33: "down", 37: "right", 38: "down" }, close: [27], play: [32], toggle: [70] },
            direction: { next: "left", prev: "right" },
            scrollOutside: !0,
            index: 0,
            type: null,
            href: null,
            content: null,
            title: null,
            tpl: {
                wrap: '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
                image: '<img class="fancybox-image" src="{href}" alt="" />',
                iframe:
                    '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen' +
                    (I ? ' allowtransparency="true"' : "") +
                    "></iframe>",
                error: '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
                closeBtn: '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',
                next: '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
                prev: '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>',
            },
            openEffect: "fade",
            openSpeed: 250,
            openEasing: "swing",
            openOpacity: !0,
            openMethod: "zoomIn",
            closeEffect: "fade",
            closeSpeed: 250,
            closeEasing: "swing",
            closeOpacity: !0,
            closeMethod: "zoomOut",
            nextEffect: "elastic",
            nextSpeed: 250,
            nextEasing: "swing",
            nextMethod: "changeIn",
            prevEffect: "elastic",
            prevSpeed: 250,
            prevEasing: "swing",
            prevMethod: "changeOut",
            helpers: { overlay: !0, title: !0 },
            onCancel: f.noop,
            beforeLoad: f.noop,
            afterLoad: f.noop,
            beforeShow: f.noop,
            afterShow: f.noop,
            beforeChange: f.noop,
            beforeClose: f.noop,
            afterClose: f.noop,
        },
        group: {},
        opts: {},
        previous: null,
        coming: null,
        current: null,
        isActive: !1,
        isOpen: !1,
        isOpened: !1,
        wrap: null,
        skin: null,
        outer: null,
        inner: null,
        player: { timer: null, isActive: !1 },
        ajaxLoad: null,
        imgPreload: null,
        transitions: {},
        helpers: {},
        open: function (a, d) {
            if (a && (f.isPlainObject(d) || (d = {}), !1 !== b.close(!0)))
                return (
                    f.isArray(a) || (a = t(a) ? f(a).get() : [a]),
                    f.each(a, function (e, c) {
                        var k = {},
                            g,
                            h,
                            j,
                            m,
                            l;
                        "object" === f.type(c) &&
                            (c.nodeType && (c = f(c)),
                            t(c) ? ((k = { href: c.data("fancybox-href") || c.attr("href"), title: c.data("fancybox-title") || c.attr("title"), isDom: !0, element: c }), f.metadata && f.extend(!0, k, c.metadata())) : (k = c));
                        g = d.href || k.href || (q(c) ? c : null);
                        h = d.title !== v ? d.title : k.title || "";
                        m = (j = d.content || k.content) ? "html" : d.type || k.type;
                        !m && k.isDom && ((m = c.data("fancybox-type")), m || (m = (m = c.prop("class").match(/fancybox\.(\w+)/)) ? m[1] : null));
                        q(g) &&
                            (m || (b.isImage(g) ? (m = "image") : b.isSWF(g) ? (m = "swf") : "#" === g.charAt(0) ? (m = "inline") : q(c) && ((m = "html"), (j = c))),
                            "ajax" === m && ((l = g.split(/\s+/, 2)), (g = l.shift()), (l = l.shift())));
                        j || ("inline" === m ? (g ? (j = f(q(g) ? g.replace(/.*(?=#[^\s]+$)/, "") : g)) : k.isDom && (j = c)) : "html" === m ? (j = g) : !m && !g && k.isDom && ((m = "inline"), (j = c)));
                        f.extend(k, { href: g, type: m, content: j, title: h, selector: l });
                        a[e] = k;
                    }),
                    (b.opts = f.extend(!0, {}, b.defaults, d)),
                    d.keys !== v && (b.opts.keys = d.keys ? f.extend({}, b.defaults.keys, d.keys) : !1),
                    (b.group = a),
                    b._start(b.opts.index)
                );
        },
        cancel: function () {
            var a = b.coming;
            a &&
                !1 !== b.trigger("onCancel") &&
                (b.hideLoading(),
                b.ajaxLoad && b.ajaxLoad.abort(),
                (b.ajaxLoad = null),
                b.imgPreload && (b.imgPreload.onload = b.imgPreload.onerror = null),
                a.wrap && a.wrap.stop(!0, !0).trigger("onReset").remove(),
                (b.coming = null),
                b.current || b._afterZoomOut(a));
        },
        close: function (a) {
            b.cancel();
            !1 !== b.trigger("beforeClose") &&
                (b.unbindEvents(),
                b.isActive &&
                    (!b.isOpen || !0 === a
                        ? (f(".fancybox-wrap").stop(!0).trigger("onReset").remove(), b._afterZoomOut())
                        : ((b.isOpen = b.isOpened = !1), (b.isClosing = !0), f(".fancybox-item, .fancybox-nav").remove(), b.wrap.stop(!0, !0).removeClass("fancybox-opened"), b.transitions[b.current.closeMethod]())));
        },
        play: function (a) {
            var d = function () {
                    clearTimeout(b.player.timer);
                },
                e = function () {
                    d();
                    b.current && b.player.isActive && (b.player.timer = setTimeout(b.next, b.current.playSpeed));
                },
                c = function () {
                    d();
                    p.unbind(".player");
                    b.player.isActive = !1;
                    b.trigger("onPlayEnd");
                };
            if (!0 === a || (!b.player.isActive && !1 !== a)) {
                if (b.current && (b.current.loop || b.current.index < b.group.length - 1))
                    (b.player.isActive = !0), p.bind({ "onCancel.player beforeClose.player": c, "onUpdate.player": e, "beforeLoad.player": d }), e(), b.trigger("onPlayStart");
            } else c();
        },
        next: function (a) {
            var d = b.current;
            d && (q(a) || (a = d.direction.next), b.jumpto(d.index + 1, a, "next"));
        },
        prev: function (a) {
            var d = b.current;
            d && (q(a) || (a = d.direction.prev), b.jumpto(d.index - 1, a, "prev"));
        },
        jumpto: function (a, d, e) {
            var c = b.current;
            c &&
                ((a = l(a)),
                (b.direction = d || c.direction[a >= c.index ? "next" : "prev"]),
                (b.router = e || "jumpto"),
                c.loop && (0 > a && (a = c.group.length + (a % c.group.length)), (a %= c.group.length)),
                c.group[a] !== v && (b.cancel(), b._start(a)));
        },
        reposition: function (a, d) {
            var e = b.current,
                c = e ? e.wrap : null,
                k;
            c && ((k = b._getPosition(d)), a && "scroll" === a.type ? (delete k.position, c.stop(!0, !0).animate(k, 200)) : (c.css(k), (e.pos = f.extend({}, e.dim, k))));
        },
        update: function (a) {
            var d = a && a.type,
                e = !d || "orientationchange" === d;
            e && (clearTimeout(B), (B = null));
            b.isOpen &&
                !B &&
                (B = setTimeout(
                    function () {
                        var c = b.current;
                        c &&
                            !b.isClosing &&
                            (b.wrap.removeClass("fancybox-tmp"), (e || "load" === d || ("resize" === d && c.autoResize)) && b._setDimension(), ("scroll" === d && c.canShrink) || b.reposition(a), b.trigger("onUpdate"), (B = null));
                    },
                    e && !s ? 0 : 300
                ));
        },
        toggle: function (a) {
            b.isOpen && ((b.current.fitToView = "boolean" === f.type(a) ? a : !b.current.fitToView), s && (b.wrap.removeAttr("style").addClass("fancybox-tmp"), b.trigger("onUpdate")), b.update());
        },
        hideLoading: function () {
            p.unbind(".loading");
            f("#fancybox-loading").remove();
        },
        showLoading: function () {
            var a, d;
            b.hideLoading();
            a = f('<div id="fancybox-loading"><div></div></div>').click(b.cancel).appendTo("body");
            p.bind("keydown.loading", function (a) {
                if (27 === (a.which || a.keyCode)) a.preventDefault(), b.cancel();
            });
            b.defaults.fixed || ((d = b.getViewport()), a.css({ position: "absolute", top: 0.5 * d.h + d.y, left: 0.5 * d.w + d.x }));
        },
        getViewport: function () {
            var a = (b.current && b.current.locked) || !1,
                d = { x: n.scrollLeft(), y: n.scrollTop() };
            a ? ((d.w = a[0].clientWidth), (d.h = a[0].clientHeight)) : ((d.w = s && r.innerWidth ? r.innerWidth : n.width()), (d.h = s && r.innerHeight ? r.innerHeight : n.height()));
            return d;
        },
        unbindEvents: function () {
            b.wrap && t(b.wrap) && b.wrap.unbind(".fb");
            p.unbind(".fb");
            n.unbind(".fb");
        },
        bindEvents: function () {
            var a = b.current,
                d;
            a &&
                (n.bind("orientationchange.fb" + (s ? "" : " resize.fb") + (a.autoCenter && !a.locked ? " scroll.fb" : ""), b.update),
                (d = a.keys) &&
                    p.bind("keydown.fb", function (e) {
                        var c = e.which || e.keyCode,
                            k = e.target || e.srcElement;
                        if (27 === c && b.coming) return !1;
                        !e.ctrlKey &&
                            !e.altKey &&
                            !e.shiftKey &&
                            !e.metaKey &&
                            (!k || (!k.type && !f(k).is("[contenteditable]"))) &&
                            f.each(d, function (d, k) {
                                if (1 < a.group.length && k[c] !== v) return b[d](k[c]), e.preventDefault(), !1;
                                if (-1 < f.inArray(c, k)) return b[d](), e.preventDefault(), !1;
                            });
                    }),
                f.fn.mousewheel &&
                    a.mouseWheel &&
                    b.wrap.bind("mousewheel.fb", function (d, c, k, g) {
                        for (var h = f(d.target || null), j = !1; h.length && !j && !h.is(".fancybox-skin") && !h.is(".fancybox-wrap"); )
                            (j = h[0] && !(h[0].style.overflow && "hidden" === h[0].style.overflow) && ((h[0].clientWidth && h[0].scrollWidth > h[0].clientWidth) || (h[0].clientHeight && h[0].scrollHeight > h[0].clientHeight))),
                                (h = f(h).parent());
                        if (0 !== c && !j && 1 < b.group.length && !a.canShrink) {
                            if (0 < g || 0 < k) b.prev(0 < g ? "down" : "left");
                            else if (0 > g || 0 > k) b.next(0 > g ? "up" : "right");
                            d.preventDefault();
                        }
                    }));
        },
        trigger: function (a, d) {
            var e,
                c = d || b.coming || b.current;
            if (c) {
                f.isFunction(c[a]) && (e = c[a].apply(c, Array.prototype.slice.call(arguments, 1)));
                if (!1 === e) return !1;
                c.helpers &&
                    f.each(c.helpers, function (d, e) {
                        if (e && b.helpers[d] && f.isFunction(b.helpers[d][a])) b.helpers[d][a](f.extend(!0, {}, b.helpers[d].defaults, e), c);
                    });
                p.trigger(a);
            }
        },
        isImage: function (a) {
            return q(a) && a.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i);
        },
        isSWF: function (a) {
            return q(a) && a.match(/\.(swf)((\?|#).*)?$/i);
        },
        _start: function (a) {
            var d = {},
                e,
                c;
            a = l(a);
            e = b.group[a] || null;
            if (!e) return !1;
            d = f.extend(!0, {}, b.opts, e);
            e = d.margin;
            c = d.padding;
            "number" === f.type(e) && (d.margin = [e, e, e, e]);
            "number" === f.type(c) && (d.padding = [c, c, c, c]);
            d.modal && f.extend(!0, d, { closeBtn: !1, closeClick: !1, nextClick: !1, arrows: !1, mouseWheel: !1, keys: null, helpers: { overlay: { closeClick: !1 } } });
            d.autoSize && (d.autoWidth = d.autoHeight = !0);
            "auto" === d.width && (d.autoWidth = !0);
            "auto" === d.height && (d.autoHeight = !0);
            d.group = b.group;
            d.index = a;
            b.coming = d;
            if (!1 === b.trigger("beforeLoad")) b.coming = null;
            else {
                c = d.type;
                e = d.href;
                if (!c) return (b.coming = null), b.current && b.router && "jumpto" !== b.router ? ((b.current.index = a), b[b.router](b.direction)) : !1;
                b.isActive = !0;
                if ("image" === c || "swf" === c) (d.autoHeight = d.autoWidth = !1), (d.scrolling = "visible");
                "image" === c && (d.aspectRatio = !0);
                "iframe" === c && s && (d.scrolling = "scroll");
                d.wrap = f(d.tpl.wrap)
                    .addClass("fancybox-" + (s ? "mobile" : "desktop") + " fancybox-type-" + c + " fancybox-tmp " + d.wrapCSS)
                    .appendTo(d.parent || "body");
                f.extend(d, { skin: f(".fancybox-skin", d.wrap), outer: f(".fancybox-outer", d.wrap), inner: f(".fancybox-inner", d.wrap) });
                f.each(["Top", "Right", "Bottom", "Left"], function (a, b) {
                    d.skin.css("padding" + b, w(d.padding[a]));
                });
                b.trigger("onReady");
                if ("inline" === c || "html" === c) {
                    if (!d.content || !d.content.length) return b._error("content");
                } else if (!e) return b._error("href");
                "image" === c ? b._loadImage() : "ajax" === c ? b._loadAjax() : "iframe" === c ? b._loadIframe() : b._afterLoad();
            }
        },
        _error: function (a) {
            f.extend(b.coming, { type: "html", autoWidth: !0, autoHeight: !0, minWidth: 0, minHeight: 0, scrolling: "no", hasError: a, content: b.coming.tpl.error });
            b._afterLoad();
        },
        _loadImage: function () {
            var a = (b.imgPreload = new Image());
            a.onload = function () {
                this.onload = this.onerror = null;
                b.coming.width = this.width / b.opts.pixelRatio;
                b.coming.height = this.height / b.opts.pixelRatio;
                b._afterLoad();
            };
            a.onerror = function () {
                this.onload = this.onerror = null;
                b._error("image");
            };
            a.src = b.coming.href;
            !0 !== a.complete && b.showLoading();
        },
        _loadAjax: function () {
            var a = b.coming;
            b.showLoading();
            b.ajaxLoad = f.ajax(
                f.extend({}, a.ajax, {
                    url: a.href,
                    error: function (a, e) {
                        b.coming && "abort" !== e ? b._error("ajax", a) : b.hideLoading();
                    },
                    success: function (d, e) {
                        "success" === e && ((a.content = d), b._afterLoad());
                    },
                })
            );
        },
        _loadIframe: function () {
            var a = b.coming,
                d = f(a.tpl.iframe.replace(/\{rnd\}/g, new Date().getTime()))
                    .attr("scrolling", s ? "auto" : a.iframe.scrolling)
                    .attr("src", a.href);
            f(a.wrap).bind("onReset", function () {
                try {
                    f(this).find("iframe").hide().attr("src", "//about:blank").end().empty();
                } catch (a) {}
            });
            a.iframe.preload &&
                (b.showLoading(),
                d.one("load", function () {
                    f(this).data("ready", 1);
                    s || f(this).bind("load.fb", b.update);
                    f(this).parents(".fancybox-wrap").width("100%").removeClass("fancybox-tmp").show();
                    b._afterLoad();
                }));
            a.content = d.appendTo(a.inner);
            a.iframe.preload || b._afterLoad();
        },
        _preloadImages: function () {
            var a = b.group,
                d = b.current,
                e = a.length,
                c = d.preload ? Math.min(d.preload, e - 1) : 0,
                f,
                g;
            for (g = 1; g <= c; g += 1) (f = a[(d.index + g) % e]), "image" === f.type && f.href && (new Image().src = f.href);
        },
        _afterLoad: function () {
            var a = b.coming,
                d = b.current,
                e,
                c,
                k,
                g,
                h;
            b.hideLoading();
            if (a && !1 !== b.isActive)
                if (!1 === b.trigger("afterLoad", a, d)) a.wrap.stop(!0).trigger("onReset").remove(), (b.coming = null);
                else {
                    d && (b.trigger("beforeChange", d), d.wrap.stop(!0).removeClass("fancybox-opened").find(".fancybox-item, .fancybox-nav").remove());
                    b.unbindEvents();
                    e = a.content;
                    c = a.type;
                    k = a.scrolling;
                    f.extend(b, { wrap: a.wrap, skin: a.skin, outer: a.outer, inner: a.inner, current: a, previous: d });
                    g = a.href;
                    switch (c) {
                        case "inline":
                        case "ajax":
                        case "html":
                            a.selector
                                ? (e = f("<div>").html(e).find(a.selector))
                                : t(e) &&
                                  (e.data("fancybox-placeholder") || e.data("fancybox-placeholder", f('<div class="fancybox-placeholder"></div>').insertAfter(e).hide()),
                                  (e = e.show().detach()),
                                  a.wrap.bind("onReset", function () {
                                      f(this).find(e).length && e.hide().replaceAll(e.data("fancybox-placeholder")).data("fancybox-placeholder", !1);
                                  }));
                            break;
                        case "image":
                            e = a.tpl.image.replace("{href}", g);
                            break;
                        case "swf":
                            (e = '<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="' + g + '"></param>'),
                                (h = ""),
                                f.each(a.swf, function (a, b) {
                                    e += '<param name="' + a + '" value="' + b + '"></param>';
                                    h += " " + a + '="' + b + '"';
                                }),
                                (e += '<embed src="' + g + '" type="application/x-shockwave-flash" width="100%" height="100%"' + h + "></embed></object>");
                    }
                    (!t(e) || !e.parent().is(a.inner)) && a.inner.append(e);
                    b.trigger("beforeShow");
                    a.inner.css("overflow", "yes" === k ? "scroll" : "no" === k ? "hidden" : k);
                    b._setDimension();
                    b.reposition();
                    b.isOpen = !1;
                    b.coming = null;
                    b.bindEvents();
                    if (b.isOpened) {
                        if (d.prevMethod) b.transitions[d.prevMethod]();
                    } else f(".fancybox-wrap").not(a.wrap).stop(!0).trigger("onReset").remove();
                    b.transitions[b.isOpened ? a.nextMethod : a.openMethod]();
                    b._preloadImages();
                }
        },
        _setDimension: function () {
            var a = b.getViewport(),
                d = 0,
                e = !1,
                c = !1,
                e = b.wrap,
                k = b.skin,
                g = b.inner,
                h = b.current,
                c = h.width,
                j = h.height,
                m = h.minWidth,
                u = h.minHeight,
                n = h.maxWidth,
                p = h.maxHeight,
                s = h.scrolling,
                q = h.scrollOutside ? h.scrollbarWidth : 0,
                x = h.margin,
                y = l(x[1] + x[3]),
                r = l(x[0] + x[2]),
                v,
                z,
                t,
                C,
                A,
                F,
                B,
                D,
                H;
            e.add(k).add(g).width("auto").height("auto").removeClass("fancybox-tmp");
            x = l(k.outerWidth(!0) - k.width());
            v = l(k.outerHeight(!0) - k.height());
            z = y + x;
            t = r + v;
            C = E(c) ? ((a.w - z) * l(c)) / 100 : c;
            A = E(j) ? ((a.h - t) * l(j)) / 100 : j;
            if ("iframe" === h.type) {
                if (((H = h.content), h.autoHeight && 1 === H.data("ready")))
                    try {
                        H[0].contentWindow.document.location && (g.width(C).height(9999), (F = H.contents().find("body")), q && F.css("overflow-x", "hidden"), (A = F.outerHeight(!0)));
                    } catch (G) {}
            } else if (h.autoWidth || h.autoHeight) g.addClass("fancybox-tmp"), h.autoWidth || g.width(C), h.autoHeight || g.height(A), h.autoWidth && (C = g.width()), h.autoHeight && (A = g.height()), g.removeClass("fancybox-tmp");
            c = l(C);
            j = l(A);
            D = C / A;
            m = l(E(m) ? l(m, "w") - z : m);
            n = l(E(n) ? l(n, "w") - z : n);
            u = l(E(u) ? l(u, "h") - t : u);
            p = l(E(p) ? l(p, "h") - t : p);
            F = n;
            B = p;
            h.fitToView && ((n = Math.min(a.w - z, n)), (p = Math.min(a.h - t, p)));
            z = a.w - y;
            r = a.h - r;
            h.aspectRatio
                ? (c > n && ((c = n), (j = l(c / D))), j > p && ((j = p), (c = l(j * D))), c < m && ((c = m), (j = l(c / D))), j < u && ((j = u), (c = l(j * D))))
                : ((c = Math.max(m, Math.min(c, n))), h.autoHeight && "iframe" !== h.type && (g.width(c), (j = g.height())), (j = Math.max(u, Math.min(j, p))));
            if (h.fitToView)
                if ((g.width(c).height(j), e.width(c + x), (a = e.width()), (y = e.height()), h.aspectRatio))
                    for (; (a > z || y > r) && c > m && j > u && !(19 < d++); )
                        (j = Math.max(u, Math.min(p, j - 10))), (c = l(j * D)), c < m && ((c = m), (j = l(c / D))), c > n && ((c = n), (j = l(c / D))), g.width(c).height(j), e.width(c + x), (a = e.width()), (y = e.height());
                else (c = Math.max(m, Math.min(c, c - (a - z)))), (j = Math.max(u, Math.min(j, j - (y - r))));
            q && "auto" === s && j < A && c + x + q < z && (c += q);
            g.width(c).height(j);
            e.width(c + x);
            a = e.width();
            y = e.height();
            e = (a > z || y > r) && c > m && j > u;
            c = h.aspectRatio ? c < F && j < B && c < C && j < A : (c < F || j < B) && (c < C || j < A);
            f.extend(h, { dim: { width: w(a), height: w(y) }, origWidth: C, origHeight: A, canShrink: e, canExpand: c, wPadding: x, hPadding: v, wrapSpace: y - k.outerHeight(!0), skinSpace: k.height() - j });
            !H && h.autoHeight && j > u && j < p && !c && g.height("auto");
        },
        _getPosition: function (a) {
            var d = b.current,
                e = b.getViewport(),
                c = d.margin,
                f = b.wrap.width() + c[1] + c[3],
                g = b.wrap.height() + c[0] + c[2],
                c = { position: "absolute", top: c[0], left: c[3] };
            d.autoCenter && d.fixed && !a && g <= e.h && f <= e.w ? (c.position = "fixed") : d.locked || ((c.top += e.y), (c.left += e.x));
            c.top = w(Math.max(c.top, c.top + (e.h - g) * d.topRatio));
            c.left = w(Math.max(c.left, c.left + (e.w - f) * d.leftRatio));
            return c;
        },
        _afterZoomIn: function () {
            var a = b.current;
            a &&
                ((b.isOpen = b.isOpened = !0),
                b.wrap.css("overflow", "visible").addClass("fancybox-opened"),
                b.update(),
                (a.closeClick || (a.nextClick && 1 < b.group.length)) &&
                    b.inner.css("cursor", "pointer").bind("click.fb", function (d) {
                        !f(d.target).is("a") && !f(d.target).parent().is("a") && (d.preventDefault(), b[a.closeClick ? "close" : "next"]());
                    }),
                a.closeBtn &&
                    f(a.tpl.closeBtn)
                        .appendTo(b.skin)
                        .bind("click.fb", function (a) {
                            a.preventDefault();
                            b.close();
                        }),
                a.arrows && 1 < b.group.length && ((a.loop || 0 < a.index) && f(a.tpl.prev).appendTo(b.outer).bind("click.fb", b.prev), (a.loop || a.index < b.group.length - 1) && f(a.tpl.next).appendTo(b.outer).bind("click.fb", b.next)),
                b.trigger("afterShow"),
                !a.loop && a.index === a.group.length - 1 ? b.play(!1) : b.opts.autoPlay && !b.player.isActive && ((b.opts.autoPlay = !1), b.play()));
        },
        _afterZoomOut: function (a) {
            a = a || b.current;
            f(".fancybox-wrap").trigger("onReset").remove();
            f.extend(b, { group: {}, opts: {}, router: !1, current: null, isActive: !1, isOpened: !1, isOpen: !1, isClosing: !1, wrap: null, skin: null, outer: null, inner: null });
            b.trigger("afterClose", a);
        },
    });
    b.transitions = {
        getOrigPosition: function () {
            var a = b.current,
                d = a.element,
                e = a.orig,
                c = {},
                f = 50,
                g = 50,
                h = a.hPadding,
                j = a.wPadding,
                m = b.getViewport();
            !e && a.isDom && d.is(":visible") && ((e = d.find("img:first")), e.length || (e = d));
            t(e) ? ((c = e.offset()), e.is("img") && ((f = e.outerWidth()), (g = e.outerHeight()))) : ((c.top = m.y + (m.h - g) * a.topRatio), (c.left = m.x + (m.w - f) * a.leftRatio));
            if ("fixed" === b.wrap.css("position") || a.locked) (c.top -= m.y), (c.left -= m.x);
            return (c = { top: w(c.top - h * a.topRatio), left: w(c.left - j * a.leftRatio), width: w(f + j), height: w(g + h) });
        },
        step: function (a, d) {
            var e,
                c,
                f = d.prop;
            c = b.current;
            var g = c.wrapSpace,
                h = c.skinSpace;
            if ("width" === f || "height" === f)
                (e = d.end === d.start ? 1 : (a - d.start) / (d.end - d.start)),
                    b.isClosing && (e = 1 - e),
                    (c = "width" === f ? c.wPadding : c.hPadding),
                    (c = a - c),
                    b.skin[f](l("width" === f ? c : c - g * e)),
                    b.inner[f](l("width" === f ? c : c - g * e - h * e));
        },
        zoomIn: function () {
            var a = b.current,
                d = a.pos,
                e = a.openEffect,
                c = "elastic" === e,
                k = f.extend({ opacity: 1 }, d);
            delete k.position;
            c ? ((d = this.getOrigPosition()), a.openOpacity && (d.opacity = 0.1)) : "fade" === e && (d.opacity = 0.1);
            b.wrap.css(d).animate(k, { duration: "none" === e ? 0 : a.openSpeed, easing: a.openEasing, step: c ? this.step : null, complete: b._afterZoomIn });
        },
        zoomOut: function () {
            var a = b.current,
                d = a.closeEffect,
                e = "elastic" === d,
                c = { opacity: 0.1 };
            e && ((c = this.getOrigPosition()), a.closeOpacity && (c.opacity = 0.1));
            b.wrap.animate(c, { duration: "none" === d ? 0 : a.closeSpeed, easing: a.closeEasing, step: e ? this.step : null, complete: b._afterZoomOut });
        },
        changeIn: function () {
            var a = b.current,
                d = a.nextEffect,
                e = a.pos,
                c = { opacity: 1 },
                f = b.direction,
                g;
            e.opacity = 0.1;
            "elastic" === d && ((g = "down" === f || "up" === f ? "top" : "left"), "down" === f || "right" === f ? ((e[g] = w(l(e[g]) - 200)), (c[g] = "+=200px")) : ((e[g] = w(l(e[g]) + 200)), (c[g] = "-=200px")));
            "none" === d ? b._afterZoomIn() : b.wrap.css(e).animate(c, { duration: a.nextSpeed, easing: a.nextEasing, complete: b._afterZoomIn });
        },
        changeOut: function () {
            var a = b.previous,
                d = a.prevEffect,
                e = { opacity: 0.1 },
                c = b.direction;
            "elastic" === d && (e["down" === c || "up" === c ? "top" : "left"] = ("up" === c || "left" === c ? "-" : "+") + "=200px");
            a.wrap.animate(e, {
                duration: "none" === d ? 0 : a.prevSpeed,
                easing: a.prevEasing,
                complete: function () {
                    f(this).trigger("onReset").remove();
                },
            });
        },
    };
    b.helpers.overlay = {
        defaults: { closeClick: !0, speedOut: 200, showEarly: !0, css: {}, locked: !s, fixed: !0 },
        overlay: null,
        fixed: !1,
        el: f("html"),
        create: function (a) {
            a = f.extend({}, this.defaults, a);
            this.overlay && this.close();
            this.overlay = f('<div class="fancybox-overlay"></div>').appendTo(b.coming ? b.coming.parent : a.parent);
            this.fixed = !1;
            a.fixed && b.defaults.fixed && (this.overlay.addClass("fancybox-overlay-fixed"), (this.fixed = !0));
        },
        open: function (a) {
            var d = this;
            a = f.extend({}, this.defaults, a);
            this.overlay ? this.overlay.unbind(".overlay").width("auto").height("auto") : this.create(a);
            this.fixed || (n.bind("resize.overlay", f.proxy(this.update, this)), this.update());
            a.closeClick &&
                this.overlay.bind("click.overlay", function (a) {
                    if (f(a.target).hasClass("fancybox-overlay")) return b.isActive ? b.close() : d.close(), !1;
                });
            this.overlay.css(a.css).show();
        },
        close: function () {
            var a, b;
            n.unbind("resize.overlay");
            this.el.hasClass("fancybox-lock") && (f(".fancybox-margin").removeClass("fancybox-margin"), (a = n.scrollTop()), (b = n.scrollLeft()), this.el.removeClass("fancybox-lock"), n.scrollTop(a).scrollLeft(b));
            f(".fancybox-overlay").remove().hide();
            f.extend(this, { overlay: null, fixed: !1 });
        },
        update: function () {
            var a = "100%",
                b;
            this.overlay.width(a).height("100%");
            I ? ((b = Math.max(G.documentElement.offsetWidth, G.body.offsetWidth)), p.width() > b && (a = p.width())) : p.width() > n.width() && (a = p.width());
            this.overlay.width(a).height(p.height());
        },
        onReady: function (a, b) {
            var e = this.overlay;
            f(".fancybox-overlay").stop(!0, !0);
            e || this.create(a);
            a.locked && this.fixed && b.fixed && (e || (this.margin = p.height() > n.height() ? f("html").css("margin-right").replace("px", "") : !1), (b.locked = this.overlay.append(b.wrap)), (b.fixed = !1));
            !0 === a.showEarly && this.beforeShow.apply(this, arguments);
        },
        beforeShow: function (a, b) {
            var e, c;
            b.locked &&
                (!1 !== this.margin &&
                    (f("*")
                        .filter(function () {
                            return "fixed" === f(this).css("position") && !f(this).hasClass("fancybox-overlay") && !f(this).hasClass("fancybox-wrap");
                        })
                        .addClass("fancybox-margin"),
                    this.el.addClass("fancybox-margin")),
                (e = n.scrollTop()),
                (c = n.scrollLeft()),
                this.el.addClass("fancybox-lock"),
                n.scrollTop(e).scrollLeft(c));
            this.open(a);
        },
        onUpdate: function () {
            this.fixed || this.update();
        },
        afterClose: function (a) {
            this.overlay && !b.coming && this.overlay.fadeOut(a.speedOut, f.proxy(this.close, this));
        },
    };
    b.helpers.title = {
        defaults: { type: "float", position: "bottom" },
        beforeShow: function (a) {
            var d = b.current,
                e = d.title,
                c = a.type;
            f.isFunction(e) && (e = e.call(d.element, d));
            if (q(e) && "" !== f.trim(e)) {
                d = f('<div class="fancybox-title fancybox-title-' + c + '-wrap">' + e + "</div>");
                switch (c) {
                    case "inside":
                        c = b.skin;
                        break;
                    case "outside":
                        c = b.wrap;
                        break;
                    case "over":
                        c = b.inner;
                        break;
                    default:
                        (c = b.skin), d.appendTo("body"), I && d.width(d.width()), d.wrapInner('<span class="child"></span>'), (b.current.margin[2] += Math.abs(l(d.css("margin-bottom"))));
                }
                d["top" === a.position ? "prependTo" : "appendTo"](c);
            }
        },
    };
    f.fn.fancybox = function (a) {
        var d,
            e = f(this),
            c = this.selector || "",
            k = function (g) {
                var h = f(this).blur(),
                    j = d,
                    k,
                    l;
                !g.ctrlKey &&
                    !g.altKey &&
                    !g.shiftKey &&
                    !g.metaKey &&
                    !h.is(".fancybox-wrap") &&
                    ((k = a.groupAttr || "data-fancybox-group"),
                    (l = h.attr(k)),
                    l || ((k = "rel"), (l = h.get(0)[k])),
                    l && "" !== l && "nofollow" !== l && ((h = c.length ? f(c) : e), (h = h.filter("[" + k + '="' + l + '"]')), (j = h.index(this))),
                    (a.index = j),
                    !1 !== b.open(h, a) && g.preventDefault());
            };
        a = a || {};
        d = a.index || 0;
        !c || !1 === a.live ? e.unbind("click.fb-start").bind("click.fb-start", k) : p.undelegate(c, "click.fb-start").delegate(c + ":not('.fancybox-item, .fancybox-nav')", "click.fb-start", k);
        this.filter("[data-fancybox-start=1]").trigger("click");
        return this;
    };
    p.ready(function () {
        var a, d;
        f.scrollbarWidth === v &&
            (f.scrollbarWidth = function () {
                var a = f('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo("body"),
                    b = a.children(),
                    b = b.innerWidth() - b.height(99).innerWidth();
                a.remove();
                return b;
            });
        if (f.support.fixedPosition === v) {
            a = f.support;
            d = f('<div style="position:fixed;top:20px;"></div>').appendTo("body");
            var e = 20 === d[0].offsetTop || 15 === d[0].offsetTop;
            d.remove();
            a.fixedPosition = e;
        }
        f.extend(b.defaults, { scrollbarWidth: f.scrollbarWidth(), fixed: f.support.fixedPosition, parent: f("body") });
        a = f(r).width();
        J.addClass("fancybox-lock-test");
        d = f(r).width();
        J.removeClass("fancybox-lock-test");
        f("<style type='text/css'>.fancybox-margin{margin-right:" + (d - a) + "px;}</style>").appendTo("head");
    });
})(window, document, jQuery);

/*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2006, 2014 Klaus Hartl
 * Released under the MIT license
 */

(function (factory) {
    if (typeof define === "function" && define.amd) {
        define(["jquery"], factory);
    } else if (typeof exports === "object") {
        factory(require("jquery"));
    } else {
        factory(jQuery);
    }
})(function ($) {
    var pluses = /\+/g;
    function encode(s) {
        return config.raw ? s : encodeURIComponent(s);
    }
    function decode(s) {
        return config.raw ? s : decodeURIComponent(s);
    }
    function stringifyCookieValue(value) {
        return encode(config.json ? JSON.stringify(value) : String(value));
    }
    function parseCookieValue(s) {
        if (s.indexOf('"') === 0) {
            s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\");
        }
        try {
            s = decodeURIComponent(s.replace(pluses, " "));
            return config.json ? JSON.parse(s) : s;
        } catch (e) {}
    }
    function read(s, converter) {
        var value = config.raw ? s : parseCookieValue(s);
        return $.isFunction(converter) ? converter(value) : value;
    }
    var config = ($.cookie = function (key, value, options) {
        if (arguments.length > 1 && !$.isFunction(value)) {
            options = $.extend({}, config.defaults, options);
            if (typeof options.expires === "number") {
                var days = options.expires,
                    t = (options.expires = new Date());
                t.setTime(+t + days * 864e5);
            }
            return (document.cookie = [
                encode(key),
                "=",
                stringifyCookieValue(value),
                options.expires ? "; expires=" + options.expires.toUTCString() : "",
                options.path ? "; path=" + options.path : "",
                options.domain ? "; domain=" + options.domain : "",
                options.secure ? "; secure" : "",
            ].join(""));
        }
        var result = key ? undefined : {};
        var cookies = document.cookie ? document.cookie.split("; ") : [];
        for (var i = 0, l = cookies.length; i < l; i++) {
            var parts = cookies[i].split("=");
            var name = decode(parts.shift());
            var cookie = parts.join("=");
            if (key && key === name) {
                result = read(cookie, value);
                break;
            }
            if (!key && (cookie = read(cookie)) !== undefined) {
                result[name] = cookie;
            }
        }
        return result;
    });
    config.defaults = {};
    $.removeCookie = function (key, options) {
        if ($.cookie(key) === undefined) {
            return false;
        }
        $.cookie(key, "", $.extend({}, options, { expires: -1 }));
        return !$.cookie(key);
    };
});

// Instafeed 1.4.1
(function () {
    var e;
    (e = (function () {
        function e(e, t) {
            var n, r;
            this.options = { target: "instafeed", get: "popular", resolution: "thumbnail", sortBy: "none", links: !0, mock: !1, useHttp: !1 };
            if (typeof e == "object") for (n in e) (r = e[n]), (this.options[n] = r);
            (this.context = t != null ? t : this), (this.unique = this._genKey());
        }
        return (
            (e.prototype.hasNext = function () {
                return typeof this.context.nextUrl == "string" && this.context.nextUrl.length > 0;
            }),
            (e.prototype.next = function () {
                return this.hasNext() ? this.run(this.context.nextUrl) : !1;
            }),
            (e.prototype.run = function (t) {
                var n, r, i;
                if (typeof this.options.clientId != "string" && typeof this.options.accessToken != "string") throw new Error("Missing clientId or accessToken.");
                if (typeof this.options.accessToken != "string" && typeof this.options.clientId != "string") throw new Error("Missing clientId or accessToken.");
                return (
                    this.options.before != null && typeof this.options.before == "function" && this.options.before.call(this),
                    typeof document != "undefined" &&
                        document !== null &&
                        ((i = document.createElement("script")),
                        (i.id = "instafeed-fetcher"),
                        (i.src = t || this._buildUrl()),
                        (n = document.getElementsByTagName("head")),
                        n[0].appendChild(i),
                        (r = "instafeedCache" + this.unique),
                        (window[r] = new e(this.options, this)),
                        (window[r].unique = this.unique)),
                    !0
                );
            }),
            (e.prototype.parse = function (e) {
                var t, n, r, i, s, o, u, a, f, l, c, h, p, d, v, m, g, y, b, w, E, S, x, T, N, C, k, L, A, O, M, _, D;
                if (typeof e != "object") {
                    if (this.options.error != null && typeof this.options.error == "function") return this.options.error.call(this, "Invalid JSON data"), !1;
                    throw new Error("Invalid JSON response");
                }
                if (e.meta.code !== 200) {
                    if (this.options.error != null && typeof this.options.error == "function") return this.options.error.call(this, e.meta.error_message), !1;
                    throw new Error("Error from Instagram: " + e.meta.error_message);
                }
                if (e.data.length === 0) {
                    if (this.options.error != null && typeof this.options.error == "function") return this.options.error.call(this, "No images were returned from Instagram"), !1;
                    throw new Error("No images were returned from Instagram");
                }
                this.options.success != null && typeof this.options.success == "function" && this.options.success.call(this, e), (this.context.nextUrl = ""), e.pagination != null && (this.context.nextUrl = e.pagination.next_url);
                if (this.options.sortBy !== "none") {
                    this.options.sortBy === "random" ? (M = ["", "random"]) : (M = this.options.sortBy.split("-")), (O = M[0] === "least" ? !0 : !1);
                    switch (M[1]) {
                        case "random":
                            e.data.sort(function () {
                                return 0.5 - Math.random();
                            });
                            break;
                        case "recent":
                            e.data = this._sortBy(e.data, "created_time", O);
                            break;
                        case "liked":
                            e.data = this._sortBy(e.data, "likes.count", O);
                            break;
                        case "commented":
                            e.data = this._sortBy(e.data, "comments.count", O);
                            break;
                        default:
                            throw new Error("Invalid option for sortBy: '" + this.options.sortBy + "'.");
                    }
                }
                if (typeof document != "undefined" && document !== null && this.options.mock === !1) {
                    (m = e.data),
                        (A = parseInt(this.options.limit, 10)),
                        this.options.limit != null && m.length > A && (m = m.slice(0, A)),
                        (u = document.createDocumentFragment()),
                        this.options.filter != null && typeof this.options.filter == "function" && (m = this._filter(m, this.options.filter));
                    if (this.options.template != null && typeof this.options.template == "string") {
                        (f = ""), (d = ""), (w = ""), (D = document.createElement("div"));
                        for (c = 0, N = m.length; c < N; c++) {
                            (h = m[c]), (p = h.images[this.options.resolution]);
                            if (typeof p != "object") throw ((o = "No image found for resolution: " + this.options.resolution + "."), new Error(o));
                            (E = p.width),
                                (y = p.height),
                                (b = "square"),
                                E > y && (b = "landscape"),
                                E < y && (b = "portrait"),
                                (v = p.url),
                                (l = window.location.protocol.indexOf("http") >= 0),
                                l && !this.options.useHttp && (v = v.replace(/https?:\/\//, "//")),
                                (d = this._makeTemplate(this.options.template, {
                                    model: h,
                                    id: h.id,
                                    link: h.link,
                                    type: h.type,
                                    image: v,
                                    width: E,
                                    height: y,
                                    orientation: b,
                                    caption: this._getObjectProperty(h, "caption.text"),
                                    likes: h.likes.count,
                                    comments: h.comments.count,
                                    location: this._getObjectProperty(h, "location.name"),
                                })),
                                (f += d);
                        }
                        (D.innerHTML = f), (i = []), (r = 0), (n = D.childNodes.length);
                        while (r < n) i.push(D.childNodes[r]), (r += 1);
                        for (x = 0, C = i.length; x < C; x++) (L = i[x]), u.appendChild(L);
                    } else
                        for (T = 0, k = m.length; T < k; T++) {
                            (h = m[T]), (g = document.createElement("img")), (p = h.images[this.options.resolution]);
                            if (typeof p != "object") throw ((o = "No image found for resolution: " + this.options.resolution + "."), new Error(o));
                            (v = p.url),
                                (l = window.location.protocol.indexOf("http") >= 0),
                                l && !this.options.useHttp && (v = v.replace(/https?:\/\//, "//")),
                                (g.src = v),
                                this.options.links === !0 ? ((t = document.createElement("a")), (t.href = h.link), t.appendChild(g), u.appendChild(t)) : u.appendChild(g);
                        }
                    (_ = this.options.target), typeof _ == "string" && (_ = document.getElementById(_));
                    if (_ == null) throw ((o = 'No element with id="' + this.options.target + '" on page.'), new Error(o));
                    _.appendChild(u), (a = document.getElementsByTagName("head")[0]), a.removeChild(document.getElementById("instafeed-fetcher")), (S = "instafeedCache" + this.unique), (window[S] = void 0);
                    try {
                        delete window[S];
                    } catch (P) {
                        s = P;
                    }
                }
                return this.options.after != null && typeof this.options.after == "function" && this.options.after.call(this), !0;
            }),
            (e.prototype._buildUrl = function () {
                var e, t, n;
                e = "https://api.instagram.com/v1";
                switch (this.options.get) {
                    case "popular":
                        t = "media/popular";
                        break;
                    case "tagged":
                        if (!this.options.tagName) throw new Error("No tag name specified. Use the 'tagName' option.");
                        t = "tags/" + this.options.tagName + "/media/recent";
                        break;
                    case "location":
                        if (!this.options.locationId) throw new Error("No location specified. Use the 'locationId' option.");
                        t = "locations/" + this.options.locationId + "/media/recent";
                        break;
                    case "user":
                        if (!this.options.userId) throw new Error("No user specified. Use the 'userId' option.");
                        t = "users/" + this.options.userId + "/media/recent";
                        break;
                    default:
                        throw new Error("Invalid option for get: '" + this.options.get + "'.");
                }
                return (
                    (n = e + "/" + t),
                    this.options.accessToken != null ? (n += "?access_token=" + this.options.accessToken) : (n += "?client_id=" + this.options.clientId),
                    this.options.limit != null && (n += "&count=" + this.options.limit),
                    (n += "&callback=instafeedCache" + this.unique + ".parse"),
                    n
                );
            }),
            (e.prototype._genKey = function () {
                var e;
                return (
                    (e = function () {
                        return (((1 + Math.random()) * 65536) | 0).toString(16).substring(1);
                    }),
                    "" + e() + e() + e() + e()
                );
            }),
            (e.prototype._makeTemplate = function (e, t) {
                var n, r, i, s, o;
                (r = /(?:\{{2})([\w\[\]\.]+)(?:\}{2})/), (n = e);
                while (r.test(n))
                    (s = n.match(r)[1]),
                        (o = (i = this._getObjectProperty(t, s)) != null ? i : ""),
                        (n = n.replace(r, function () {
                            return "" + o;
                        }));
                return n;
            }),
            (e.prototype._getObjectProperty = function (e, t) {
                var n, r;
                (t = t.replace(/\[(\w+)\]/g, ".$1")), (r = t.split("."));
                while (r.length) {
                    n = r.shift();
                    if (!(e != null && n in e)) return null;
                    e = e[n];
                }
                return e;
            }),
            (e.prototype._sortBy = function (e, t, n) {
                var r;
                return (
                    (r = function (e, r) {
                        var i, s;
                        return (i = this._getObjectProperty(e, t)), (s = this._getObjectProperty(r, t)), n ? (i > s ? 1 : -1) : i < s ? 1 : -1;
                    }),
                    e.sort(r.bind(this)),
                    e
                );
            }),
            (e.prototype._filter = function (e, t) {
                var n, r, i, s, o;
                (n = []),
                    (r = function (e) {
                        if (t(e)) return n.push(e);
                    });
                for (i = 0, o = e.length; i < o; i++) (s = e[i]), r(s);
                return n;
            }),
            e
        );
    })()),
        (function (e, t) {
            return typeof define == "function" && define.amd ? define([], t) : typeof module == "object" && module.exports ? (module.exports = t()) : (e.Instafeed = t());
        })(this, function () {
            return e;
        });
}.call(this));

/* ===========================================================
 *
 *  Name:          selectordie.min.js
 *  Updated:       2014-10-11
 *  Version:       0.1.8
 *  Created by:    Per V @ Vst.mn
 *  What?:         Minified version of the Select or Die JS
 *
 *  Copyright (c) 2014 Per Vestman
 *  Dual licensed under the MIT and GPL licenses.
 *
 *  Beards, Rock & Loud Guns | Cogs 'n Kegs
 *
 * =========================================================== */

!(function (a) {
    "use strict";
    a.fn.selectOrDie = function (b) {
        var f,
            g,
            c = { customID: null, customClass: "", placeholder: null, placeholderOption: !1, prefix: null, cycle: !1, stripEmpty: !1, links: !1, linksExternal: !1, size: 0, tabIndex: 0, onChange: a.noop },
            d = {},
            e = !1,
            h = {
                initSoD: function (b) {
                    return (
                        (d = a.extend({}, c, b)),
                        this.each(function () {
                            if (a(this).parent().hasClass("sod_select")) console.log("Select or Die: It looks like the SoD already exists");
                            else {
                                var u,
                                    v,
                                    w,
                                    b = a(this),
                                    c = b.data("custom-id") ? b.data("custom-id") : d.customID,
                                    e = b.data("custom-class") ? b.data("custom-class") : d.customClass,
                                    f = b.data("prefix") ? b.data("prefix") : d.prefix,
                                    g = b.data("placeholder") ? b.data("placeholder") : d.placeholder,
                                    i = b.data("placeholder-option") ? b.data("placeholder-option") : d.placeholderOption,
                                    j = b.data("cycle") ? b.data("cycle") : d.cycle,
                                    k = b.data("links") ? b.data("links") : d.links,
                                    l = b.data("links-external") ? b.data("links-external") : d.linksExternal,
                                    m = parseInt(b.data("size")) ? b.data("size") : d.size,
                                    n = parseInt(b.data("tabindex")) ? b.data("tabindex") : d.tabIndex ? d.tabIndex : b.attr("tabindex") ? b.attr("tabindex") : d.tabIndex,
                                    o = b.data("strip-empty") ? b.data("strip-empty") : d.stripEmpty,
                                    p = b.prop("title") ? b.prop("title") : null,
                                    q = b.is(":disabled") ? " disabled" : "",
                                    r = "",
                                    s = "",
                                    t = 0;
                                f && (r = '<span class="sod_prefix">' + f + "</span> "),
                                    (s += g && !f ? '<span class="sod_label sod_placeholder">' + g + "</span>" : '<span class="sod_label">' + r + "</span>"),
                                    (u = a("<span/>", {
                                        id: c,
                                        class: "sod_select " + e + q,
                                        title: p,
                                        tabindex: n,
                                        html: s,
                                        "data-cycle": j,
                                        "data-links": k,
                                        "data-links-external": l,
                                        "data-placeholder": g,
                                        "data-placeholder-option": i,
                                        "data-prefix": f,
                                        "data-filter": "",
                                    }).insertAfter(this)),
                                    h.isTouch() && u.addClass("touch"),
                                    (v = a("<span/>", { class: "sod_list_wrapper" }).appendTo(u)),
                                    (w = a("<span/>", { class: "sod_list" }).appendTo(v)),
                                    a("option, optgroup", b).each(function (b) {
                                        var c = a(this);
                                        o && !a.trim(c.text()) ? c.remove() : 0 === b && i && !r ? h.populateSoD(c, w, u, !0) : h.populateSoD(c, w, u, !1);
                                    }),
                                    m &&
                                        (v.show(),
                                        a(".sod_option:lt(" + m + ")", w).each(function () {
                                            t += a(this).outerHeight();
                                        }),
                                        v.removeAttr("style"),
                                        w.css({ "max-height": t })),
                                    b.appendTo(u),
                                    u.on("focusin", h.focusSod).on("click", h.triggerSod).on("click", ".sod_option", h.optionClick).on("mousemove", ".sod_option", h.optionHover).on("keydown", h.keyboardUse),
                                    b.on("change", h.selectChange),
                                    a(document).on("click", "label[for='" + b.attr("id") + "']", function (a) {
                                        a.preventDefault(), u.focus();
                                    });
                            }
                        })
                    );
                },
                populateSoD: function (b, c, d, e) {
                    var f = d.data("placeholder"),
                        g = d.data("placeholder-option"),
                        h = d.data("prefix"),
                        i = d.find(".sod_label"),
                        j = b.parent(),
                        k = b.text(),
                        l = b.val(),
                        m = b.data("custom-id") ? b.data("custom-id") : null,
                        n = b.data("custom-class") ? b.data("custom-class") : "",
                        o = b.is(":disabled") ? " disabled " : "",
                        p = b.is(":selected") ? " selected active " : "",
                        q = b.data("link") ? " link " : "",
                        r = b.data("link-external") ? " linkexternal" : "",
                        s = b.prop("label");
                    b.is("option")
                        ? (a("<span/>", { class: "sod_option " + n + o + p + q + r, id: m, title: k, html: k, "data-value": l }).appendTo(c),
                          e && !h
                              ? (d.data("label", k), d.data("placeholder", k), b.prop("disabled", !0), c.find(".sod_option:last").addClass("is-placeholder disabled"), p && i.addClass("sod_placeholder"))
                              : p && f && !g && !h
                              ? d.data("label", f)
                              : p && d.data("label", k),
                          ((p && !f) || (p && g) || (p && h)) && i.append(k),
                          j.is("optgroup") && (c.find(".sod_option:last").addClass("groupchild"), j.is(":disabled") && c.find(".sod_option:last").addClass("disabled")))
                        : a("<span/>", { class: "sod_option optgroup " + o, title: s, html: s, "data-label": s }).appendTo(c);
                },
                focusSod: function () {
                    var b = a(this);
                    b.hasClass("disabled")
                        ? h.blurSod(b)
                        : (h.blurSod(a(".sod_select.focus").not(b)),
                          b.addClass("focus"),
                          a("html").on("click.sodBlur", function () {
                              h.blurSod(b);
                          }));
                },
                triggerSod: function (b) {
                    b.stopPropagation();
                    var c = a(this),
                        d = c.find(".sod_list"),
                        e = c.data("placeholder"),
                        f = c.find(".active"),
                        i = c.find(".selected");
                    c.hasClass("disabled") || c.hasClass("open") || c.hasClass("touch")
                        ? (clearTimeout(g), c.removeClass("open"), e && (c.find(".sod_label").get(0).lastChild.nodeValue = f.text()))
                        : (c.addClass("open"), e && !c.data("prefix") && c.find(".sod_label").addClass("sod_placeholder").html(e), h.listScroll(d, i), h.checkViewport(c, d));
                },
                keyboardUse: function (b) {
                    var l,
                        m,
                        n,
                        c = a(this),
                        d = c.find(".sod_list"),
                        g = c.find(".sod_option"),
                        i = c.find(".sod_label"),
                        j = c.data("cycle"),
                        k = g.filter(".active");
                    return b.which > 36 && b.which < 41
                        ? (37 === b.which || 38 === b.which
                              ? ((m = k.prevAll(":not('.disabled, .optgroup')").first()), (n = g.not(".disabled, .optgroup").last()))
                              : (39 === b.which || 40 === b.which) && ((m = k.nextAll(":not('.disabled, .optgroup')").first()), (n = g.not(".disabled, .optgroup").first())),
                          !m.hasClass("sod_option") && j && (m = n),
                          (m.hasClass("sod_option") || j) && (k.removeClass("active"), m.addClass("active"), (i.get(0).lastChild.nodeValue = m.text()), h.listScroll(d, m), c.hasClass("open") || (e = !0)),
                          !1)
                        : (13 === b.which || (32 === b.which && c.hasClass("open") && (" " === c.data("filter")[0] || "" === c.data("filter")))
                              ? (b.preventDefault(), k.click())
                              : 32 !== b.which || c.hasClass("open") || (" " !== c.data("filter")[0] && "" !== c.data("filter"))
                              ? 27 === b.which && h.blurSod(c)
                              : (b.preventDefault(), (e = !1), c.click()),
                          0 !== b.which &&
                              (clearTimeout(f),
                              c.data("filter", c.data("filter") + String.fromCharCode(b.which)),
                              (l = g
                                  .filter(function () {
                                      return 0 === a(this).text().toLowerCase().indexOf(c.data("filter").toLowerCase());
                                  })
                                  .not(".disabled, .optgroup")
                                  .first()),
                              l.length && (k.removeClass("active"), l.addClass("active"), h.listScroll(d, l), (i.get(0).lastChild.nodeValue = l.text()), c.hasClass("open") || (e = !0)),
                              (f = setTimeout(function () {
                                  c.data("filter", "");
                              }, 500))),
                          void 0);
                },
                optionHover: function () {
                    var b = a(this);
                    b.hasClass("disabled") || b.hasClass("optgroup") || b.siblings().removeClass("active").end().addClass("active");
                },
                optionClick: function (b) {
                    b.stopPropagation();
                    var c = a(this),
                        d = c.closest(".sod_select"),
                        e = c.hasClass("disabled"),
                        f = c.hasClass("optgroup"),
                        h = d.find(".sod_option:not('.optgroup')").index(this);
                    d.hasClass("touch") ||
                        (e || f || (d.find(".selected, .sod_placeholder").removeClass("selected sod_placeholder"), c.addClass("selected"), (d.find("select option")[h].selected = !0), d.find("select").change()),
                        clearTimeout(g),
                        d.removeClass("open"));
                },
                selectChange: function () {
                    var b = a(this),
                        c = b.find(":selected"),
                        e = c.text(),
                        f = b.closest(".sod_select");
                    //(f.find(".sod_label").get(0).lastChild.nodeValue = e),
                        f.data("label", e),
                        d.onChange.call(this),
                        (!f.data("links") && !c.data("link")) || c.data("link-external") ? (f.data("links-external") || c.data("link-external")) && window.open(c.val(), "_blank") : (window.location.href = c.val());
                },
                blurSod: function (b) {
                    if (a("body").find(b).length) {
                        var c = b.data("label"),
                            d = b.data("placeholder"),
                            f = b.find(".active"),
                            h = b.find(".selected"),
                            i = !1;
                        clearTimeout(g),
                            e && !f.hasClass("selected") ? (f.click(), (i = !0)) : f.hasClass("selected") || (f.removeClass("active"), h.addClass("active")),
                            !i && d ? (b.find(".sod_label").get(0).lastChild.nodeValue = h.text()) : i || (b.find(".sod_label").get(0).lastChild.nodeValue = c),
                            (e = !1),
                            b.removeClass("open focus"),
                            b.blur(),
                            a("html").off(".sodBlur");
                    }
                },
                checkViewport: function (b, c) {
                    var d = b[0].getBoundingClientRect(),
                        e = c.outerHeight();
                    d.bottom + e + 10 > a(window).height() && d.top - e > 10 ? b.addClass("above") : b.removeClass("above"),
                        (g = setTimeout(function () {
                            h.checkViewport(b, c);
                        }, 200));
                },
                listScroll: function (a, b) {
                    var c = a[0].getBoundingClientRect(),
                        d = b[0].getBoundingClientRect();
                    c.top > d.top ? a.scrollTop(a.scrollTop() - c.top + d.top) : c.bottom < d.bottom && a.scrollTop(a.scrollTop() - c.bottom + d.bottom);
                },
                isTouch: function () {
                    return "ontouchstart" in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
                },
            },
            i = {
                destroy: function () {
                    return this.each(function () {
                        var b = a(this),
                            c = b.parent();
                        c.hasClass("sod_select") ? (b.off("change"), c.find("span").remove(), b.unwrap()) : console.log("Select or Die: There's no SoD to destroy");
                    });
                },
                update: function () {
                    return this.each(function () {
                        var b = a(this),
                            c = b.parent(),
                            d = c.find(".sod_list:first");
                        c.hasClass("sod_select")
                            ? (d.empty(),
                              (c.find(".sod_label").get(0).lastChild.nodeValue = ""),
                              b.is(":disabled") && c.addClass("disabled"),
                              a("option, optgroup", b).each(function () {
                                  h.populateSoD(a(this), d, c);
                              }))
                            : console.log("Select or Die: There's no SoD to update");
                    });
                },
                disable: function (b) {
                    return this.each(function () {
                        var c = a(this),
                            d = c.parent();
                        d.hasClass("sod_select")
                            ? "undefined" != typeof b
                                ? (d.find(".sod_list:first .sod_option[data-value='" + b + "']").addClass("disabled"),
                                  d
                                      .find(".sod_list:first .sod_option[data-label='" + b + "']")
                                      .nextUntil(":not(.groupchild)")
                                      .addClass("disabled"),
                                  a("option[value='" + b + "'], optgroup[label='" + b + "']", this).prop("disabled", !0))
                                : d.hasClass("sod_select") && (d.addClass("disabled"), c.prop("disabled", !0))
                            : console.log("Select or Die: There's no SoD to disable");
                    });
                },
                enable: function (b) {
                    return this.each(function () {
                        var c = a(this),
                            d = c.parent();
                        d.hasClass("sod_select")
                            ? "undefined" != typeof b
                                ? (d.find(".sod_list:first .sod_option[data-value='" + b + "']").removeClass("disabled"),
                                  d
                                      .find(".sod_list:first .sod_option[data-label='" + b + "']")
                                      .nextUntil(":not(.groupchild)")
                                      .removeClass("disabled"),
                                  a("option[value='" + b + "'], optgroup[label='" + b + "']", this).prop("disabled", !1))
                                : d.hasClass("sod_select") && (d.removeClass("disabled"), c.prop("disabled", !1))
                            : console.log("Select or Die: There's no SoD to enable");
                    });
                },
            };
        return i[b] ? i[b].apply(this, Array.prototype.slice.call(arguments, 1)) : "object" != typeof b && b ? (a.error('Select or Die: Oh no! No such method "' + b + '" for the SoD instance'), void 0) : h.initSoD.apply(this, arguments);
    };
})(jQuery);

/*============================================================================
  Social Icon Buttons v1.0
  Author:
    Carson Shold | @cshold
    http://www.carsonshold.com
  MIT License
==============================================================================*/
window.CSbuttons = window.CSbuttons || {};

CSbuttons.init = function () {
    var $shareLinks = $(".social-sharing").find("a");

    // Share popups
    $shareLinks.on("click", function (e) {
        var el = $(this),
            popup = el.attr("class").replace("-", "_"),
            link = el.attr("href"),
            w = 700,
            h = 400;

        // Set popup sizes
        switch (popup) {
            case "share_twitter":
                h = 300;
                break;
            case "share_fancy":
                w = 480;
                h = 720;
                break;
            case "share_google":
                w = 500;
                break;
            case "share_reddit":
                popup = false;
                break;
            case "share_skype":
                w = 300;
                h = 720;
                break;
        }

        if (popup) {
            e.preventDefault();
            window.open(link, popup, "width=" + w + ", height=" + h);
        }
    });
};

$(function () {
    window.CSbuttons.init();
});

/*
 * jquery-match-height 0.7.0 by @liabru
 * http://brm.io/jquery-match-height/
 * License MIT
 */
!(function (t) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], t) : "undefined" != typeof module && module.exports ? (module.exports = t(require("jquery"))) : t(jQuery);
})(function (t) {
    var e = -1,
        o = -1,
        i = function (t) {
            return parseFloat(t) || 0;
        },
        a = function (e) {
            var o = 1,
                a = t(e),
                n = null,
                r = [];
            return (
                a.each(function () {
                    var e = t(this),
                        a = e.offset().top - i(e.css("margin-top")),
                        s = r.length > 0 ? r[r.length - 1] : null;
                    null === s ? r.push(e) : Math.floor(Math.abs(n - a)) <= o ? (r[r.length - 1] = s.add(e)) : r.push(e), (n = a);
                }),
                r
            );
        },
        n = function (e) {
            var o = {
                byRow: !0,
                property: "height",
                target: null,
                remove: !1,
            };
            return "object" == typeof e ? t.extend(o, e) : ("boolean" == typeof e ? (o.byRow = e) : "remove" === e && (o.remove = !0), o);
        },
        r = (t.fn.matchHeight = function (e) {
            var o = n(e);
            if (o.remove) {
                var i = this;
                return (
                    this.css(o.property, ""),
                    t.each(r._groups, function (t, e) {
                        e.elements = e.elements.not(i);
                    }),
                    this
                );
            }
            return this.length <= 1 && !o.target ? this : (r._groups.push({ elements: this, options: o }), r._apply(this, o), this);
        });
    (r.version = "0.7.0"),
        (r._groups = []),
        (r._throttle = 80),
        (r._maintainScroll = !1),
        (r._beforeUpdate = null),
        (r._afterUpdate = null),
        (r._rows = a),
        (r._parse = i),
        (r._parseOptions = n),
        (r._apply = function (e, o) {
            var s = n(o),
                h = t(e),
                l = [h],
                c = t(window).scrollTop(),
                p = t("html").outerHeight(!0),
                d = h.parents().filter(":hidden");
            return (
                d.each(function () {
                    var e = t(this);
                    e.data("style-cache", e.attr("style"));
                }),
                d.css("display", "block"),
                s.byRow &&
                    !s.target &&
                    (h.each(function () {
                        var e = t(this),
                            o = e.css("display");
                        "inline-block" !== o && "flex" !== o && "inline-flex" !== o && (o = "block"),
                            e.data("style-cache", e.attr("style")),
                            e.css({ display: o, "padding-top": "0", "padding-bottom": "0", "margin-top": "0", "margin-bottom": "0", "border-top-width": "0", "border-bottom-width": "0", height: "100px", overflow: "hidden" });
                    }),
                    (l = a(h)),
                    h.each(function () {
                        var e = t(this);
                        e.attr("style", e.data("style-cache") || "");
                    })),
                t.each(l, function (e, o) {
                    var a = t(o),
                        n = 0;
                    if (s.target) n = s.target.outerHeight(!1);
                    else {
                        if (s.byRow && a.length <= 1) return void a.css(s.property, "");
                        a.each(function () {
                            var e = t(this),
                                o = e.attr("style"),
                                i = e.css("display");
                            "inline-block" !== i && "flex" !== i && "inline-flex" !== i && (i = "block");
                            var a = {
                                display: i,
                            };
                            (a[s.property] = ""), e.css(a), e.outerHeight(!1) > n && (n = e.outerHeight(!1)), o ? e.attr("style", o) : e.css("display", "");
                        });
                    }
                    a.each(function () {
                        var e = t(this),
                            o = 0;
                        (s.target && e.is(s.target)) ||
                            ("border-box" !== e.css("box-sizing") && ((o += i(e.css("border-top-width")) + i(e.css("border-bottom-width"))), (o += i(e.css("padding-top")) + i(e.css("padding-bottom")))), e.css(s.property, n - o + "px"));
                    });
                }),
                d.each(function () {
                    var e = t(this);
                    e.attr("style", e.data("style-cache") || null);
                }),
                r._maintainScroll && t(window).scrollTop((c / p) * t("html").outerHeight(!0)),
                this
            );
        }),
        (r._applyDataApi = function () {
            var e = {};
            t("[data-match-height], [data-mh]").each(function () {
                var o = t(this),
                    i = o.attr("data-mh") || o.attr("data-match-height");
                i in e ? (e[i] = e[i].add(o)) : (e[i] = o);
            }),
                t.each(e, function () {
                    this.matchHeight(!0);
                });
        });
    var s = function (e) {
        r._beforeUpdate && r._beforeUpdate(e, r._groups),
            t.each(r._groups, function () {
                r._apply(this.elements, this.options);
            }),
            r._afterUpdate && r._afterUpdate(e, r._groups);
    };
    (r._update = function (i, a) {
        if (a && "resize" === a.type) {
            var n = t(window).width();
            if (n === e) return;
            e = n;
        }
        i
            ? -1 === o &&
              (o = setTimeout(function () {
                  s(a), (o = -1);
              }, r._throttle))
            : s(a);
    }),
        t(r._applyDataApi),
        t(window).bind("load", function (t) {
            r._update(!1, t);
        }),
        t(window).bind("resize orientationchange", function (t) {
            r._update(!0, t);
        });
});

/* Menu */
!(function (t) {
    if ("object" == typeof exports && "undefined" != typeof module) module.exports = t();
    else if ("function" == typeof define && define.amd) define([], t);
    else {
        var e;
        "undefined" != typeof window ? (e = window) : "undefined" != typeof global ? (e = global) : "undefined" != typeof self && (e = self), (e.Slideout = t());
    }
})(function () {
    var t, e, n;
    return (function i(t, e, n) {
        function o(r, a) {
            if (!e[r]) {
                if (!t[r]) {
                    var u = typeof require == "function" && require;
                    if (!a && u) return u(r, !0);
                    if (s) return s(r, !0);
                    var l = new Error("Cannot find module '" + r + "'");
                    throw ((l.code = "MODULE_NOT_FOUND"), l);
                }
                var f = (e[r] = { exports: {} });
                t[r][0].call(
                    f.exports,
                    function (e) {
                        var n = t[r][1][e];
                        return o(n ? n : e);
                    },
                    f,
                    f.exports,
                    i,
                    t,
                    e,
                    n
                );
            }
            return e[r].exports;
        }
        var s = typeof require == "function" && require;
        for (var r = 0; r < n.length; r++) o(n[r]);
        return o;
    })(
        {
            1: [
                function (t, e, n) {
                    "use strict";
                    var i = t("decouple");
                    var o = t("emitter");
                    var s;
                    var r = false;
                    var a = window.document;
                    var u = a.documentElement;
                    var l = window.navigator.msPointerEnabled;
                    var f = { start: l ? "MSPointerDown" : "touchstart", move: l ? "MSPointerMove" : "touchmove", end: l ? "MSPointerUp" : "touchend" };
                    var h = (function v() {
                        var t = /^(Webkit|Khtml|Moz|ms|O)(?=[A-Z])/;
                        var e = a.getElementsByTagName("script")[0].style;
                        for (var n in e) {
                            if (t.test(n)) {
                                return "-" + n.match(t)[0].toLowerCase() + "-";
                            }
                        }
                        if ("WebkitOpacity" in e) {
                            return "-webkit-";
                        }
                        if ("KhtmlOpacity" in e) {
                            return "-khtml-";
                        }
                        return "";
                    })();
                    function c(t, e) {
                        for (var n in e) {
                            if (e[n]) {
                                t[n] = e[n];
                            }
                        }
                        return t;
                    }
                    function p(t, e) {
                        t.prototype = c(t.prototype || {}, e.prototype);
                    }
                    function d(t) {
                        t = t || {};
                        this._startOffsetX = 0;
                        this._currentOffsetX = 0;
                        this._opening = false;
                        this._moved = false;
                        this._opened = false;
                        this._preventOpen = false;
                        this._touch = t.touch === undefined ? true : t.touch && true;
                        this.panel = t.panel;
                        this.menu = t.menu;
                        if (this.panel.className.search("slideout-panel") === -1) {
                            this.panel.className += " slideout-panel";
                        }
                        if (this.menu.className.search("slideout-menu") === -1) {
                            this.menu.className += " slideout-menu";
                        }
                        this._fx = t.fx || "ease";
                        this._duration = parseInt(t.duration, 10) || 300;
                        this._tolerance = parseInt(t.tolerance, 10) || 70;
                        this._padding = this._translateTo = parseInt(t.padding, 10) || 256;
                        this._orientation = t.side === "right" ? -1 : 1;
                        this._translateTo *= this._orientation;
                        if (this._touch) {
                            this._initTouchEvents();
                        }
                    }
                    p(d, o);
                    d.prototype.open = function () {
                        var t = this;
                        this.emit("beforeopen");
                        if (u.className.search("slideout-open") === -1) {
                            u.className += " slideout-open";
                        }
                        this._setTransition();
                        this._translateXTo(this._translateTo);
                        this._opened = true;
                        setTimeout(function () {
                            t.panel.style.transition = t.panel.style["-webkit-transition"] = "";
                            t.emit("open");
                        }, this._duration + 50);
                        return this;
                    };
                    d.prototype.close = function () {
                        var t = this;
                        if (!this.isOpen() && !this._opening) {
                            return this;
                        }
                        this.emit("beforeclose");
                        this._setTransition();
                        this._translateXTo(0);
                        this._opened = false;
                        setTimeout(function () {
                            u.className = u.className.replace(/ slideout-open/, "");
                            t.panel.style.transition = t.panel.style["-webkit-transition"] = t.panel.style[h + "transform"] = t.panel.style.transform = "";
                            t.emit("close");
                        }, this._duration + 50);
                        return this;
                    };
                    d.prototype.toggle = function () {
                        return this.isOpen() ? this.close() : this.open();
                    };
                    d.prototype.isOpen = function () {
                        return this._opened;
                    };
                    d.prototype._translateXTo = function (t) {
                        this._currentOffsetX = t;
                        this.panel.style[h + "transform"] = this.panel.style.transform = "translateX(" + t + "px)";
                        return this;
                    };
                    d.prototype._setTransition = function () {
                        this.panel.style[h + "transition"] = this.panel.style.transition = h + "transform " + this._duration + "ms " + this._fx;
                        return this;
                    };
                    d.prototype._initTouchEvents = function () {
                        var t = this;
                        this._onScrollFn = i(a, "scroll", function () {
                            if (!t._moved) {
                                clearTimeout(s);
                                r = true;
                                s = setTimeout(function () {
                                    r = false;
                                }, 250);
                            }
                        });
                        this._preventMove = function (e) {
                            if (t._moved) {
                                e.preventDefault();
                            }
                        };
                        a.addEventListener(f.move, this._preventMove);
                        this._resetTouchFn = function (e) {
                            if (typeof e.touches === "undefined") {
                                return;
                            }
                            t._moved = false;
                            t._opening = false;
                            t._startOffsetX = e.touches[0].pageX;
                            t._preventOpen = !t._touch || (!t.isOpen() && t.menu.clientWidth !== 0);
                        };
                        this.panel.addEventListener(f.start, this._resetTouchFn);
                        this._onTouchCancelFn = function () {
                            t._moved = false;
                            t._opening = false;
                        };
                        this.panel.addEventListener("touchcancel", this._onTouchCancelFn);
                        this._onTouchEndFn = function () {
                            if (t._moved) {
                                t.emit("translateend");
                                t._opening && Math.abs(t._currentOffsetX) > t._tolerance ? t.open() : t.close();
                            }
                            t._moved = false;
                        };
                        this.panel.addEventListener(f.end, this._onTouchEndFn);
                        this._onTouchMoveFn = function (e) {
                            if (r || t._preventOpen || typeof e.touches === "undefined") {
                                return;
                            }
                            var n = e.touches[0].clientX - t._startOffsetX;
                            var i = (t._currentOffsetX = n);
                            if (Math.abs(i) > t._padding) {
                                return;
                            }
                            if (Math.abs(n) > 20) {
                                t._opening = true;
                                var o = n * t._orientation;
                                if ((t._opened && o > 0) || (!t._opened && o < 0)) {
                                    return;
                                }
                                if (!t._moved) {
                                    t.emit("translatestart");
                                }
                                if (o <= 0) {
                                    i = n + t._padding * t._orientation;
                                    t._opening = false;
                                }
                                if (!t._moved && u.className.search("slideout-open") === -1) {
                                    u.className += " slideout-open";
                                }
                                t.panel.style[h + "transform"] = t.panel.style.transform = "translateX(" + i + "px)";
                                t.emit("translate", i);
                                t._moved = true;
                            }
                        };
                        this.panel.addEventListener(f.move, this._onTouchMoveFn);
                        return this;
                    };
                    d.prototype.enableTouch = function () {
                        this._touch = true;
                        return this;
                    };
                    d.prototype.disableTouch = function () {
                        this._touch = false;
                        return this;
                    };
                    d.prototype.destroy = function () {
                        this.close();
                        a.removeEventListener(f.move, this._preventMove);
                        this.panel.removeEventListener(f.start, this._resetTouchFn);
                        this.panel.removeEventListener("touchcancel", this._onTouchCancelFn);
                        this.panel.removeEventListener(f.end, this._onTouchEndFn);
                        this.panel.removeEventListener(f.move, this._onTouchMoveFn);
                        a.removeEventListener("scroll", this._onScrollFn);
                        this.open = this.close = function () {};
                        return this;
                    };
                    e.exports = d;
                },
                { decouple: 2, emitter: 3 },
            ],
            2: [
                function (t, e, n) {
                    "use strict";
                    var i = (function () {
                        return (
                            window.requestAnimationFrame ||
                            window.webkitRequestAnimationFrame ||
                            function (t) {
                                window.setTimeout(t, 1e3 / 60);
                            }
                        );
                    })();
                    function o(t, e, n) {
                        var o,
                            s = false;
                        function r(t) {
                            o = t;
                            a();
                        }
                        function a() {
                            if (!s) {
                                i(u);
                                s = true;
                            }
                        }
                        function u() {
                            n.call(t, o);
                            s = false;
                        }
                        t.addEventListener(e, r, false);
                        return r;
                    }
                    e.exports = o;
                },
                {},
            ],
            3: [
                function (t, e, n) {
                    "use strict";
                    var i = function (t, e) {
                        if (!(t instanceof e)) {
                            throw new TypeError("Cannot call a class as a function");
                        }
                    };
                    n.__esModule = true;
                    var o = (function () {
                        function t() {
                            i(this, t);
                        }
                        t.prototype.on = function e(t, n) {
                            this._eventCollection = this._eventCollection || {};
                            this._eventCollection[t] = this._eventCollection[t] || [];
                            this._eventCollection[t].push(n);
                            return this;
                        };
                        t.prototype.once = function n(t, e) {
                            var n = this;
                            function i() {
                                n.off(t, i);
                                e.apply(this, arguments);
                            }
                            i.listener = e;
                            this.on(t, i);
                            return this;
                        };
                        t.prototype.off = function o(t, e) {
                            var n = undefined;
                            if (!this._eventCollection || !(n = this._eventCollection[t])) {
                                return this;
                            }
                            n.forEach(function (t, i) {
                                if (t === e || t.listener === e) {
                                    n.splice(i, 1);
                                }
                            });
                            if (n.length === 0) {
                                delete this._eventCollection[t];
                            }
                            return this;
                        };
                        t.prototype.emit = function s(t) {
                            var e = this;
                            for (var n = arguments.length, i = Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) {
                                i[o - 1] = arguments[o];
                            }
                            var s = undefined;
                            if (!this._eventCollection || !(s = this._eventCollection[t])) {
                                return this;
                            }
                            s = s.slice(0);
                            s.forEach(function (t) {
                                return t.apply(e, i);
                            });
                            return this;
                        };
                        return t;
                    })();
                    n["default"] = o;
                    e.exports = n["default"];
                },
                {},
            ],
        },
        {},
        [1]
    )(1);
});

/*
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie = function (b, j, m) {
    if (typeof j != "undefined") {
        m = m || {};
        if (j === null) {
            j = "";
            m.expires = -1;
        }
        var e = "";
        if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) {
            var f;
            if (typeof m.expires == "number") {
                f = new Date();
                f.setTime(f.getTime() + m.expires * 24 * 60 * 60 * 1000);
            } else {
                f = m.expires;
            }
            e = "; expires=" + f.toUTCString();
        }
        var l = m.path ? "; path=" + m.path : "";
        var g = m.domain ? "; domain=" + m.domain : "";
        var a = m.secure ? "; secure" : "";
        document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("");
    } else {
        var d = null;
        if (document.cookie && document.cookie != "") {
            var k = document.cookie.split(";");
            for (var h = 0; h < k.length; h++) {
                var c = jQuery.trim(k[h]);
                if (c.substring(0, b.length + 1) == b + "=") {
                    d = decodeURIComponent(c.substring(b.length + 1));
                    break;
                }
            }
        }
        return d;
    }
};

/*
 * Currency tools
 *
 * Copyright (c) 2015 Caroline Schnapp (mllegeorgesand@gmail.com)
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */

if (typeof Currency === "undefined") {
    var Currency = {};
}
Currency.cookie = {
    configuration: { expires: 365, path: "/", domain: window.location.hostname },
    name: "currency",
    write: function (a) {
        jQuery.cookie(this.name, a, this.configuration);
    },
    read: function () {
        return jQuery.cookie(this.name);
    },
    destroy: function () {
        jQuery.cookie(this.name, null, this.configuration);
    },
};
Currency.moneyFormats = {
    USD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} USD" },
    EUR: { money_format: "&euro;{{amount}}", money_with_currency_format: "&euro;{{amount}} EUR" },
    GBP: { money_format: "&pound;{{amount}}", money_with_currency_format: "&pound;{{amount}} GBP" },
    CAD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} CAD" },
    ALL: { money_format: "Lek {{amount}}", money_with_currency_format: "Lek {{amount}} ALL" },
    DZD: { money_format: "DA {{amount}}", money_with_currency_format: "DA {{amount}} DZD" },
    AOA: { money_format: "Kz{{amount}}", money_with_currency_format: "Kz{{amount}} AOA" },
    ARS: { money_format: "${{amount_with_comma_separator}}", money_with_currency_format: "${{amount_with_comma_separator}} ARS" },
    AMD: { money_format: "{{amount}} AMD", money_with_currency_format: "{{amount}} AMD" },
    AWG: { money_format: "Afl{{amount}}", money_with_currency_format: "Afl{{amount}} AWG" },
    AUD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} AUD" },
    BBD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} Bds" },
    AZN: { money_format: "m.{{amount}}", money_with_currency_format: "m.{{amount}} AZN" },
    BDT: { money_format: "Tk {{amount}}", money_with_currency_format: "Tk {{amount}} BDT" },
    BSD: { money_format: "BS${{amount}}", money_with_currency_format: "BS${{amount}} BSD" },
    BHD: { money_format: "{{amount}}0 BD", money_with_currency_format: "{{amount}}0 BHD" },
    BYR: { money_format: "Br {{amount}}", money_with_currency_format: "Br {{amount}} BYR" },
    BZD: { money_format: "BZ${{amount}}", money_with_currency_format: "BZ${{amount}} BZD" },
    BTN: { money_format: "Nu {{amount}}", money_with_currency_format: "Nu {{amount}} BTN" },
    BAM: { money_format: "KM {{amount_with_comma_separator}}", money_with_currency_format: "KM {{amount_with_comma_separator}} BAM" },
    BRL: { money_format: "R$ {{amount_with_comma_separator}}", money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL" },
    BOB: { money_format: "Bs{{amount_with_comma_separator}}", money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB" },
    BWP: { money_format: "P{{amount}}", money_with_currency_format: "P{{amount}} BWP" },
    BND: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} BND" },
    BGN: { money_format: "{{amount}} лв", money_with_currency_format: "{{amount}} лв BGN" },
    MMK: { money_format: "K{{amount}}", money_with_currency_format: "K{{amount}} MMK" },
    KHR: { money_format: "KHR{{amount}}", money_with_currency_format: "KHR{{amount}}" },
    KYD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} KYD" },
    XAF: { money_format: "FCFA{{amount}}", money_with_currency_format: "FCFA{{amount}} XAF" },
    CLP: { money_format: "${{amount_no_decimals}}", money_with_currency_format: "${{amount_no_decimals}} CLP" },
    CNY: { money_format: "&#165;{{amount}}", money_with_currency_format: "&#165;{{amount}} CNY" },
    COP: { money_format: "${{amount_with_comma_separator}}", money_with_currency_format: "${{amount_with_comma_separator}} COP" },
    CRC: { money_format: "&#8353; {{amount_with_comma_separator}}", money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC" },
    HRK: { money_format: "{{amount_with_comma_separator}} kn", money_with_currency_format: "{{amount_with_comma_separator}} kn HRK" },
    CZK: { money_format: "{{amount_with_comma_separator}} K&#269;", money_with_currency_format: "{{amount_with_comma_separator}} K&#269;" },
    DKK: { money_format: "{{amount_with_comma_separator}}", money_with_currency_format: "kr.{{amount_with_comma_separator}}" },
    DOP: { money_format: "RD$ {{amount}}", money_with_currency_format: "RD$ {{amount}}" },
    XCD: { money_format: "${{amount}}", money_with_currency_format: "EC${{amount}}" },
    EGP: { money_format: "LE {{amount}}", money_with_currency_format: "LE {{amount}} EGP" },
    ETB: { money_format: "Br{{amount}}", money_with_currency_format: "Br{{amount}} ETB" },
    XPF: { money_format: "{{amount_no_decimals_with_comma_separator}} XPF", money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} XPF" },
    FJD: { money_format: "${{amount}}", money_with_currency_format: "FJ${{amount}}" },
    GMD: { money_format: "D {{amount}}", money_with_currency_format: "D {{amount}} GMD" },
    GHS: { money_format: "GH&#8373;{{amount}}", money_with_currency_format: "GH&#8373;{{amount}}" },
    GTQ: { money_format: "Q{{amount}}", money_with_currency_format: "{{amount}} GTQ" },
    GYD: { money_format: "G${{amount}}", money_with_currency_format: "${{amount}} GYD" },
    GEL: { money_format: "{{amount}} GEL", money_with_currency_format: "{{amount}} GEL" },
    HNL: { money_format: "L {{amount}}", money_with_currency_format: "L {{amount}} HNL" },
    HKD: { money_format: "${{amount}}", money_with_currency_format: "HK${{amount}}" },
    HUF: { money_format: "{{amount_no_decimals_with_comma_separator}}", money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} Ft" },
    ISK: { money_format: "{{amount_no_decimals}} kr", money_with_currency_format: "{{amount_no_decimals}} kr ISK" },
    INR: { money_format: "Rs. {{amount}}", money_with_currency_format: "Rs. {{amount}}" },
    IDR: { money_format: "{{amount_with_comma_separator}}", money_with_currency_format: "Rp {{amount_with_comma_separator}}" },
    ILS: { money_format: "{{amount}} NIS", money_with_currency_format: "{{amount}} NIS" },
    JMD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} JMD" },
    JPY: { money_format: "&#165;{{amount_no_decimals}}", money_with_currency_format: "&#165;{{amount_no_decimals}} JPY" },
    JEP: { money_format: "&pound;{{amount}}", money_with_currency_format: "&pound;{{amount}} JEP" },
    JOD: { money_format: "{{amount}}0 JD", money_with_currency_format: "{{amount}}0 JOD" },
    KZT: { money_format: "{{amount}} KZT", money_with_currency_format: "{{amount}} KZT" },
    KES: { money_format: "KSh{{amount}}", money_with_currency_format: "KSh{{amount}}" },
    KWD: { money_format: "{{amount}}0 KD", money_with_currency_format: "{{amount}}0 KWD" },
    KGS: { money_format: "лв{{amount}}", money_with_currency_format: "лв{{amount}}" },
    LVL: { money_format: "Ls {{amount}}", money_with_currency_format: "Ls {{amount}} LVL" },
    LBP: { money_format: "L&pound;{{amount}}", money_with_currency_format: "L&pound;{{amount}} LBP" },
    LTL: { money_format: "{{amount}} Lt", money_with_currency_format: "{{amount}} Lt" },
    MGA: { money_format: "Ar {{amount}}", money_with_currency_format: "Ar {{amount}} MGA" },
    MKD: { money_format: "ден {{amount}}", money_with_currency_format: "ден {{amount}} MKD" },
    MOP: { money_format: "MOP${{amount}}", money_with_currency_format: "MOP${{amount}}" },
    MVR: { money_format: "Rf{{amount}}", money_with_currency_format: "Rf{{amount}} MRf" },
    MXN: { money_format: "$ {{amount}}", money_with_currency_format: "$ {{amount}} MXN" },
    MYR: { money_format: "RM{{amount}} MYR", money_with_currency_format: "RM{{amount}} MYR" },
    MUR: { money_format: "Rs {{amount}}", money_with_currency_format: "Rs {{amount}} MUR" },
    MDL: { money_format: "{{amount}} MDL", money_with_currency_format: "{{amount}} MDL" },
    MAD: { money_format: "{{amount}} dh", money_with_currency_format: "Dh {{amount}} MAD" },
    MNT: { money_format: "{{amount_no_decimals}} &#8366", money_with_currency_format: "{{amount_no_decimals}} MNT" },
    MZN: { money_format: "{{amount}} Mt", money_with_currency_format: "Mt {{amount}} MZN" },
    NAD: { money_format: "N${{amount}}", money_with_currency_format: "N${{amount}} NAD" },
    NPR: { money_format: "Rs{{amount}}", money_with_currency_format: "Rs{{amount}} NPR" },
    ANG: { money_format: "&fnof;{{amount}}", money_with_currency_format: "{{amount}} NA&fnof;" },
    NZD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} NZD" },
    NIO: { money_format: "C${{amount}}", money_with_currency_format: "C${{amount}} NIO" },
    NGN: { money_format: "&#8358;{{amount}}", money_with_currency_format: "&#8358;{{amount}} NGN" },
    NOK: { money_format: "kr {{amount_with_comma_separator}}", money_with_currency_format: "kr {{amount_with_comma_separator}} NOK" },
    OMR: { money_format: "{{amount_with_comma_separator}} OMR", money_with_currency_format: "{{amount_with_comma_separator}} OMR" },
    PKR: { money_format: "Rs.{{amount}}", money_with_currency_format: "Rs.{{amount}} PKR" },
    PGK: { money_format: "K {{amount}}", money_with_currency_format: "K {{amount}} PGK" },
    PYG: { money_format: "Gs. {{amount_no_decimals_with_comma_separator}}", money_with_currency_format: "Gs. {{amount_no_decimals_with_comma_separator}} PYG" },
    PEN: { money_format: "S/. {{amount}}", money_with_currency_format: "S/. {{amount}} PEN" },
    PHP: { money_format: "&#8369;{{amount}}", money_with_currency_format: "&#8369;{{amount}} PHP" },
    PLN: { money_format: "{{amount_with_comma_separator}} zl", money_with_currency_format: "{{amount_with_comma_separator}} zl PLN" },
    QAR: { money_format: "QAR {{amount_with_comma_separator}}", money_with_currency_format: "QAR {{amount_with_comma_separator}}" },
    RON: { money_format: "{{amount_with_comma_separator}} lei", money_with_currency_format: "{{amount_with_comma_separator}} lei RON" },
    RUB: { money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}", money_with_currency_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB" },
    RWF: { money_format: "{{amount_no_decimals}} RF", money_with_currency_format: "{{amount_no_decimals}} RWF" },
    WST: { money_format: "WS$ {{amount}}", money_with_currency_format: "WS$ {{amount}} WST" },
    SAR: { money_format: "{{amount}} SR", money_with_currency_format: "{{amount}} SAR" },
    STD: { money_format: "Db {{amount}}", money_with_currency_format: "Db {{amount}} STD" },
    RSD: { money_format: "{{amount}} RSD", money_with_currency_format: "{{amount}} RSD" },
    SCR: { money_format: "Rs {{amount}}", money_with_currency_format: "Rs {{amount}} SCR" },
    SGD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} SGD" },
    SYP: { money_format: "S&pound;{{amount}}", money_with_currency_format: "S&pound;{{amount}} SYP" },
    ZAR: { money_format: "R {{amount}}", money_with_currency_format: "R {{amount}} ZAR" },
    KRW: { money_format: "&#8361;{{amount_no_decimals}}", money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW" },
    LKR: { money_format: "Rs {{amount}}", money_with_currency_format: "Rs {{amount}} LKR" },
    SEK: { money_format: "{{amount_no_decimals}} kr", money_with_currency_format: "{{amount_no_decimals}} kr SEK" },
    CHF: { money_format: "SFr. {{amount}}", money_with_currency_format: "SFr. {{amount}} CHF" },
    TWD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} TWD" },
    THB: { money_format: "{{amount}} &#xe3f;", money_with_currency_format: "{{amount}} &#xe3f; THB" },
    TZS: { money_format: "{{amount}} TZS", money_with_currency_format: "{{amount}} TZS" },
    TTD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} TTD" },
    TND: { money_format: "{{amount}}", money_with_currency_format: "{{amount}} DT" },
    TRY: { money_format: "{{amount}}TL", money_with_currency_format: "{{amount}}TL" },
    UGX: { money_format: "Ush {{amount_no_decimals}}", money_with_currency_format: "Ush {{amount_no_decimals}} UGX" },
    UAH: { money_format: "₴{{amount}}", money_with_currency_format: "₴{{amount}} UAH" },
    AED: { money_format: "Dhs. {{amount}}", money_with_currency_format: "Dhs. {{amount}} AED" },
    UYU: { money_format: "${{amount_with_comma_separator}}", money_with_currency_format: "${{amount_with_comma_separator}} UYU" },
    VUV: { money_format: "${{amount}}", money_with_currency_format: "${{amount}}VT" },
    VEF: { money_format: "Bs. {{amount_with_comma_separator}}", money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF" },
    VND: { money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;", money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} VND" },
    XBT: { money_format: "{{amount_no_decimals}} BTC", money_with_currency_format: "{{amount_no_decimals}} BTC" },
    XOF: { money_format: "CFA{{amount}}", money_with_currency_format: "CFA{{amount}} XOF" },
    ZMW: { money_format: "K{{amount_no_decimals_with_comma_separator}}", money_with_currency_format: "ZMW{{amount_no_decimals_with_comma_separator}}" },
};
Currency.formatMoney = function (b, g) {
    if (typeof Shopify.formatMoney === "function") {
        return Shopify.formatMoney(b, g);
    }
    if (typeof b == "string") {
        b = b.replace(".", "");
    }
    var f = "";
    var e = /\{\{\s*(\w+)\s*\}\}/;
    var a = g || "${{amount}}";
    function c(h, i) {
        return typeof h == "undefined" ? i : h;
    }
    function d(m, k, l, j) {
        k = c(k, 2);
        l = c(l, ",");
        j = c(j, ".");
        if (isNaN(m) || m == null) {
            return 0;
        }
        m = (m / 100).toFixed(k);
        var n = m.split("."),
            i = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + l),
            h = n[1] ? j + n[1] : "";
        return i + h;
    }
    switch (a.match(e)[1]) {
        case "amount":
            f = d(b, 2);
            break;
        case "amount_no_decimals":
            f = d(b, 0);
            break;
        case "amount_with_comma_separator":
            f = d(b, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            f = d(b, 0, ".", ",");
            break;
    }
    return a.replace(e, f);
};
Currency.currentCurrency = "";
Currency.format = "money_with_currency_format";
Currency.convertAll = function (c, b, a, d) {
    jQuery(a || "span.money").each(function () {
        if (jQuery(this).attr("data-currency") === b) {
            return;
        }
        if (jQuery(this).attr("data-currency-" + b)) {
            jQuery(this).html(jQuery(this).attr("data-currency-" + b));
        } else {
            var e = 0;
            var f = Currency.moneyFormats[c][d || Currency.format] || "{{amount}}";
            var g = Currency.moneyFormats[b][d || Currency.format] || "{{amount}}";
            if (f.indexOf("amount_no_decimals") !== -1) {
                e = Currency.convert(
                    parseInt(
                        jQuery(this)
                            .html()
                            .replace(/[^0-9]/g, ""),
                        10
                    ) * 100,
                    c,
                    b
                );
            } else {
                if (c === "JOD" || c == "KWD" || c == "BHD") {
                    e = Currency.convert(
                        parseInt(
                            jQuery(this)
                                .html()
                                .replace(/[^0-9]/g, ""),
                            10
                        ) / 10,
                        c,
                        b
                    );
                } else {
                    e = Currency.convert(
                        parseInt(
                            jQuery(this)
                                .html()
                                .replace(/[^0-9]/g, ""),
                            10
                        ),
                        c,
                        b
                    );
                }
            }
            var h = Currency.formatMoney(e, g);
            jQuery(this).html(h);
            jQuery(this).attr("data-currency-" + b, h);
        }
        jQuery(this).attr("data-currency", b);
    });
    this.currentCurrency = b;
    this.cookie.write(b);
};

/*! WOW - v1.1.2 - 2015-08-19
 * Copyright (c) 2015 Matthieu Aussaguel; Licensed MIT */ (function () {
    var a,
        b,
        c,
        d,
        e,
        f = function (a, b) {
            return function () {
                return a.apply(b, arguments);
            };
        },
        g =
            [].indexOf ||
            function (a) {
                for (var b = 0, c = this.length; c > b; b++) if (b in this && this[b] === a) return b;
                return -1;
            };
    (b = (function () {
        function a() {}
        return (
            (a.prototype.extend = function (a, b) {
                var c, d;
                for (c in b) (d = b[c]), null == a[c] && (a[c] = d);
                return a;
            }),
            (a.prototype.isMobile = function (a) {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(a);
            }),
            (a.prototype.createEvent = function (a, b, c, d) {
                var e;
                return (
                    null == b && (b = !1),
                    null == c && (c = !1),
                    null == d && (d = null),
                    null != document.createEvent
                        ? ((e = document.createEvent("CustomEvent")), e.initCustomEvent(a, b, c, d))
                        : null != document.createEventObject
                        ? ((e = document.createEventObject()), (e.eventType = a))
                        : (e.eventName = a),
                    e
                );
            }),
            (a.prototype.emitEvent = function (a, b) {
                return null != a.dispatchEvent ? a.dispatchEvent(b) : b in (null != a) ? a[b]() : "on" + b in (null != a) ? a["on" + b]() : void 0;
            }),
            (a.prototype.addEvent = function (a, b, c) {
                return null != a.addEventListener ? a.addEventListener(b, c, !1) : null != a.attachEvent ? a.attachEvent("on" + b, c) : (a[b] = c);
            }),
            (a.prototype.removeEvent = function (a, b, c) {
                return null != a.removeEventListener ? a.removeEventListener(b, c, !1) : null != a.detachEvent ? a.detachEvent("on" + b, c) : delete a[b];
            }),
            (a.prototype.innerHeight = function () {
                return "innerHeight" in window ? window.innerHeight : document.documentElement.clientHeight;
            }),
            a
        );
    })()),
        (c =
            this.WeakMap ||
            this.MozWeakMap ||
            (c = (function () {
                function a() {
                    (this.keys = []), (this.values = []);
                }
                return (
                    (a.prototype.get = function (a) {
                        var b, c, d, e, f;
                        for (f = this.keys, b = d = 0, e = f.length; e > d; b = ++d) if (((c = f[b]), c === a)) return this.values[b];
                    }),
                    (a.prototype.set = function (a, b) {
                        var c, d, e, f, g;
                        for (g = this.keys, c = e = 0, f = g.length; f > e; c = ++e) if (((d = g[c]), d === a)) return void (this.values[c] = b);
                        return this.keys.push(a), this.values.push(b);
                    }),
                    a
                );
            })())),
        (a =
            this.MutationObserver ||
            this.WebkitMutationObserver ||
            this.MozMutationObserver ||
            (a = (function () {
                function a() {
                    "undefined" != typeof console && null !== console && console.warn("MutationObserver is not supported by your browser."),
                        "undefined" != typeof console && null !== console && console.warn("WOW.js cannot detect dom mutations, please call .sync() after loading new content.");
                }
                return (a.notSupported = !0), (a.prototype.observe = function () {}), a;
            })())),
        (d =
            this.getComputedStyle ||
            function (a) {
                return (
                    (this.getPropertyValue = function (b) {
                        var c;
                        return (
                            "float" === b && (b = "styleFloat"),
                            e.test(b) &&
                                b.replace(e, function (a, b) {
                                    return b.toUpperCase();
                                }),
                            (null != (c = a.currentStyle) ? c[b] : void 0) || null
                        );
                    }),
                    this
                );
            }),
        (e = /(\-([a-z]){1})/g),
        (this.WOW = (function () {
            function e(a) {
                null == a && (a = {}),
                    (this.scrollCallback = f(this.scrollCallback, this)),
                    (this.scrollHandler = f(this.scrollHandler, this)),
                    (this.resetAnimation = f(this.resetAnimation, this)),
                    (this.start = f(this.start, this)),
                    (this.scrolled = !0),
                    (this.config = this.util().extend(a, this.defaults)),
                    null != a.scrollContainer && (this.config.scrollContainer = document.querySelector(a.scrollContainer)),
                    (this.animationNameCache = new c()),
                    (this.wowEvent = this.util().createEvent(this.config.boxClass));
            }
            return (
                (e.prototype.defaults = { boxClass: "wow", animateClass: "animated", offset: 0, mobile: !0, live: !0, callback: null, scrollContainer: null }),
                (e.prototype.init = function () {
                    var a;
                    return (
                        (this.element = window.document.documentElement), "interactive" === (a = document.readyState) || "complete" === a ? this.start() : this.util().addEvent(document, "DOMContentLoaded", this.start), (this.finished = [])
                    );
                }),
                (e.prototype.start = function () {
                    var b, c, d, e;
                    if (
                        ((this.stopped = !1),
                        (this.boxes = function () {
                            var a, c, d, e;
                            for (d = this.element.querySelectorAll("." + this.config.boxClass), e = [], a = 0, c = d.length; c > a; a++) (b = d[a]), e.push(b);
                            return e;
                        }.call(this)),
                        (this.all = function () {
                            var a, c, d, e;
                            for (d = this.boxes, e = [], a = 0, c = d.length; c > a; a++) (b = d[a]), e.push(b);
                            return e;
                        }.call(this)),
                        this.boxes.length)
                    )
                        if (this.disabled()) this.resetStyle();
                        else for (e = this.boxes, c = 0, d = e.length; d > c; c++) (b = e[c]), this.applyStyle(b, !0);
                    return (
                        this.disabled() ||
                            (this.util().addEvent(this.config.scrollContainer || window, "scroll", this.scrollHandler), this.util().addEvent(window, "resize", this.scrollHandler), (this.interval = setInterval(this.scrollCallback, 50))),
                        this.config.live
                            ? new a(
                                  (function (a) {
                                      return function (b) {
                                          var c, d, e, f, g;
                                          for (g = [], c = 0, d = b.length; d > c; c++)
                                              (f = b[c]),
                                                  g.push(
                                                      function () {
                                                          var a, b, c, d;
                                                          for (c = f.addedNodes || [], d = [], a = 0, b = c.length; b > a; a++) (e = c[a]), d.push(this.doSync(e));
                                                          return d;
                                                      }.call(a)
                                                  );
                                          return g;
                                      };
                                  })(this)
                              ).observe(document.body, { childList: !0, subtree: !0 })
                            : void 0
                    );
                }),
                (e.prototype.stop = function () {
                    return (
                        (this.stopped = !0),
                        this.util().removeEvent(this.config.scrollContainer || window, "scroll", this.scrollHandler),
                        this.util().removeEvent(window, "resize", this.scrollHandler),
                        null != this.interval ? clearInterval(this.interval) : void 0
                    );
                }),
                (e.prototype.sync = function () {
                    return a.notSupported ? this.doSync(this.element) : void 0;
                }),
                (e.prototype.doSync = function (a) {
                    var b, c, d, e, f;
                    if ((null == a && (a = this.element), 1 === a.nodeType)) {
                        for (a = a.parentNode || a, e = a.querySelectorAll("." + this.config.boxClass), f = [], c = 0, d = e.length; d > c; c++)
                            (b = e[c]), g.call(this.all, b) < 0 ? (this.boxes.push(b), this.all.push(b), this.stopped || this.disabled() ? this.resetStyle() : this.applyStyle(b, !0), f.push((this.scrolled = !0))) : f.push(void 0);
                        return f;
                    }
                }),
                (e.prototype.show = function (a) {
                    return (
                        this.applyStyle(a),
                        (a.className = a.className + " " + this.config.animateClass),
                        null != this.config.callback && this.config.callback(a),
                        this.util().emitEvent(a, this.wowEvent),
                        this.util().addEvent(a, "animationend", this.resetAnimation),
                        this.util().addEvent(a, "oanimationend", this.resetAnimation),
                        this.util().addEvent(a, "webkitAnimationEnd", this.resetAnimation),
                        this.util().addEvent(a, "MSAnimationEnd", this.resetAnimation),
                        a
                    );
                }),
                (e.prototype.applyStyle = function (a, b) {
                    var c, d, e;
                    return (
                        (d = a.getAttribute("data-wow-duration")),
                        (c = a.getAttribute("data-wow-delay")),
                        (e = a.getAttribute("data-wow-iteration")),
                        this.animate(
                            (function (f) {
                                return function () {
                                    return f.customStyle(a, b, d, c, e);
                                };
                            })(this)
                        )
                    );
                }),
                (e.prototype.animate = (function () {
                    return "requestAnimationFrame" in window
                        ? function (a) {
                              return window.requestAnimationFrame(a);
                          }
                        : function (a) {
                              return a();
                          };
                })()),
                (e.prototype.resetStyle = function () {
                    var a, b, c, d, e;
                    for (d = this.boxes, e = [], b = 0, c = d.length; c > b; b++) (a = d[b]), e.push((a.style.visibility = "visible"));
                    return e;
                }),
                (e.prototype.resetAnimation = function (a) {
                    var b;
                    return a.type.toLowerCase().indexOf("animationend") >= 0 ? ((b = a.target || a.srcElement), (b.className = b.className.replace(this.config.animateClass, "").trim())) : void 0;
                }),
                (e.prototype.customStyle = function (a, b, c, d, e) {
                    return (
                        b && this.cacheAnimationName(a),
                        (a.style.visibility = b ? "hidden" : "visible"),
                        c && this.vendorSet(a.style, { animationDuration: c }),
                        d && this.vendorSet(a.style, { animationDelay: d }),
                        e && this.vendorSet(a.style, { animationIterationCount: e }),
                        this.vendorSet(a.style, { animationName: b ? "none" : this.cachedAnimationName(a) }),
                        a
                    );
                }),
                (e.prototype.vendors = ["moz", "webkit"]),
                (e.prototype.vendorSet = function (a, b) {
                    var c, d, e, f;
                    d = [];
                    for (c in b)
                        (e = b[c]),
                            (a["" + c] = e),
                            d.push(
                                function () {
                                    var b, d, g, h;
                                    for (g = this.vendors, h = [], b = 0, d = g.length; d > b; b++) (f = g[b]), h.push((a["" + f + c.charAt(0).toUpperCase() + c.substr(1)] = e));
                                    return h;
                                }.call(this)
                            );
                    return d;
                }),
                (e.prototype.vendorCSS = function (a, b) {
                    var c, e, f, g, h, i;
                    for (h = d(a), g = h.getPropertyCSSValue(b), f = this.vendors, c = 0, e = f.length; e > c; c++) (i = f[c]), (g = g || h.getPropertyCSSValue("-" + i + "-" + b));
                    return g;
                }),
                (e.prototype.animationName = function (a) {
                    var b;
                    try {
                        b = this.vendorCSS(a, "animation-name").cssText;
                    } catch (c) {
                        b = d(a).getPropertyValue("animation-name");
                    }
                    return "none" === b ? "" : b;
                }),
                (e.prototype.cacheAnimationName = function (a) {
                    return this.animationNameCache.set(a, this.animationName(a));
                }),
                (e.prototype.cachedAnimationName = function (a) {
                    return this.animationNameCache.get(a);
                }),
                (e.prototype.scrollHandler = function () {
                    return (this.scrolled = !0);
                }),
                (e.prototype.scrollCallback = function () {
                    var a;
                    return !this.scrolled ||
                        ((this.scrolled = !1),
                        (this.boxes = function () {
                            var b, c, d, e;
                            for (d = this.boxes, e = [], b = 0, c = d.length; c > b; b++) (a = d[b]), a && (this.isVisible(a) ? this.show(a) : e.push(a));
                            return e;
                        }.call(this)),
                        this.boxes.length || this.config.live)
                        ? void 0
                        : this.stop();
                }),
                (e.prototype.offsetTop = function (a) {
                    for (var b; void 0 === a.offsetTop; ) a = a.parentNode;
                    for (b = a.offsetTop; (a = a.offsetParent); ) b += a.offsetTop;
                    return b;
                }),
                (e.prototype.isVisible = function (a) {
                    var b, c, d, e, f;
                    return (
                        (c = a.getAttribute("data-wow-offset") || this.config.offset),
                        (f = (this.config.scrollContainer && this.config.scrollContainer.scrollTop) || window.pageYOffset),
                        (e = f + Math.min(this.element.clientHeight, this.util().innerHeight()) - c),
                        (d = this.offsetTop(a)),
                        (b = d + a.clientHeight),
                        e >= d && b >= f
                    );
                }),
                (e.prototype.util = function () {
                    return null != this._util ? this._util : (this._util = new b());
                }),
                (e.prototype.disabled = function () {
                    return !this.config.mobile && this.util().isMobile(navigator.userAgent);
                }),
                e
            );
        })());
}.call(this));

/**
 * @preserve
 * Project: Bootstrap Hover Dropdown
 * Author: Cameron Spear
 * Version: v2.2.1
 * Contributors: Mattia Larentis
 * Dependencies: Bootstrap's Dropdown plugin, jQuery
 * Description: A simple plugin to enable Bootstrap dropdowns to active on hover and provide a nice user experience.
 * License: MIT
 * Homepage: http://cameronspear.com/blog/bootstrap-dropdown-on-hover-plugin/
 */
!(function (e, n) {
    var o = e();
    (e.fn.dropdownHover = function (t) {
        return "ontouchstart" in document
            ? this
            : ((o = o.add(this.parent())),
              this.each(function () {
                  function r() {
                      d.parents(".navbar").find(".navbar-toggle").is(":visible") ||
                          (n.clearTimeout(a),
                          n.clearTimeout(i),
                          (i = n.setTimeout(function () {
                              o.find(":focus").blur(), v.instantlyCloseOthers === !0 && o.removeClass("open"), n.clearTimeout(i), d.attr("aria-expanded", "true"), s.addClass("open"), d.trigger(h);
                          }, v.hoverDelay)));
                  }
                  var a,
                      i,
                      d = e(this),
                      s = d.parent(),
                      u = { delay: 500, hoverDelay: 0, instantlyCloseOthers: !0 },
                      l = { delay: e(this).data("delay"), hoverDelay: e(this).data("hover-delay"), instantlyCloseOthers: e(this).data("close-others") },
                      h = "show.bs.dropdown",
                      c = "hide.bs.dropdown",
                      v = e.extend(!0, {}, u, t, l);
                  s.hover(
                      function (e) {
                          return s.hasClass("open") || d.is(e.target) ? void r(e) : !0;
                      },
                      function () {
                          n.clearTimeout(i),
                              (a = n.setTimeout(function () {
                                  d.attr("aria-expanded", "false"), s.removeClass("open"), d.trigger(c);
                              }, v.delay));
                      }
                  ),
                      d.hover(function (e) {
                          return s.hasClass("open") || s.is(e.target) ? void r(e) : !0;
                      }),
                      s.find(".dropdown-submenu").each(function () {
                          var o,
                              t = e(this);
                          t.hover(
                              function () {
                                  n.clearTimeout(o), t.children(".dropdown-menu").show(), t.siblings().children(".dropdown-menu").hide();
                              },
                              function () {
                                  var e = t.children(".dropdown-menu");
                                  o = n.setTimeout(function () {
                                      e.hide();
                                  }, v.delay);
                              }
                          );
                      });
              }));
    }),
        e(document).ready(function () {
            e('[data-hover="dropdown"]').dropdownHover();
        });
})(jQuery, window);
